export const enStrings = {
  "documents.picker.appLanguage": "App language",
  "documents.picker.selectionMissing": "This layout is no longer available. Choose your business default to continue.",
  "documents.picker.useDefault": "Use business default",
  // Guided document template editor
  "documents.editor.setup": "Setup",
  "documents.editor.design": "Design",
  "documents.editor.review": "Review",
  "documents.editor.createTitle": "Create a document template",
  "documents.editor.noBusiness": "Select a business before editing templates.",
  "documents.editor.starterError": "The starting layout could not be loaded. Retry to continue.",
  "documents.editor.suggestedName": "Standard {{type}}",
  "documents.editor.copyName": "{{name}} — copy",
  "documents.editor.saveTemplate": "Save template",
  "documents.editor.saveError": "The template could not be saved. Try again.",
  "documents.editor.previewError": "The preview could not be loaded. Try again.",
  "documents.editor.invalidColors": "Use a valid hex color, such as #1a56db, for both brand colors.",
  "documents.editor.emptyLayout": "Add a document layout before saving.",
  "documents.editor.readOnly": "You can preview this template. Editing requires permission to manage orders.",
  "documents.editor.typeFixed": "This template is only for this document type. Choose another type from Document templates.",
  "documents.editor.defaultTitle": "Use automatically",
  "documents.editor.defaultHint": "Use this template whenever a {{type}} is created without choosing another layout. Other document types are unchanged.",
  "documents.editor.branding": "Your branding",
  "documents.editor.brandingHint": "Choose a color palette. The layout uses your business details and logo.",
  "documents.editor.palette": "Color palette {{number}}",
  "documents.editor.businessLogo": "Use the business logo",
  "documents.editor.advancedBranding": "Custom logo and colors",
  "documents.editor.mode.standard": "Standard layout",
  "documents.editor.mode.canvas": "Canvas (advanced)",
  "documents.editor.mode.code": "HTML (advanced)",
  "documents.editor.standardTitle": "A complete {{type}} layout, ready to use",
  "documents.editor.standardHint": "Customer details, items and totals fill automatically when you create a real document. You can use this layout as it is.",
  "documents.editor.standardIncludesIdentity": "Business identity and document details",
  "documents.editor.standardIncludesItems": "The right customer or vendor and line items",
  "documents.editor.standardIncludesTotals": "Totals, payment or delivery details as appropriate",
  "documents.editor.typeParty.quotation": "Customer details and a valid-until date",
  "documents.editor.typeParty.proforma_invoice": "Customer and delivery details",
  "documents.editor.typeParty.order_confirmation": "Customer and delivery details",
  "documents.editor.typeParty.invoice": "Customer, buyer VAT number and delivery details",
  "documents.editor.typeParty.receipt": "Customer and the amount received",
  "documents.editor.typeParty.delivery_note": "Customer and delivery address",
  "documents.editor.typeParty.packing_slip": "Vendor and delivery address",
  "documents.editor.typeParty.purchase_order": "Vendor and the address to deliver to",
  "documents.editor.typeItems.quotation": "Priced items, totals and notes",
  "documents.editor.typeItems.proforma_invoice": "Priced items, VAT, totals and payment status",
  "documents.editor.typeItems.order_confirmation": "Priced items, totals and payment status",
  "documents.editor.typeItems.invoice": "Priced items, VAT, totals, payment status and the e-invoice QR code in Saudi Arabia",
  "documents.editor.typeItems.receipt": "Items, totals and the payment received",
  "documents.editor.typeItems.delivery_note": "Items and quantities without prices, with a receipt signature",
  "documents.editor.typeItems.packing_slip": "Items and quantities without prices, with a packing checklist and signatures",
  "documents.editor.typeItems.purchase_order": "Ordered items at cost prices, totals and an authorization signature",
  "documents.messageTemplate.sendTitle": "Send on WhatsApp",
  "documents.messageTemplate.sendHint": "Pick an approved message template. Its values are filled from this document.",
  "documents.messageTemplate.sendChooseHint": "Choose the message template to send this document with.",
  "documents.send.failed": "The message could not be sent.",
  "documents.send.noTemplatesTitle": "No approved message templates yet",
  "documents.send.noTemplatesHint": "Sending a document on WhatsApp needs an approved message template. Create one, and once Meta approves it, it shows here.",
  "documents.send.createTemplate": "Create a message template",
  "documents.send.to": "Send to {{name}}",
  "documents.send.sent": "Queued for {{phone}}. It arrives in a few seconds.",
  "documents.send.sendNow": "Send now",
  "documents.send.fillValues": "Fill every value of the template to send.",
  "documents.forQuotation": "Quotation {{number}}",
  "documents.sendQuotation": "Documents & send",
  "search.open": "Search",
  "search.pill": "Search anything…",
  "search.placeholder": "Search pages, contacts, orders, products…",
  "search.clear": "Clear",
  "search.cancel": "Cancel",
  "search.close": "Close search",
  "search.copy": "Copy",
  "search.all": "All",
  "search.today": "Today",
  "search.yesterday": "Yesterday",
  "search.daysAgo": "{{count}} days ago",
  "search.recentlyOpened": "Recently opened",
  "search.recentSearches": "Recent searches",
  "search.emptyTitle": "Find anything in your business",
  "search.emptyHint": "Pages and settings, customers, orders, quotations, products, vendors, lists, templates and more — only what your access allows.",
  "search.tryTitle": "Narrow it down",
  "search.tryHint": "Type a phone number, an order or quotation number, a SKU or an email to jump straight to it.",
  "search.errorTitle": "Search didn't respond",
  "search.retry": "Try again",
  "search.noResults": "No results for “{{query}}”",
  "search.noResultsInGroup": "Nothing in {{group}}. Try searching everywhere.",
  "search.noResultsHint": "Check the spelling, try fewer words, or search by phone, number or SKU.",
  "search.searchEverywhere": "Search everywhere",
  "search.seeAll": "See all {{group}}",
  "search.assistant": "Assistant",
  "search.askAbout": "Ask the assistant about “{{query}}”",
  "search.askHint": "For questions like totals, comparisons or “which customers…”",
  "search.partial": "Some results couldn't load. Try again in a moment.",
  "search.keys.move": "move",
  "search.keys.open": "open",
  "search.keys.filter": "filter",
  "search.keys.edit": "edit",
  "search.took": "{{ms}} ms",
  "search.group.actions": "Quick actions",
  "search.group.pages": "Pages & settings",
  "search.group.contacts": "Contacts",
  "search.group.orders": "Orders",
  "search.group.quotations": "Quotations",
  "search.group.products": "Products",
  "search.group.vendors": "Vendors",
  "search.group.catalogues": "Catalogues",
  "search.group.data_lists": "Data lists",
  "search.group.templates": "Message templates",
  "search.group.documents": "Document templates",
  "search.group.flows": "Workflows",
  "search.group.events": "Calendar",
  "search.group.team": "Team",
  "search.group.departments": "Departments",
  "avatarMenu.option.lightMode": "Light mode",
  "avatarMenu.option.darkMode": "Dark mode",
  "search.askEmpty": "Ask the assistant",
  "documents.messageTemplate.title": "Message template",
  "documents.messageTemplate.hint": "Sent to the customer on WhatsApp when {{event}}.",
  "documents.messageTemplate.builtInHint": "No template chosen, so DISLIX sends its built-in message.",
  "documents.messageTemplate.status.active": "Active",
  "documents.messageTemplate.status.builtIn": "Built-in",
  "documents.messageTemplate.header.document": "File",
  "documents.messageTemplate.header.image": "Image",
  "documents.messageTemplate.header.video": "Video",
  "documents.messageTemplate.header.text": "Text",
  "documents.messageTemplate.progress": "{{done}} of {{total}} filled",
  "documents.messageTemplate.ready": "Nothing to fill. This template is ready to send.",
  "documents.messageTemplate.search": "Search templates",
  "documents.messageTemplate.noMatch": "No templates match your search.",
  "documents.messageTemplate.event.order_placed": "an order is placed",
  "documents.messageTemplate.event.order_confirmed": "an order is confirmed",
  "documents.messageTemplate.event.order_shipped": "an order is shipped",
  "documents.messageTemplate.event.order_delivered": "an order is delivered",
  "documents.messageTemplate.event.order_paid": "an order is paid or partly paid",
  "documents.messageTemplate.builtIn": "Built-in message",
  "documents.messageTemplate.choose": "Choose a message template",
  "documents.messageTemplate.change": "Change",
  "documents.messageTemplate.remove": "Use the built-in message",
  "documents.messageTemplate.createNew": "Create a new message template",
  "documents.messageTemplate.none": "No approved message templates yet. Create one and come back once it is approved.",
  "documents.messageTemplate.loadError": "Message templates could not be loaded.",
  "documents.messageTemplate.unavailable": "The chosen message template is no longer available. Choose another.",
  "documents.messageTemplate.notApproved": "This message template is not approved. Choose another.",
  "documents.messageTemplate.mapTitle": "Fill the template's values",
  "documents.messageTemplate.fileAttached": "This document's PDF is attached automatically as the template's file.",
  "documents.messageTemplate.ownMedia": "The template's own image or video is used.",
  "documents.messageTemplate.noValues": "This template has no values to fill.",
  "documents.messageTemplate.valueLabel": "Value {{position}} · {{section}}",
  "documents.messageTemplate.section.header": "Header",
  "documents.messageTemplate.section.body": "Body",
  "documents.messageTemplate.section.footer": "Footer",
  "documents.messageTemplate.section.button": "Button",
  "documents.messageTemplate.inputPlaceholder": "Type text, or add a document field",
  "documents.messageTemplate.insertField": "Add a document field",
  "documents.messageTemplate.pickField": "Choose a document field",
  "documents.messageTemplate.incomplete": "Fill every value of the message template, or use the built-in message.",
  "documents.editor.canvasHint": "Build a custom layout by adding, moving and editing blocks. Check the preview before saving.",
  "documents.editor.codeHint": "Advanced: edit the document HTML and placeholders. Existing custom layouts stay intact.",
  "documents.editor.reviewDefault": "This will be the automatic layout for {{type}} documents.",
  "documents.editor.reviewOptional": "This layout will be available to choose when creating a {{type}}.",
  "documents.editor.sampleData": "Preview uses sample details, not a real customer or order.",
  "documents.editor.previewReady": "Your document preview is ready. Open it to check the complete layout.",
  "documents.editor.openPreview": "Open full preview",
  "documents.editor.continueDesign": "Continue to design",
  "documents.editor.continueReview": "Review template",
  "documents.editor.unsavedTitle": "Leave without saving?",
  "documents.editor.unsavedHint": "Your changes will be lost. Save the template to keep them.",
  "documents.editor.replaceTitle": "Replace the current layout?",
  "documents.editor.replaceCanvasHint": "This starts a new canvas and replaces the current layout in this draft. Your saved template will only change when you save.",
  "documents.editor.replaceStandardHint": "This restores the complete standard layout in this draft. Your saved template will only change when you save.",
  "documents.editor.discard": "Discard changes",
  "documents.editor.replace": "Replace layout",
  // Document template setup and selection
  "documents.hub.intro": "Choose a document, preview its layout, then customize it for your business.",
  "documents.hub.chooseDocument": "Which document would you like to set up?",
  "documents.hub.customCount": "{{count}} custom templates",
  "documents.hub.currentDefault": "Current default",
  "documents.hub.defaultHelp": "Used automatically when a document is created without choosing another template.",
  "documents.hub.backToTypes": "All document types",
  "documents.hub.standardTitle": "Standard layout",
  "documents.hub.standardHint": "A complete layout using your business details. Ready to use without setup.",
  "documents.hub.customize": "Customize layout",
  "documents.hub.preview": "Preview",
  "documents.hub.edit": "Edit",
  "documents.hub.useDefault": "Use as default",
  "documents.hub.defaultBadge": "Default",
  "documents.hub.defaultSaved": "Default layout updated",
  "documents.hub.defaultSaveError": "Could not update the default layout. Please try again.",
  "documents.hub.copy": "Make a copy",
  "documents.hub.searchPlaceholder": "Search your templates",
  "documents.hub.noMatches": "No templates match your search",
  "documents.hub.clearSearch": "Clear search",
  "documents.hub.customTitle": "Your templates",
  "documents.hub.customEmpty": "Create your own version",
  "documents.hub.customEmptyHint": "Start with the standard layout, then adjust branding, language and content.",
  "documents.hub.loadError": "Templates could not be loaded. Retry to see your current defaults.",
  "documents.hub.retry": "Retry",
  "documents.hub.readOnly": "You can preview layouts. Editing requires permission to manage order templates.",
  "documents.hub.previewTitle": "Preview: {{name}}",
  "documents.hub.defaultLanguage": "Language: {{language}}",
  "documents.picker.change": "Change layout",
  "documents.picker.businessDefault": "Your business default for this document type.",
  "documents.picker.thisDocumentOnly": "Selected for this document only.",
  "documents.picker.templateLanguage": "Use template settings",
  "documents.picker.templateLanguageHint": "Uses the language saved in the template. Automatic language follows the document settings.",
  "documents.picker.languageOverrideHint": "This language choice applies to this document only.",
  "documents.picker.loadError": "Could not load your layouts. Retry before creating this document.",
  "documents.picker.invalidDate": "Enter a valid delivery date as YYYY-MM-DD.",
  // ─── Quotation list filters ───
  "quotations.filterSection.quotation": "Quotation",
  "quotations.filterSection.items": "Items",
  "quotations.filterSection.team": "Team & currency",
  "quotations.filters.converted": "Converted to an order",
  "quotations.filters.convertedYes": "Converted",
  "quotations.filters.convertedNo": "Not converted yet",
  "quotations.filters.products": "Contains product",
  "quotations.filters.vendors": "Vendor",
  "quotations.filters.vendorsHint": "Quotations with at least one of the vendor's products.",
  "quotations.sort.updated": "Recently updated",
  "quotations.view.drafts": "Drafts",
  "quotations.view.awaiting": "Awaiting reply",
  "quotations.view.toConvert": "Accepted, not converted",
  "quotations.view.expiringSoon": "Expiring in 7 days",
  "quotations.view.thisMonth": "This month",
  // ─── Business documents & templates ───
  "businessProfile.legal": "Legal & tax",
  "businessProfile.legalHint": "Printed on invoices and other documents. In Saudi Arabia the VAT number is also used for the e-invoice QR code.",
  "businessProfile.legalName": "Legal (registered) name",
  "businessProfile.vatNumber": "VAT / tax registration number",
  "businessProfile.crNumber": "Commercial registration (CR) number",
  "documents.title": "Documents",
  "documents.templatesTitle": "Document templates",
  "documents.allTypes": "All",
  "documents.chooseType": "Which document is this template for?",
  "documents.newTemplateAction": "New template",
  "documents.newTemplate": "New {{type}} template",
  "documents.noTemplates": "No templates yet",
  "documents.noTemplatesHint": "Documents use the built-in layout until you add a template.",
  "documents.typeLabel": "Document type",
  "documents.language": "Language",
  "documents.languageHint": "Auto uses the language of the person creating the document. Bilingual prints English and Arabic labels together.",
  "documents.lang.auto": "Auto",
  "documents.lang.en": "English",
  "documents.lang.ar": "العربية",
  "documents.lang.bilingual": "Bilingual (EN + AR)",
  "documents.startFromBuiltIn": "Start from the built-in layout",
  "documents.template": "Template",
  "documents.defaultTemplate": "Default: {{name}}",
  "documents.builtIn": "Built-in layout",
  "documents.create": "Create a document",
  "documents.createPdf": "Create PDF",
  "documents.forOrder": "Order {{number}}",
  "documents.hidePhone": "Hide the customer's phone",
  "documents.deliverBy": "Requested delivery date (optional)",
  "documents.noteToVendor": "Note to the vendor (optional)",
  "documents.failed": "The document could not be created",
  "documents.ready": "{{title}} {{number}} is ready.",
  "documents.open": "Open PDF",
  "documents.sendWhatsapp": "Send on WhatsApp {{name}}",
  "documents.sendEmail": "Send by email",
  "documents.another": "Create another document",
  "documents.shareText": "Hello {{name}}, here is your {{title}} {{number}}: {{url}}",
  "documents.receiptNeedsPayment": "Available once the order is paid or partly paid",
  "documents.type.quotation": "Quotation",
  "documents.type.proforma_invoice": "Proforma invoice",
  "documents.type.order_confirmation": "Order confirmation",
  "documents.type.invoice": "Tax invoice",
  "documents.type.receipt": "Payment receipt",
  "documents.type.delivery_note": "Delivery note",
  "documents.type.packing_slip": "Packing slip",
  "documents.type.purchase_order": "Purchase order",
  "documents.typeHint.quotation": "Price offer before the customer orders",
  "documents.typeHint.proforma_invoice": "Advance invoice before delivery or payment",
  "documents.typeHint.order_confirmation": "The order as agreed, with prices",
  "documents.typeHint.invoice": "VAT details and, in Saudi Arabia, the e-invoice QR code",
  "documents.typeHint.receipt": "Confirms the amount paid",
  "documents.typeHint.delivery_note": "What is delivered, without prices, with a receipt signature",
  "documents.typeHint.packing_slip": "What a vendor or the warehouse prepares",
  "documents.typeHint.purchase_order": "What you order from a vendor, at cost prices",
  // ─── List filters (orders, products, vendors, catalogues, data lists) ───
  "listFilters.filters": "Filters",
  "listFilters.filtersWithCount": "Filters ({{count}})",
  "listFilters.sortBy": "Sort by",
  "listFilters.reset": "Reset",
  "listFilters.apply": "Show results",
  "listFilters.applyWithCount": "Show results ({{count}} filters)",
  "listFilters.clear": "Clear",
  "listFilters.clearAll": "Clear all",
  "listFilters.clearSearch": "Clear search",
  "listFilters.min": "Min",
  "listFilters.max": "Max",
  "listFilters.anyDate": "Any date",
  "listFilters.moreFields": "More fields",
  "listFilters.hasValue": "Has a value",
  "listFilters.noValue": "No value",
  "listFilters.noValues": "No values yet",
  "listFilters.searchValues": "Search values…",
  "listFilters.searchToAdd": "Search to add…",
  "listFilters.removeFilter": "Remove filter: {{label}}",
  "listFilters.saveView": "Save view",
  "listFilters.saveViewTitle": "Save this view",
  "listFilters.saveViewHint": "Saves the current filters, sort and search as a tab above the list (on this device).",
  "listFilters.viewName": "View name, e.g. \"Unpaid this week\"",
  "listFilters.savedViews": "Saved views",
  "listFilters.manageViews": "Manage saved views",
  "listFilters.deleteView": "Delete view {{name}}",
  "listFilters.noSavedViews": "No saved views yet.",
  "orders.filter.title": "Filter orders",
  "orders.filter.orderStatus": "Order status",
  "orders.filter.paymentStatus": "Payment",
  "orders.filter.source": "Source",
  "orders.filter.orderDate": "Order date",
  "orders.filter.total": "Order total",
  "orders.filter.vendors": "Vendor",
  "orders.filter.vendorsHint": "Orders with at least one line from these vendors.",
  "orders.filter.products": "Contains product",
  "orders.filter.invoice": "Invoice",
  "orders.filter.invoiceYes": "Invoice created",
  "orders.filter.invoiceNo": "No invoice yet",
  "orders.filter.slip": "Packing slip",
  "orders.filter.slipYes": "Printed",
  "orders.filter.slipNo": "Not printed yet",
  "orders.filterSection.order": "Order",
  "orders.filterSection.items": "Items",
  "orders.filterSection.documents": "Documents",
  "orders.sort.newest": "Newest first",
  "orders.sort.oldest": "Oldest first",
  "orders.sort.totalDesc": "Highest total",
  "orders.sort.totalAsc": "Lowest total",
  "orders.sort.updated": "Recently updated",
  "orders.view.toFulfil": "To fulfil",
  "orders.view.unpaid": "Unpaid",
  "orders.view.today": "Today",
  "orders.view.thisWeek": "This week",
  "products.filter.title": "Filter products",
  "products.filter.search": "Search name, SKU or brand…",
  "products.filter.categories": "Category",
  "products.filter.vendors": "Vendor",
  "products.filter.withoutVendor": "Vendor link",
  "products.filter.withoutVendorYes": "Without a vendor",
  "products.filter.brand": "Brand",
  "products.filter.type": "Type",
  "products.filter.stock": "Stock",
  "products.filter.availability": "Availability",
  "products.filter.price": "Price",
  "products.filter.condition": "Condition",
  "products.filter.variants": "Variants",
  "products.filter.withVariants": "Has variants",
  "products.filter.noVariants": "No variants",
  "products.filter.photo": "Photo",
  "products.filter.withPhoto": "Has a photo",
  "products.filter.noPhoto": "No photo",
  "products.filter.added": "Date added",
  "products.filterSection.catalog": "Catalog",
  "products.filterSection.stock": "Stock",
  "products.filterSection.details": "Details",
  "products.stock.in": "In stock",
  "products.stock.low": "Low stock",
  "products.stock.out": "Out of stock",
  "products.availability.in_stock": "In stock",
  "products.availability.out_of_stock": "Out of stock",
  "products.availability.preorder": "Pre-order",
  "products.availability.backorder": "Backorder",
  "products.condition.new": "New",
  "products.condition.refurbished": "Refurbished",
  "products.condition.used": "Used",
  "products.type.physical": "Physical",
  "products.type.digital": "Digital",
  "products.type.service": "Service",
  "products.field.name": "Name",
  "products.field.sku": "SKU",
  "products.sort.newest": "Newest first",
  "products.sort.name": "Name (A–Z)",
  "products.sort.priceAsc": "Lowest price",
  "products.sort.priceDesc": "Highest price",
  "products.sort.stockAsc": "Lowest stock",
  "products.sort.updated": "Recently updated",
  "products.view.lowStock": "Low stock",
  "products.view.outOfStock": "Out of stock",
  "products.view.noVendor": "No vendor",
  "products.view.noPhoto": "No photo",
  "products.view.new": "Added in 30 days",
  "vendors.filterSection.sales": "Sales",
  "vendors.filterSection.vendor": "Vendor",
  "vendors.filters.hasProducts": "Has products",
  "vendors.view.hasOrders": "Has orders",
  "vendors.view.topRevenue": "Top revenue",
  "vendors.view.noProducts": "No products",
  "vendors.view.withMinimum": "With minimum order",
  "catalogues.filter.title": "Filter catalogues",
  "catalogues.filter.search": "Search catalogues…",
  "catalogues.filter.products": "Number of products",
  "catalogues.filter.added": "Date added",
  "catalogues.filter.kind": "Kind",
  "catalogues.field.name": "Name",
  "catalogues.field.currency": "Currency",
  "catalogues.field.locale": "Language",
  "catalogues.field.hasProducts": "Has products",
  "catalogues.sort.newest": "Newest first",
  "catalogues.sort.name": "Name (A–Z)",
  "catalogues.sort.products": "Most products",
  "catalogues.sort.updated": "Recently updated",
  "catalogues.view.empty": "Empty",
  "catalogues.view.new": "Added in 30 days",
  "dataLists.filter.title": "Filter data lists",
  "dataLists.filter.type": "List type",
  "dataLists.filter.module": "Module",
  "dataLists.filter.source": "Data source",
  "dataLists.filter.sourceManual": "Manual",
  "dataLists.filter.sourceWebhook": "Webhook (live)",
  "dataLists.filter.records": "Records",
  "dataLists.filter.hasRecords": "Has records",
  "dataLists.filter.noRecords": "Empty",
  "dataLists.filter.added": "Date added",
  "dataLists.view.custom": "Custom lists",
  "dataLists.view.system": "System lists",
  "dataLists.view.webhook": "Webhook",
  "dataLists.view.empty": "Empty",
  "dataLists.sort.newest": "Newest first",
  "dataLists.sort.oldest": "Oldest first",
  "dataLists.sort.name": "Name (A–Z)",
  "dataLists.sort.updated": "Recently updated",
  "dataLists.sort.columnAsc": "{{name}} ↑",
  "dataLists.sort.columnDesc": "{{name}} ↓",
  "dataLists.records.filterTitle": "Filter records",
  "dataLists.records.filterContains": "Contains…",
  "dataLists.schema.systemModule.vendors": "Vendors",
  "dataLists.schema.systemModule.quotations": "Quotations",
  // ─── Header action titles ───
  "common.download": "Download",
  "common.import": "Import",
  "common.share": "Share",
  "common.print": "Print",
  "common.refresh": "Refresh",
  "common.select": "Select",
  "common.settings": "Settings",
  "common.options": "Options",
  "common.view": "View",
  "common.sort": "Sort",
  "common.send": "Send",
  "common.moreActions": "More actions",
  // ─── Vendors: list, orders, analytics, packing slips ───
  "workspaceAssistant.proposal.createSlips": "Create packing slips",
  "workspaceAssistant.proposal.openVendor": "Open vendor",
  "workspaceAssistant.proposal.openOrder": "Open order",
  "orders.form.lineVendor": "Vendor for this line",
  "orders.form.packingSlips": "Packing slips",
  "orders.form.packingSlipsScope": "This order — one slip per vendor ({{count}})",
  "vendors.tab.overview": "Overview",
  "vendors.tab.products": "Products",
  "vendors.tab.orders": "Orders",
  "vendors.tab.analytics": "Analytics",
  "vendors.period.7d": "7 days",
  "vendors.period.30d": "30 days",
  "vendors.period.90d": "90 days",
  "vendors.period.month": "This month",
  "vendors.period.year": "This year",
  "vendors.period.all": "All time",
  "vendors.sort.newest": "Newest",
  "vendors.sort.name": "Name (A–Z)",
  "vendors.sort.revenue": "Highest revenue",
  "vendors.sort.orders": "Most orders",
  "vendors.sort.units": "Most units",
  "vendors.sort.lastOrder": "Latest order",
  "vendors.sort.products": "Most products",
  "vendors.list.title": "Vendors",
  "vendors.list.search": "Search vendors…",
  "vendors.list.count": "{{count}} vendors",
  "vendors.list.empty": "No vendors yet",
  "vendors.list.emptyHint": "Tap + to add your first vendor",
  "vendors.list.noMatch": "No vendors match these filters",
  "vendors.list.error": "Error",
  "vendors.list.loadFailed": "The vendors could not be loaded",
  "vendors.list.exportCsv": "Download as CSV (Excel)",
  "vendors.list.exportFailed": "The CSV could not be created",
  "vendors.list.select": "Select",
  "vendors.list.cancelSelection": "Cancel selection",
  "vendors.list.selected": "{{count}} selected",
  "vendors.list.addProduct": "Add product",
  "vendors.list.addProductTitle": "Add product to vendors",
  "vendors.list.addConfirm": "Add",
  "vendors.list.added": "Added",
  "vendors.list.productsAdded": "Product(s) added to {{count}} vendor(s)",
  "vendors.list.addFailed": "The products could not be added",
  "vendors.list.bulkUpload": "Bulk upload",
  "vendors.list.add": "Add vendor",
  "vendors.list.delete": "Delete",
  "vendors.list.deleteTitle": "Delete vendor",
  "vendors.list.deleteMessage": "Are you sure you want to delete this vendor? This can't be undone.",
  "vendors.list.deleted": "Deleted",
  "vendors.list.deletedMessage": "Vendor deleted",
  "vendors.list.deleteFailed": "The vendor could not be deleted",
  "vendors.row.products": "{{count}} products",
  "vendors.row.orders": "{{count}} orders",
  "vendors.row.units": "{{count}} units",
  "vendors.row.lastOrder": "Last order {{date}}",
  "vendors.row.noOrders": "No orders in this period",
  "vendors.row.noContact": "No contact info",
  "vendors.chip.minOrders": "At least {{count}} orders",
  "vendors.chip.statuses": "{{count}} order statuses",
  "vendors.chip.clearAll": "Clear all",
  "vendors.chip.remove": "Remove filter: {{label}}",
  "vendors.csv.name": "Name",
  "vendors.csv.phone": "Phone",
  "vendors.csv.email": "Email",
  "vendors.csv.city": "City",
  "vendors.csv.country": "Country",
  "vendors.csv.cr": "CR number",
  "vendors.csv.vat": "VAT number",
  "vendors.csv.products": "Products",
  "vendors.csv.orders": "Orders",
  "vendors.csv.units": "Units",
  "vendors.csv.revenue": "Revenue",
  "vendors.csv.lastOrder": "Last order",
  "vendors.csv.minimum": "Minimum order",
  "vendors.csv.added": "Added on",
  "vendors.filters.title": "Sort & filter",
  "vendors.filters.close": "Close",
  "vendors.filters.reset": "Reset",
  "vendors.filters.apply": "Show vendors",
  "vendors.filters.applyWithCount": "Show vendors ({{count}} filters)",
  "vendors.filters.sort": "Sort by",
  "vendors.filters.orders": "Orders in the period",
  "vendors.filters.ordersHint": "Uses the period chosen above the list.",
  "vendors.filters.hasOrders": "Has orders",
  "vendors.filters.noOrders": "No orders",
  "vendors.filters.minOrders": "At least this many orders",
  "vendors.filters.revenue": "Revenue",
  "vendors.filters.revenueIn": "Revenue ({{currency}})",
  "vendors.filters.min": "Min",
  "vendors.filters.max": "Max",
  "vendors.filters.countedStatuses": "Orders counted",
  "vendors.filters.countedStatusesHint": "By default every order except pending and cancelled.",
  "vendors.filters.products": "Number of products",
  "vendors.filters.minimum": "Minimum order amount",
  "vendors.filters.minimumSet": "Has a minimum",
  "vendors.filters.minimumNone": "No minimum",
  "vendors.filters.location": "Location",
  "vendors.filters.city": "City",
  "vendors.filters.country": "Country",
  "vendors.filters.added": "Added",
  "vendors.filters.anyDate": "Any date",
  "vendors.filters.fields": "Filter by fields",
  "vendors.filters.fieldsWithCount": "Filter by fields ({{count}})",
  "vendors.detail.phone": "Phone",
  "vendors.detail.email": "Email",
  "vendors.detail.address": "Address",
  "vendors.detail.crNumber": "CR number",
  "vendors.detail.vatNumber": "VAT number",
  "vendors.detail.notes": "Notes",
  "vendors.detail.files": "Files",
  "vendors.detail.productsSupplied": "Products supplied ({{count}})",
  "vendors.detail.manageProducts": "Manage products",
  "vendors.detail.noProducts": "No products linked to this vendor yet",
  "vendors.orders.search": "Order number, customer or phone",
  "vendors.orders.filters": "Filters",
  "vendors.orders.filtersWithCount": "Filters ({{count}})",
  "vendors.orders.status": "Order status",
  "vendors.orders.toFulfil": "To fulfil",
  "vendors.orders.allPlaced": "All placed orders",
  "vendors.orders.payment": "Payment",
  "vendors.orders.slip": "Packing slip",
  "vendors.orders.slipNo": "Not printed yet",
  "vendors.orders.slipYes": "Printed",
  "vendors.orders.product": "Contains product",
  "vendors.orders.count": "{{count}} orders",
  "vendors.orders.selected": "{{count}} selected",
  "vendors.orders.select": "Select order",
  "vendors.orders.slipsSelected": "Packing slips ({{count}})",
  "vendors.orders.slipsAll": "Packing slips for all",
  "vendors.orders.units": "{{count}} units",
  "vendors.orders.otherLines": "{{count}} lines from other vendors",
  "vendors.orders.slipPrinted": "Slip printed {{date}}",
  "vendors.orders.empty": "No orders with this vendor's products match",
  "vendors.orders.loadMore": "Show more ({{shown}} of {{total}})",
  "vendors.orders.loadFailed": "The orders could not be loaded",
  "vendors.analytics.revenue": "Revenue",
  "vendors.analytics.orders": "Orders",
  "vendors.analytics.units": "Units",
  "vendors.analytics.averageOrder": "Average per order",
  "vendors.analytics.customers": "Customers",
  "vendors.analytics.minimumMet": "Minimum order met",
  "vendors.analytics.minimumNote": "{{percent}}% of orders reached the vendor's minimum of {{amount}}.",
  "vendors.analytics.vsPrevious": "vs previous period",
  "vendors.analytics.counting": "Counting:",
  "vendors.analytics.over.revenue": "Revenue over time",
  "vendors.analytics.over.orders": "Orders over time",
  "vendors.analytics.over.units": "Units over time",
  "vendors.analytics.topProducts": "Top products by revenue",
  "vendors.analytics.byStatus": "Orders by status",
  "vendors.analytics.empty": "No orders with this vendor's products in this period",
  "vendors.analytics.truncated": "Showing the latest 20,000 orders of this period.",
  "vendors.analytics.loadFailed": "The analytics could not be loaded",
  "vendors.slips.title": "Packing slips",
  "vendors.slips.language": "Language",
  "vendors.slips.pickList": "Pick list first",
  "vendors.slips.pickListHint": "Every product totalled across the orders, then one slip per order.",
  "vendors.slips.showPrices": "Show prices",
  "vendors.slips.showPricesHint": "Off by default — slips usually travel with the parcel.",
  "vendors.slips.hidePhone": "Hide the customer's phone",
  "vendors.slips.generate": "Create PDF",
  "vendors.slips.failed": "The packing slips could not be created",
  "vendors.slips.ready": "{{count}} packing slips ready.",
  "vendors.slips.truncated": "Only the first {{count}} orders are included.",
  "vendors.slips.open": "Open PDF",
  "vendors.slips.sendWhatsapp": "Send to vendor on WhatsApp",
  "vendors.slips.sendEmail": "Email to vendor",
  "vendors.slips.emailSubject": "Packing slips",
  "vendors.slips.shareText": "Hello {{name}}, here are the packing slips to prepare: {{url}}",
  "vendors.slips.scopeSelected": "{{count}} selected orders",
  "vendors.slips.scopeAll": "All {{count}} orders matching the filters",
  'workspaceAssistant.savePdf': "Save answer as PDF",
  'workspaceAssistant.exportChatPdf': "Save chat as PDF",
  'workspaceAssistant.pdfFailed': "The PDF could not be created. Try again.",
  'workspaceAssistant.table.chart': "Show chart",
  'workspaceAssistant.table.hideChart': "Hide chart",
  'workspaceAssistant.paneTab.assistant': "AI assistant",
  'workspaceAssistant.paneTab.chat': "Chat",
  'workspaceAssistant.paneTab.calls': "Calls",
  'workspaceAssistant.paneTab.form': "Form",
  'workspaceAssistant.paneTab.contacts': "Contacts",
  'workspaceAssistant.paneTab.contact': "Contact",
  'workspaceAssistant.paneTab.settings': "Settings",
  'workspaceAssistant.paneTab.details': "Details",
  'workspaceAssistant.exportChat': "Save chat as a file",
  'workspaceAssistant.saveReply': "Save answer as a file",
  'workspaceAssistant.table.copy': "Copy table (paste into Excel / Sheets)",
  'workspaceAssistant.table.csv': "Download CSV (Excel)",
  'workspaceAssistant.table.open': "Open",
  'workspaceAssistant.table.chat': "Open chat",
  'workspaceAssistant.table.call': "Call",
  'workspaceAssistant.table.filter': "Filter rows",
  'workspaceAssistant.table.noMatch': "No rows match.",
  'workspaceAssistant.table.showing': "{{shown}} of {{total}}",
  'workspaceAssistant.table.showAll': "Show all {{count}}",
  'workspaceAssistant.table.showLess': "Show less",
  'workspaceAssistant.table.loadMore': "Load more",
  'workspaceAssistant.table.expand': "Open table",
  'workspaceAssistant.table.moreColumns': "+{{count}} columns",
  'workspaceAssistant.table.close': "Close",
  'workspaceAssistant.table.chatFailed': "The chat could not be opened. Try from the contact's profile.",
  'workspaceAssistant.table.callFailed': "This contact has no number to call.",
  'workspaceAssistant.onScreen': "On: {{screen}}",
  'workspaceAssistant.copy': "Copy answer",
  'workspaceAssistant.askAgain': "Ask again",
  'workspaceAssistant.newReply': "New reply",
  'workspaceAssistant.enterHint': "Enter to send · Shift+Enter for a new line",
  'workspaceAssistant.screen.chat': "Inbox",
  'workspaceAssistant.screen.conversation': "Conversation",
  'workspaceAssistant.screen.contacts': "Contacts",
  'workspaceAssistant.screen.home': "Home",
  'workspaceAssistant.screen.products-list': "Products",
  'workspaceAssistant.screen.product-detail': "Product",
  'workspaceAssistant.screen.vendors': "Vendors",
  'workspaceAssistant.screen.orders': "Orders",
  'workspaceAssistant.screen.quotations': "Quotations",
  'workspaceAssistant.screen.dashboard': "Dashboard",
  'workspaceAssistant.screen.performance': "Reports",
  'workspaceAssistant.screen.template-management': "Templates",
  'workspaceAssistant.screen.lead-finder': "Lead Finder",
  'workspaceAssistant.screen.flows-list': "Workflows",
  'workspaceAssistant.screen.data-lists': "Data lists",
  'workspaceAssistant.screen.settings': "Settings",
  'workspaceAssistant.area.inbox': "Inbox",
  'workspaceAssistant.area.customers': "Customers",
  'workspaceAssistant.area.products': "Products & vendors",
  'workspaceAssistant.area.messages': "Messages & templates",
  'workspaceAssistant.area.analytics': "Sales & analytics",
  'workspaceAssistant.area.market': "Price comparison",
  'workspaceAssistant.starter.inbox.waiting': "How many customers are waiting for our reply? Oldest first with their last message",
  'workspaceAssistant.starter.inbox.today': "Which customers wrote to us today?",
  'workspaceAssistant.starter.customers.find': "Find the contact",
  'workspaceAssistant.starter.customers.mine': "Which contacts are assigned to me?",
  'workspaceAssistant.starter.products.coverage': "Which products need more vendors or similar items?",
  'workspaceAssistant.starter.products.prices': "What are the prices of",
  'workspaceAssistant.starter.messages.received': "Who received our templates in the last 7 days?",
  'workspaceAssistant.starter.messages.template': "Write a WhatsApp template for a new offer",
  'workspaceAssistant.starter.analytics.sales': "Sales this month compared with last month",
  'workspaceAssistant.starter.analytics.topCustomers': "Who are our top customers this month?",
  'workspaceAssistant.starter.market.compare': "Compare our prices with this store:",
  'workspaceAssistant.stage.history': "Reading our chat…",
  'workspaceAssistant.stage.business': "Reading business details…",
  'workspaceAssistant.stage.catalogue': "Searching products…",
  'workspaceAssistant.stage.lookup.conversations': "Checking the inbox…",
  'workspaceAssistant.stage.lookup.messages': "Reading message history…",
  'workspaceAssistant.stage.lookup.contacts': "Searching contacts…",
  'workspaceAssistant.stage.lookup.products': "Searching products…",
  'workspaceAssistant.stage.lookup.product_coverage': "Analysing the catalogue…",
  'workspaceAssistant.stage.lookup.web_prices': "Reading the store's prices…",
  'workspaceAssistant.stage.lookup.analytics': "Calculating…",
  'workspaceAssistant.stage.lookup.orders': "Reading orders…",
  'workspaceAssistant.stage.lookup.quotations': "Reading quotations…",
  'workspaceAssistant.stage.lookup.vendors': "Reading vendors…",
  'workspaceAssistant.stage.lookup.templates': "Reading templates…",
  'workspaceAssistant.stage.lookup.campaigns': "Reading campaigns…",
  'workspaceAssistant.stage.lookup.automations': "Reading workflows and automations…",
  'workspaceAssistant.stage.lookup.search_runs': "Reading lead searches…",
  'workspaceAssistant.stage.lookup.search_results': "Reading lead results…",
  'workspaceAssistant.stage.lookup.data_lists': "Reading data lists…",
  'workspaceAssistant.stage.lookup.list_records': "Reading list rows…",
  'workspaceAssistant.stage.lookup.reports': "Reading reports…",
  'workspaceAssistant.stage.lookup.other': "Reading business data…",
  'workspaceAssistant.title': 'AI assistant',
  'ai.activity.workspace_assistant': 'Workspace assistant',
  'ai.activity.workspace_agent': 'Workspace assistant',
  'workspaceAssistant.subtitle': 'Your app guide and business workspace',
  'workspaceAssistant.contextTab': 'Screen details',
  'workspaceAssistant.welcome': 'What would you like to do?',
  'workspaceAssistant.intro': 'Look up your business information, find screens, or prepare templates, campaigns and contact lists. Review the preview and use its action to execute.',
  'workspaceAssistant.proposal.status.draft': 'Ready to review',
  'workspaceAssistant.proposal.status.executing': 'Executing — check the saved record before retrying',
  'workspaceAssistant.proposal.status.completed': 'Action completed',
  'workspaceAssistant.proposal.status.failed': 'Action failed — inspect the record before retrying',
  'workspaceAssistant.proposal.sample': 'Audience sample',
  'workspaceAssistant.proposal.attachHeader': 'Attach the header file before saving or submitting.',
  'workspaceAssistant.proposal.startCampaign': 'Create and queue campaign',
  'workspaceAssistant.proposal.saveTemplate': 'Save local template',
  'workspaceAssistant.proposal.submitTemplate': 'Save and submit to Meta',
  'workspaceAssistant.proposal.contacts': 'Contacts added',
  'workspaceAssistant.proposal.create': 'Create as shown',
  'workspaceAssistant.proposal.open': 'Open saved record',
  'workspaceAssistant.proposal.queued': 'Recipients queued',
  'workspaceAssistant.proposal.attached': 'Visits created',
  'workspaceAssistant.proposal.skippedLocation': 'Skipped without a usable location',
  'workspaceAssistant.proposal.quotaLimited': 'The subscription quota limited the recipient count.',
  'workspaceAssistant.attach.add': 'Attach photos or files',
  'workspaceAssistant.attach.drop': 'Drop photos or files to attach',
  'workspaceAssistant.attach.reading': 'Reading…',
  'workspaceAssistant.attach.remove': 'Remove file',
  'workspaceAssistant.attach.unsupported': 'Use a photo, PDF, Word, Excel, CSV or text file',
  'workspaceAssistant.attach.tooLarge': 'Files up to 10 MB',
  'workspaceAssistant.attach.failed': 'Could not attach. Try again',
  'workspaceAssistant.placeholder': 'Ask about the app or your business…',
  'workspaceAssistant.send': 'Send question',
  'workspaceAssistant.you': 'You',
  'workspaceAssistant.thinking': 'Checking your question…',
  'workspaceAssistant.stop': 'Stop this reply',
  'workspaceAssistant.products.minimum': 'Minimum quantity',
  'workspaceAssistant.products.notConfigured': 'Not configured',
  'workspaceAssistant.products.noPrice': 'Price not recorded',
  'workspaceAssistant.products.unit': 'Sold by',
  'workspaceAssistant.products.allSizes': 'Show all sizes',
  'workspaceAssistant.products.fewerSizes': 'Show fewer sizes',
  'workspaceAssistant.products.outOfStock': 'Out of stock',
  'workspaceAssistant.products.suppliers': 'Suppliers',
  'workspaceAssistant.products.categories': 'Categories',
  'workspaceAssistant.products.stock': 'Stock',
  'workspaceAssistant.products.open': 'Open product',
  'workspaceAssistant.products.details': 'Supplier and details',
  'workspaceAssistant.products.hideDetails': 'Hide details',
  'workspaceAssistant.products.remainingSizes': 'Open the product to see remaining sizes.',
  'workspaceAssistant.newChat': 'New chat',
  'workspaceAssistant.resetConfirm': 'Clear this assistant conversation and start again?',
  'workspaceAssistant.permission': 'Ask your business administrator to grant AI assistant access.',
  'workspaceAssistant.setup': 'Open AI setup',
  'workspaceAssistant.screenContext': 'Current screen',
  'workspaceAssistant.prompt.profile': 'How do I change my profile picture?',
  'workspaceAssistant.prompt.quotation': 'I need to create a quotation.',
  'workspaceAssistant.prompt.products': 'Help me find product prices and minimum order quantities.',
  'workspaceAssistant.prompt.business': 'What do you know about our business?',
  "phone.audio.speaker": "Toggle speaker",
  "phone.audio.speakerOn": "Speaker on",
  "phone.audio.speakerOff": "Speaker off",
  "phone.audio.close": "Close call",
  "phone.audio.failed": "Could not configure call audio. Please try again.",
  "phone.audio.microphoneRequired": "Allow microphone access to place calls.",
  "phone.audio.rebuildRequired": "Install the latest DISLIX app version to enable native calling.",

  "visits.timeline.title": "Visit timeline",
  "visits.timeline.scheduled": "Planned visit",
  "visits.timeline.due": "Deadline",
  "visits.timeline.created": "Created",
  "visits.timeline.assigned": "Assigned / claimed",
  "visits.timeline.started": "Started / checked in",
  "visits.timeline.completed": "Finished / checked out",
  "visits.timeline.cancelled": "Cancelled",
  "visits.timeline.outcome": "Outcome recorded",
  "visits.timeline.rescheduled": "Schedule changed",
  "visits.timeline.updated": "Visit updated",
  "visits.timeline.photo_start": "Start photo captured",
  "visits.timeline.photo_end": "End photo captured",
  "visits.timeline.note": "Note added",
  "visits.timeline.order": "Order created",
  "visits.timeline.quotation": "Quotation created",
  "visits.timeline.vendor": "Vendor added",
  "visits.timeline.reminder": "Reminder created",
  "visits.timeline.list": "Added to list",
  "visits.timeline.assignment": "Assignment created",
  "reports.visits.analytics": "Visit performance & analytics",
  "reports.visits.unassigned": "Unassigned / department pool",
  "reports.visits.byStatus": "Visits by status",
  "reports.visits.teamPerformance": "Completed visits by team member",
  "reports.visits.metricsHint": "Punctuality uses {{starts}} visits with both planned and actual start times. Success uses {{outcomes}} recorded outcomes. Missing measurements show —; positive start delay means late, negative means early.",
  "reports.visits.dateBasis": "Report dates follow the actual finish or cancellation, then the actual start, otherwise the planned date or creation. Times use your device timezone.",
  "reports.visits.metric.agent": "Agent / department",
  "reports.visits.metric.total": "Visits",
  "reports.visits.metric.completed": "Completed",
  "reports.visits.metric.inProgress": "In progress",
  "reports.visits.metric.missed": "Missed",
  "reports.visits.metric.cancelled": "Cancelled",
  "reports.visits.metric.completion": "Completion rate",
  "reports.visits.metric.punctuality": "On-time starts",
  "reports.visits.metric.success": "Outcome success rate",
  "reports.visits.metric.averageDuration": "Average visit time",
  "reports.visits.metric.assignmentWait": "Assignment → start",
  "reports.visits.metric.startDelay": "Average start delay",
  "reports.visits.metric.totalDuration": "Total visit time",
  "reports.visits.metric.overdue": "Overdue open visits",
  'ai.quick.choicePreview': 'Suggested customer choices',
  'ai.quick.addChoices': 'Use reply with selection buttons',
  'ai.quick.clarifyFirst': 'Clarify the product, size, quantity or selling unit before preparing a document.',
  'ai.choices.title': 'Options sent with this message',
  'ai.choices.asButtons': 'Sent as buttons',
  'ai.choices.asList': 'Sent as a list',
  'ai.choices.optionPlaceholder': 'Option {{n}}',
  'ai.choices.descriptionPlaceholder': 'Description (optional, shown in the list)',
  'ai.choices.tooLong': 'WhatsApp shows up to {{max}} characters here',
  'ai.choices.add': 'Add option',
  'ai.choices.remove': 'Remove option',
  'ai.choices.moveUp': 'Move up',
  'ai.choices.moveDown': 'Move down',
  'ai.choices.menu': 'Options (buttons)',
  'ai.media.sendProduct': 'Send product card: {{name}}',
  'ai.media.sendCatalog': 'Send catalogue: {{name}}',
  'ai.media.sendPhotos': 'Send photos: {{name}}',
  'flowRuns.contact.title': 'Workflow runs',
  'flowRuns.contact.all': 'All runs ({{count}})',
  'flowRuns.contact.empty': 'No workflow has run for this contact yet.',
  'flowRuns.contact.more': 'Show more',
  'flowRuns.status.active': 'Running',
  'flowRuns.status.waiting': 'Waiting',
  'flowRuns.status.paused': 'Paused',
  'flowRuns.status.completed': 'Completed',
  'flowRuns.status.stopped': 'Stopped',
  'flowRuns.errors': '{{count}} errors',
  'flowRuns.nowAt': 'Now at: {{step}}',
  'flowRuns.waitingUntil': 'Waiting until {{date}}',
  'flowRuns.openConversation': 'Open conversation',
  'flowRuns.showPath': 'Show path on the flow',
  'flowRuns.resume': 'Resume',
  'flowRuns.stop': 'Stop',
  'flowRuns.resumed': 'The flow is continuing in the conversation.',
  'flowRuns.stopped': 'The flow stopped for this contact.',
  'flowRuns.moved': 'The run continues from the chosen step.',
  'flowRuns.actionFailed': 'The action failed',
  'flowRuns.move.action': 'Continue from a step…',
  'flowRuns.move.title': 'Continue from a step',
  'flowRuns.move.hint': 'The run goes on from the step you choose, right away in its conversation, with the values it has saved. A finished run is reopened.',
  'flowRuns.move.search': 'Search steps',
  'flowRuns.move.current': 'current step',
  'conversation.cart.summary': 'Open cart: {{count}} items · {{total}}',
  'conversation.cart.several': '{{count}} carts',
  'conversation.cart.fromAssistant': 'From the AI assistant',
  'conversation.cart.fromFlow': 'From workflow: {{name}}',
  'conversation.cart.workflow': 'Workflow',
  'conversation.cart.total': 'Total',
  'conversation.cart.createOrder': 'Create order',
  'conversation.cart.createQuotation': 'Create quotation',
  'conversation.cart.clear': 'Clear cart',
  'aiAgents.title': 'AI agents',
  'aiAgents.count': '{{active}} of {{allowed}} active',
  'aiAgents.countUnlimited': '{{active}} active',
  'aiAgents.hint': 'Included in your subscription on top of your users. AI agents never sign in; everything they do is recorded under their name.',
  'aiAgents.badge': 'AI agent',
  'aiAgents.default': 'Default',
  'aiAgents.noLogin': 'cannot sign in',
  'aiAgents.status.active': 'Active',
  'aiAgents.status.paused': 'Paused',
  'aiAgents.status.suspended': 'Suspended',
  'aiAgents.suspended.planLimit': 'over the number in your subscription',
  'aiAgents.suspended.noAi': 'your subscription has no AI service',
  'aiAgents.suspended.noSubscription': 'no active subscription',
  'aiAgents.banner.noAi': 'Your subscription has no AI service, so every AI agent is suspended. Their history is kept and they come back when AI is added.',
  'aiAgents.banner.noSubscription': 'There is no active subscription, so every AI agent is suspended. Their history is kept and they come back when you renew.',
  'aiAgents.settings': 'Settings',
  'aiAgents.rename': 'Rename',
  'aiAgents.pause': 'Pause',
  'aiAgents.resume': 'Resume',
  'aiAgents.makeDefault': 'Make default',
  'aiAgents.keepActive': 'Keep this one active',
  'aiAgents.add': 'Add AI agent',
  'aiAgents.actionFailed': 'The change was not saved',
  'aiAgents.form.title': '{{name}} — settings',
  'aiAgents.form.persona': 'Persona',
  'aiAgents.form.name': 'Name the customer sees',
  'aiAgents.form.tone': 'Tone (e.g. friendly and short)',
  'aiAgents.form.instructions': 'Instructions: what to focus on, policies, what to avoid…',
  'aiAgents.form.languageAuto': "Customer's language",
  'aiAgents.form.coverage': 'Where and when it answers',
  'aiAgents.form.coverageHint': 'Nothing selected = every channel and number.',
  'aiAgents.form.hoursAlways': 'Always',
  'aiAgents.form.hoursBusiness': 'Business hours',
  'aiAgents.form.hoursAfter': 'After hours',
  'aiAgents.form.actions': 'What it may do',
  'aiAgents.action.show_products': 'Show products',
  'aiAgents.action.cart': 'Build a cart',
  'aiAgents.action.orders': 'Create orders',
  'aiAgents.action.quotations': 'Quotations',
  'aiAgents.action.order_status': 'Order status',
  'aiAgents.action.media': 'Photos & catalogues',
  'aiAgents.form.products': 'Products it offers',
  'aiAgents.form.productsHint': 'Nothing selected = every product.',
  'aiAgents.form.noCatalogues': 'No catalogues yet.',
  'aiAgents.form.handoff': 'Handing over to a person',
  'aiAgents.form.handoffHint': 'The agent stops answering and the contact is assigned to the person.',
  'aiAgents.form.toPrevious': 'Who had the contact before',
  'aiAgents.form.toUser': 'A person',
  'aiAgents.form.toDepartment': 'A department',
  'aiAgents.form.previousFallback': 'When nobody had the contact before: this department (else the owner).',
  'aiAgents.form.onAskHuman': 'When the customer asks for a person',
  'aiAgents.form.onNegative': 'When the customer is upset or complaining',
  'aiAgents.form.maxTurns': 'After this many messages',
  'aiAgents.form.keywords': 'When these words appear (comma separated)',
  'aiAgents.form.other': 'Other',
  'aiAgents.form.isDefault': 'Answer contacts nobody is assigned to',
  'aiAgents.form.paused': 'Paused',
  'aiAgents.form.nameRequired': 'Give the agent a name.',
  'aiAgents.form.saved': 'The agent was updated.',
  'ai.quick.asAgent': 'AI agent: {{name}}',
  'home.aiActivity.title': 'AI activity',
  'home.aiActivity.conversations': 'Conversations',
  'home.aiActivity.replies': 'Replies',
  'home.aiActivity.orders': 'Orders',
  'home.aiActivity.quotations': 'Quotations',
  'home.aiActivity.handoffs': 'Handed over',
  'home.aiActivity.live': '{{count}} live',
  'home.aiActivity.errors': '{{count}} with errors',
  'home.flowRuns.title': 'Workflow runs by contact ({{count}})',
  'home.flowRuns.all': 'All runs',
  'home.flowRuns.unknown': 'Unknown contact',
  'home.flowRuns.runs': '{{count}} runs',
  'home.flowRuns.live': '{{count}} running',
  'home.flowRuns.errors': '{{count}} errors',
  'home.flowRuns.more': 'Show {{count}} more',
  'home.flowRuns.less': 'Show less',
  'conversation.cart.fromAgent': 'AI agent: {{name}}',
  'conversation.cart.otherNumber': 'This customer has a cart on their other number: {{count}} items · {{total}}',
  'conversation.cart.continueHere': 'Continue it here',
  'conversation.cart.startNew': 'Start a new cart',
  'conversation.cart.byCustomer': 'Changed by the customer',
  'conversation.cart.byTeam': 'Changed by the team',
  'conversation.cart.subtotal': 'Subtotal',
  'conversation.cart.less': 'One less',
  'conversation.cart.more': 'One more',
  'catalogues.temporaryFilter': 'AI temporary catalogues',
  'aiAgents.form.presentation': 'Show products as',
  'aiAgents.form.presentationHint': 'The store page sends a product card, or several products on one catalogue page (made on the fly when needed).',
  'aiAgents.form.presentationPage': 'Store page',
  'aiAgents.form.presentationChat': 'In-chat list',
  'ai.quick.draftChoices': 'Choices to send with this message',
  'ai.quick.removeChoices': 'Remove choices and send text only',
  'ai.quick.title': 'Suggested replies',
  'ai.quick.refresh': 'Refresh suggestions',
  'ai.quick.expand': 'Show suggestions',
  'ai.quick.collapse': 'Hide suggestions',
  'ai.quick.preparing': 'Preparing replies to the latest customer message…',
  'ai.quick.thinking': 'The assistant is reading the conversation and looking things up…',
  'ai.quick.summary': 'So far',
  'ai.quick.slow': 'The assistant is taking longer than usual. Tap refresh to try again.',
  'ai.quick.manage': 'AI memory options',
  'ai.quick.rebuild': 'Rebuild suggestions',
  'ai.quick.clearMemory': 'Clear AI memory',
  'ai.quick.clearConfirm': 'Forget this chat’s summary, remembered products and suggestions?',
  'ai.quick.memoryCleared': 'AI memory cleared. New suggestions come with the next customer message, or tap refresh.',
  'ai.quick.choosePrompt': 'Which one would you like?',
  'ai.quick.recommended': 'Recommended',
  'ai.quick.send': 'Send',
  'ai.quick.edit': 'Edit before sending',
  'ai.quick.cartSummary': 'Draft cart: {{count}} items · {{total}}',
  'ai.quick.needsHuman': 'This customer needs a person: complaint or a request the assistant should not handle.',
  'ai.knowledge.title': 'Business knowledge',
  'ai.knowledge.description': 'What the assistant should know to answer customers: delivery areas and times, payment methods, returns, working hours, tone. It answers from this and never invents these details.',
  'ai.knowledge.placeholder': 'Example: We deliver in Cairo and Giza within 24 hours (50 EGP, free above 1000). Payment: cash on delivery or card link. Returns within 7 days if unopened.',
  'ai.knowledge.save': 'Save knowledge',
  'ai.knowledge.saved': 'Saved',
  'ai.quick.quickReplies': 'Reply sent. Quick Replies until the customer writes again:',
  'ai.quick.noQuickReplies': 'No Quick Replies yet. Add them in Settings → Quick Replies.',
  'share.sendQuotation': 'Send quotation',
  'share.sendOrder': 'Send order',
  'share.newQuotation': 'New quotation',
  'share.newOrder': 'New order',
  'share.search': 'Search by number, name or phone',
  'share.noContact': 'This chat is not linked to a saved contact yet: showing recent ones for the business.',
  'share.noQuotations': 'No quotations for this customer yet.',
  'share.noOrders': 'No orders for this customer yet.',
  'share.items': 'items',
  'share.what': 'What to send',
  'share.details': 'Details',
  'share.pdf': 'PDF',
  'share.both': 'Details + PDF',
  'share.quotationButtons': 'Add Accept / Request changes buttons',
  'share.orderButtons': 'Add Confirm / Cancel buttons',
  'share.send': 'Send',
  'share.sent': 'Sent to the customer.',
  'share.failed': 'Could not send it. Please try again.',
  'ai.quick.useReply': 'Use reply',
  'ai.quick.firstContact': 'Start the conversation with an approved template.',
  'ai.quick.windowClosed': 'The WhatsApp reply window is closed. Use an approved template.',
  'ai.quick.prepareTemplate': 'Prepare template',
  'ai.quick.templatePermission': 'Ask your administrator for permission to use WhatsApp templates.',
  'ai.quick.noTemplates': 'No approved templates found. Add or sync templates in WhatsApp settings.',
  'ai.quick.noChannelTemplates': 'No incoming message yet. Approved template suggestions are currently available for WhatsApp.',
  'ai.quick.order': 'Prepare order',
  'ai.quick.quotation': 'Prepare quotation',
  'permissions.ai.useAssistant.label': 'Use AI assistant',
  'permissions.ai.useAssistant.description': 'Generate replies and propose quotations using permitted business data.',
  'ai.activity.suggested_reply': 'Suggested reply',
  'ai.activity.quotation_proposal': 'Quotation proposal',
  'ai.assistant.open': 'AI assistant',
  'ai.assistant.checkingSetup': 'Checking AI connection…',
  'ai.assistant.setupRequired': 'Connect and test a model in Settings → AI assistance, then check again here.',
  'ai.assistant.retrySetup': 'Check connection again',
  'ai.assistant.close': 'Close assistant',
  'ai.assistant.description': 'Draft a reply using recent messages and a live product search. Review the result before using it. Nothing is sent automatically.',
  'ai.assistant.productSearch': 'Product name or SKU (optional for replies)',
  'ai.assistant.searchPlaceholder': 'Search a product, for example Pepsi',
  'ai.assistant.instructions': 'What should the assistant help with?',
  'ai.assistant.instructionsPlaceholder': 'For example: answer the price question, or quote 2 units.',
  'ai.assistant.suggest': 'Suggest a reply',
  'ai.assistant.proposeQuotation': 'Propose quotation lines',
  'ai.assistant.working': 'Working… the local model may take a little time.',
  'ai.assistant.reviewReply': 'Review and edit the reply',
  'ai.assistant.insertReply': 'Insert into message composer',
  'ai.assistant.reviewQuotation': 'Review quotation proposal',
  'ai.assistant.total': 'Total',
  'ai.assistant.quotationTerms': 'Catalog prices; no tax, delivery charges or additional discounts. Approval creates a draft quotation without sending it. Proposals expire after 15 minutes.',
  'ai.assistant.customerName': 'Customer name',
  'ai.assistant.customerPhone': 'Customer phone',
  'ai.assistant.approveQuotation': 'Approve and create draft quotation',
  'ai.assistant.created': 'Draft quotation {{number}} created. Open Quotations to review it.',
  'ai.assistant.sources': 'Data used',
  'ai.assistant.contextCount': '{{messages}} recent messages and {{products}} matching products. Search results are limited; attachments are not read.',
  'ai.setupTitle': 'AI assistance',
  'ai.setupDescription': 'Connect a model available through DISLIX AI for your business.',
  'ai.historyTitle': 'AI usage history',
  'ai.historyDescription': 'Review requests, model usage, response times and outcomes for your business.',
  'ai.loadFailed': 'Could not load AI information. Please retry.',
  'ai.actionFailed': 'Could not complete this action. Please retry.',
  'ai.accessDenied': 'You do not have permission to access this AI page.',
  'ai.notIncluded': 'AI is not included in your plan',
  'ai.notIncludedDescription': 'Ask your business owner to enable AI through a plan that includes it.',
  'ai.viewPlan': 'View subscription',
  'ai.connected': 'AI model connected',
  'ai.notConnected': 'Choose your AI model',
  'ai.selectModel': 'Available models',
  'ai.noModels': 'No models are configured yet. Ask your administrator to configure DISLIX AI, then refresh.',
  'ai.source.local': 'DISLIX local model',
  'ai.source.platform': 'Provided by DISLIX',
  'ai.source.business': 'Your business provider',
  'ai.unavailable': 'Currently unavailable',
  'ai.refreshModels': 'Refresh',
  'ai.connect': 'Connect and test model',
  'ai.test': 'Test connection',
  'ai.disconnect': 'Disconnect',
  'ai.testSucceeded': 'Model responded successfully',
  'ai.testTime': 'Response time: {{seconds}} seconds',
  'ai.pilotNote': 'Connection tests are included in usage history so you can evaluate quality and response time.',
  'ai.unpricedNote': 'Usage is being measured. AI usage billing is not enabled.',
  'ai.dateFormat': 'Enter valid dates as YYYY-MM-DD.',
  'ai.from': 'From',
  'ai.to': 'To',
  'ai.status.all': 'All outcomes',
  'ai.status.completed': 'Completed',
  'ai.status.failed': 'Failed',
  'ai.status.pending': 'In progress',
  'ai.requests': 'Requests',
  'ai.tokens': 'Tokens processed',
  'ai.failed': 'Failed requests',
  'ai.averageTime': 'Average successful response',
  'ai.noUsage': 'No AI activity in this period. Connect or test a model to record your first request.',
  'ai.activity.connection_test': 'Connection test',
  'ai.activity.flow_step': 'Workflow AI step',
  'ai.tokenDetails': 'Input: {{input}} tokens · Output: {{output}} tokens',
  'ai.tokensUnknown': 'Token consumption unavailable',
  'ai.requestId': 'Request',
  'ai.actorId': 'User',
  'ai.providerFailed': 'The provider request failed. Token consumption may be unavailable.',
  'ai.page': 'Page {{page}} of {{pages}}',
  'settings.entry.ai.title': 'AI assistance',
  'settings.entry.ai.description': 'Connect and test your business AI model.',
  'settings.entry.aiUsage.title': 'AI usage history',
  'settings.entry.aiUsage.description': 'Requests, token consumption and response times.',
  'permissions.categoryLabel.ai': 'AI assistance',
  'permissions.ai.manageConfig.label': 'Configure AI',
  'permissions.ai.manageConfig.description': 'View or change the connected AI model and run connection tests.',
  'permissions.ai.viewUsage.label': 'View AI usage',
  'permissions.ai.viewUsage.description': 'View business-wide AI consumption and request history.',
  'setup.step.ai.title': 'Connect AI',
  'setup.step.ai.description': 'Choose and test a model for your business.',
  // ─── Common ───────────────────────────────────────────────────────────────
  'common.error': 'Error',
  'common.success': 'Success',
  'common.cancel': 'Cancel',
  'common.apply': 'Apply',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.copy': 'Copy',
  'billing.paymentRef': 'Payment ref.',
  'billing.invoiceNo': 'Invoice',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.done': 'Done',
  'common.loading': 'Loading...',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.noResults': 'No results found',
  'common.retry': 'Retry',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.actions': 'Actions',

  // ─── API Response Codes ───────────────────────────────────────────────────
  'api.1000': 'Done successfully',
  'api.1001': 'Already exists',
  'api.1002': 'Not found',
  'api.1003': 'Already exists',
  'api.0': 'An error occurred',
  'api.1010': 'Authorized',
  'api.1011': 'Unauthorized',
  'api.1004': 'Not related',
  'api.1005': 'Verification required',
  'api.1006': 'Incomplete',
  'api.1007': 'Missing required fields',
  'api.validationFailed': 'Validation failed',
  'api.unauthorized': 'Unauthorized access',
  'api.forbidden': 'Access forbidden',
  'api.notFound': 'Resource not found',
  'api.conflict': 'Resource conflict',
  'api.serverError': 'Internal server error',
  'api.serviceUnavailable': 'Service temporarily unavailable',
  'api.rateLimitExceeded': 'Too many requests, please try again later',
  'api.tokenInvalid': 'Invalid or expired session',
  'api.invalidCredentials': 'Invalid email or password',
  'api.fileTooLarge': 'File size exceeds limit',
  'api.invalidFileType': 'Invalid file type',
  'api.networkError': 'Network error, please check your connection',

  // ─── API Auth Errors ──────────────────────────────────────────────────────
  'api.auth.userAlreadyExists': 'An account with this email already exists',
  'api.auth.invalidCredentials': 'Incorrect email or password',
  'api.auth.tokenExpired': 'Your session has expired, please sign in again',
  'api.auth.tokenRevoked': 'This session has been ended',
  'api.auth.tokenInvalid': 'Invalid session token',
  'api.auth.refreshTokenInvalid': 'Invalid or expired refresh token',
  'api.auth.verificationSent': 'Verification code sent',
  'api.auth.passwordResetSuccess': 'Password reset successfully',
  'api.auth.passwordRequirements': 'Password does not meet requirements',
  'api.auth.verificationRequired': 'Please verify your account first',
  'api.auth.providerNotSupported': 'This sign-in method is not supported',

  // ─── API WhatsApp Errors ──────────────────────────────────────────────────
  'api.whatsapp.invalidPhoneFormat': 'Invalid phone number format. Include country code (e.g. +966…)',
  'api.whatsapp.phoneAlreadyRegistered': 'This number is already registered with WhatsApp. Remove it from your personal WhatsApp first',
  'api.whatsapp.businessNameFailed': 'Business name validation failed. Try a different name',
  'api.whatsapp.permissionsError': 'App permissions error. Check your WhatsApp Business App permissions',
  'api.whatsapp.maxPhonesReached': 'Maximum phone numbers reached. Delete an existing number to add a new one',
  'api.whatsapp.verificationTooManyAttempts': 'Too many attempts. Please wait before trying again',
  'api.whatsapp.verificationCodeInvalid': 'Invalid verification code. Please check and try again',
  'api.whatsapp.verificationFailed': 'Verification failed. Please try again',
  'api.whatsapp.registeredLimitedName': 'Phone active but business name verification is limited',
  'api.whatsapp.phoneVerifiedSuccess': 'Phone number verified successfully',
  'api.whatsapp.sendFailed': 'Failed to send message',
  'api.whatsapp.providerNotFound': 'WhatsApp provider not configured',
  'api.whatsapp.noPageConfigured': 'No Facebook pages configured for this business',
  'api.whatsapp.pageLimitReached': 'Page limit reached for your subscription',

  // ─── API Product Errors ───────────────────────────────────────────────────
  'api.product.nameRequired': 'Product name is required',
  'api.product.nameTooLong': 'Product name must be less than 200 characters',
  'api.product.priceRequired': 'Product price is required',
  'api.product.priceNegative': 'Price cannot be negative',
  'api.product.salePriceTooHigh': 'Sale price must be less than the regular price',
  'api.product.skuInvalid': 'SKU can only contain letters, numbers, hyphens, and underscores',
  'api.product.currencyInvalid': 'Currency must be a 3-letter ISO code (e.g., USD, EGP, SAR)',
  'api.product.tooManyImages': 'Cannot exceed 10 images per product',
  'api.product.imageUrlInvalid': 'Image URL is invalid',
  'api.product.variantsNotAllowed': 'Variants must be empty when hasVariants is false',
  'api.product.invoiceExists': 'Invoice already exists for this order',
  'api.product.orderNoItems': 'Order must have at least one item',
  'api.catalogue.businessRequired': 'Business ID is required',
  'api.catalogue.catalogueRequired': 'Catalogue ID is required',

  // ─── API Quick Reply Errors ───────────────────────────────────────────────
  'api.quickReply.maxDepthExceeded': 'Maximum nesting depth exceeded',
  'api.quickReply.circularReference': 'Circular reference: cannot nest a replies set into itself',
  'api.quickReply.messageTypeRequired': 'Message type is required',
  'api.quickReply.textRequired': 'Text is required for text message type',
  'api.quickReply.mediaUrlRequired': 'Media URL is required for media message types',
  'api.quickReply.locationRequired': 'Location coordinates are required',
  'api.quickReply.urlInvalid': 'URL must start with http:// or https://',
  'api.quickReply.taskTitleRequired': 'Task title is required',
  'api.quickReply.calendarFieldsRequired': 'Calendar title and start date are required',
  'api.quickReply.assignUserRequired': 'At least one user is required for assignment',
  'api.quickReply.assignDeptRequired': 'At least one department is required for assignment',

  // ─── API Contact & User Errors ────────────────────────────────────────────
  'api.contact.fetchFailed': 'Failed to load contacts',
  'api.contact.createFailed': 'Failed to create contact',
  'api.contact.updateFailed': 'Failed to update contact',
  'api.contact.deleteFailed': 'Failed to delete contact',
  'api.contact.importFailed': 'Failed to import contacts',
  'api.contact.exportSuccess': 'Contacts exported successfully',
  'api.contact.fileRequired': 'A file is required for import',
  'api.user.notAuthenticated': 'You are not authenticated',
  'api.user.updateFailed': 'Failed to update user',
  'api.user.passwordChangeFailed': 'Failed to change password',
  'api.user.searchRequired': 'Search query is required',

  // ─── Enum: Conversation Status ────────────────────────────────────────────
  'status.open': 'Open',
  'status.closed': 'Closed',
  'status.pending': 'Pending',
  'status.resolved': 'Resolved',
  'status.archived': 'Archived',
  'status.locked': 'Locked',
  'status.transferred': 'Transferred',
  'status.deleted': 'Deleted',
  'status.active': 'Active',
  'status.completed': 'Completed',
  'status.cancelled': 'Cancelled',
  'status.inProgress': 'In Progress',
  'status.failed': 'Failed',
  'status.sent': 'Sent',
  'status.delivered': 'Delivered',
  'status.read': 'Read',

  // ─── Enum: Notification Status ────────────────────────────────────────────
  'status.notif.pending': 'Pending',
  'status.notif.sent': 'Sent',
  'status.notif.failed': 'Failed',
  'status.notif.delivered': 'Delivered',

  // ─── Enum: Contact Status ─────────────────────────────────────────────────
  'contactStatus.lead': 'Lead',
  'contactStatus.prospect': 'Prospect',
  'contactStatus.customer': 'Customer',
  'contactStatus.accepted': 'Accepted',
  'contactStatus.declined': 'Declined',
  'contactStatus.blocked': 'Blocked',
  'contactStatus.inactive': 'Inactive',

  // ─── Enum: Channel Status ─────────────────────────────────────────────────
  'channelStatus.connected': 'Connected',
  'channelStatus.disconnected': 'Disconnected',
  'channelStatus.alreadyInUse': 'Already in use',
  'channelStatus.pendingVerification': 'Pending verification',
  'channelStatus.unknown': 'Unknown',

  // ─── Enum: User Status ────────────────────────────────────────────────────
  'userStatus.active': 'Active',
  'userStatus.inactive': 'Inactive',
  'userStatus.suspended': 'Suspended',
  'userStatus.pending': 'Pending',

  // ─── Enum: Message Direction ──────────────────────────────────────────────
  'direction.inbound': 'Inbound',
  'direction.outbound': 'Outbound',

  // ─── Enum: Notification Types ─────────────────────────────────────────────
  'notifType.email': 'Email',
  'notifType.sms': 'SMS',
  'notifType.push': 'Push Notification',
  'notifType.inApp': 'In-App',

  // ─── Profile Completion Widget ──────────────────────────────────────────
  'profile.completion.title': 'Profile Completion',
  'profile.completion.percentComplete': 'Complete',
  'profile.completion.allServices': 'All Services',
  'profile.completion.configured': 'Configured',
  'profile.completion.incomplete': 'Incomplete',
  'profile.completion.notStarted': 'Not Started',
  'profile.completion.unknown': 'Unknown',
  'profile.completion.completeService': 'Complete {{name}}',
  'profile.completion.configureService': 'Configure {{name}}',
  'profile.completion.noServices': 'No services available',
  'profile.copy.successTitle': 'Copied',
  'profile.copy.successMessage': 'Copied to clipboard',
  'profile.copy.errorTitle': 'Error',
  'profile.copy.errorMessage': 'Failed to copy to clipboard',
  'profile.whatsapp.noNumbers': 'No numbers connected',
  'profile.whatsapp.oneNumber': '{{phone}}',
  'profile.whatsapp.multipleNumbers': '{{count}} numbers connected',
  'profile.stats.contacts': 'Contacts',
  'profile.stats.messagesThisMonth': 'Messages this month',
  'profile.stats.teamMembers': 'Team',
  'profile.facebook.noPagesConnected': 'No pages connected',
  'profile.facebook.onePage': '{{name}}',
  'profile.facebook.connectedPages': '{{count}} pages connected',
  'profile.xtwitter.noAccountsConnected': 'No accounts connected',
  'profile.xtwitter.oneAccount': '{{name}}',
  'profile.xtwitter.connectedAccounts': '{{count}} accounts connected',
  'profile.phone.noAccountConnected': 'No account connected',
  'profile.phone.connectedVia': 'Connected via {{provider}}',

  // ─── Quick Actions ───────────────────────────────────────────────────────
  'quickActions.whatsappCampaign.title': 'WhatsApp Campaign',
  'quickActions.whatsappCampaign.description': 'Send a bulk WhatsApp message',
  'quickActions.addContact.title': 'Add Contact',
  'quickActions.addContact.description': 'Create a new contact',
  'quickActions.products.title': 'Products',
  'quickActions.products.description': 'Manage your product catalog',
  'quickActions.quickReplies.title': 'Quick Replies',
  'quickActions.quickReplies.description': 'Manage saved reply templates',
  'quickActions.orders.title': 'Orders',
  'quickActions.orders.description': 'View and manage orders',
  'quickActions.vendors.title': 'Vendors',
  'quickActions.vendors.description': 'Manage vendors and their products',
  'quickActions.quotations.title': 'Quotations',
  'quickActions.quotations.description': 'Create and send quotations',
  'quickActions.workflows.title': 'Workflows',
  'quickActions.workflows.description': 'Build and manage automated flows',
  'quickActions.templateMessage.title': 'Template Message',
  'quickActions.templateMessage.description': 'Manage WhatsApp message templates',
  'quickActions.calendarSetup.title': 'Calendar Setup',
  'quickActions.calendarSetup.description': 'Manage booking calendars',
  'quickActions.visits.title': 'Visits',
  'quickActions.visits.description': 'Track and execute field visits',
  'quickActions.reports.title': 'Reports',
  'quickActions.reports.description': 'Coming soon',

  // ─── Platform Performance ───────────────────────────────────────────────
  'platformPerformance.title': 'Performance',
  'platformPerformance.contacts': 'Contacts',
  'platformPerformance.conversations': 'Conversations',
  'platformPerformance.messages': 'Messages',
  'platformPerformance.myActive': 'Active',
  'platformPerformance.myCompleted': 'Completed',
  'platformPerformance.myOverdue': 'Overdue',
  'platformPerformance.myTotal': 'Total',
  'platformPerformance.loading': 'Loading performance data...',
  'platformPerformance.empty': 'No performance data available',
  'platformPerformance.messagesOverTime': 'Messages over time',
  'platformPerformance.channelBreakdown': 'Channel breakdown',
  'platformPerformance.whatsapp': 'WhatsApp',
  'platformPerformance.facebook': 'Facebook',
  'platformPerformance.xTwitter': 'X (Twitter)',
  'platformPerformance.chartsTab': 'Charts',
  'platformPerformance.tableTab': 'Table',
  'platformPerformance.datePreset.today': 'Today',
  'platformPerformance.datePreset.7d': 'Last 7 days',
  'platformPerformance.datePreset.30d': 'Last 30 days',
  'platformPerformance.searchAgents': 'Search agent name',
  'platformPerformance.noAgents': 'No agent activity yet',
  'platformPerformance.noAgentMatches': 'No matches',
  'platformPerformance.agentTotal': 'Total',
  'platformPerformance.agentActive': 'Active',
  'platformPerformance.agentCompleted': 'Done',
  'platformPerformance.agentOverdue': 'Overdue',
  'platformPerformance.phone': 'Phone',
  'platformPerformance.callsOverTime': 'Calls over time',
  'platformPerformance.callsTitle': 'Calls',
  'platformPerformance.callsInbound': 'Inbound',
  'platformPerformance.callsOutbound': 'Outbound',
  'platformPerformance.callsAvgDuration': 'Avg. duration',
  'platformPerformance.callOutcomes': 'Call outcomes',
  'platformPerformance.outcomeCompleted': 'Completed',
  'platformPerformance.outcomeNotResponded': 'Not responded',
  'platformPerformance.outcomeCancelled': 'Busy',
  'platformPerformance.outcomeEnded': 'Ended',
  'platformPerformance.outcomeFailed': 'Failed',
  'platformPerformance.noCalls': 'No calls yet',
  'platformPerformance.providerSectionTitle': 'Phone Provider',
  'platformPerformance.providerNotConnected': 'No phone provider connected',
  'platformPerformance.providerCallsTotal': 'Total calls',
  'platformPerformance.providerAvgDuration': 'Avg. duration',

  // ─── Dashboard Analytics ─────────────────────────────────────────────────
  'dashboardAnalytics.campaigns.title': 'Campaign performance',
  'dashboardAnalytics.campaigns.sent': 'Sent',
  'dashboardAnalytics.campaigns.delivered': 'Delivered',
  'dashboardAnalytics.campaigns.read': 'Read',
  'dashboardAnalytics.campaigns.empty': 'No campaigns yet',
  'dashboardAnalytics.campaigns.search': 'Search template name',
  'dashboardAnalytics.campaigns.groupCount': 'campaigns',
  'dashboardAnalytics.campaigns.groupCountOne': 'campaign',
  'dashboardAnalytics.campaigns.viewPerformance': 'View performance',
  'dashboardAnalytics.campaigns.templateOther': 'Other',
  'dashboardAnalytics.campaigns.grouping': 'Grouping by template…',
  'dashboardAnalytics.campaigns.modalSubtitle': 'Template performance',
  'dashboardAnalytics.campaigns.totalCampaigns': 'Campaigns',
  'dashboardAnalytics.campaigns.failed': 'Failed',
  'dashboardAnalytics.campaigns.successRate': 'Success rate',
  'dashboardAnalytics.campaigns.campaignList': 'Campaigns using this template',
  'dashboardAnalytics.campaigns.trendTitle': 'Sent volume trend',
  'dashboardAnalytics.campaigns.searchCampaigns': 'Search campaigns',
  'dashboardAnalytics.campaigns.sortDate': 'Date',
  'dashboardAnalytics.campaigns.sortSent': 'Sent',
  'dashboardAnalytics.campaigns.sortSuccess': 'Success',
  'dashboardAnalytics.campaigns.noMatches': 'No matching campaigns',
  'dashboardAnalytics.workflows.title': 'Workflow executions',
  'dashboardAnalytics.workflows.active': 'Active',
  'dashboardAnalytics.workflows.completed': 'Completed',
  'dashboardAnalytics.workflows.abandoned': 'Abandoned',
  'dashboardAnalytics.workflows.waiting_on_child': 'Active',
  'dashboardAnalytics.workflows.manually_paused': 'Paused',
  'dashboardAnalytics.workflows.empty': 'No workflow activity yet',
  'dashboardAnalytics.workflows.search': 'Search flow name',
  'dashboardAnalytics.actions.title': 'Most active workflow steps',
  'dashboardAnalytics.actions.caption': 'Reflects in-flight and recent sessions, not lifetime totals',
  'dashboardAnalytics.actions.empty': 'No workflow activity yet',
  'dashboardAnalytics.alerts.title': 'System alerts',
  'dashboardAnalytics.alerts.total': 'Total',
  'dashboardAnalytics.alerts.unread': 'Unread',
  'dashboardAnalytics.alerts.empty': 'No alerts',

  // ─── Navigation Tabs ─────────────────────────────────────────────────────
  'tab.home': 'Home',
  'tab.contacts': 'Contacts',
  'tab.calendar': 'Calendar',
  'tab.orders': 'Orders',
  'tab.more': 'More',
  'tab.inbox': 'Inbox',
  'tab.settings': 'Settings',

  // ─── Auth Screens ─────────────────────────────────────────────────────────
  'auth.signIn': 'Sign In',
  'auth.signUp': 'Sign Up',
  'auth.email': 'Email Address',
  'auth.emailPlaceholder': 'Enter your email',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'Enter your password',
  'auth.forgotPassword': 'Forgot your password?',
  'auth.noAccount': "Don't have an account? ",
  'auth.hasAccount': 'Already have an account? ',
  'auth.createAccount': 'Create Account',
  'auth.continue': 'Continue',
  'auth.otpTitle': 'Verify Your Email',
  'auth.otpTitlePhone': 'Verify Your Phone',
  'auth.otpSubtitle': "We've sent a verification code to",
  'auth.resendCode': "Didn't receive the code? Resend",
  'auth.trustThisDevice': 'Remember this device for 30 days',

  // Add/verify identity ("complete your profile" second-auth-method flow)
  'identity.addEmailHeaderTitle': 'Add Email',
  'identity.addMobileHeaderTitle': 'Add Mobile Number',
  'identity.verifyHeaderTitle': 'Verify',
  'identity.addEmailTitle': 'Add Email Address',
  'identity.addMobileTitle': 'Add Mobile Number',
  'identity.addEmailSubtitle': "We'll send a verification code to confirm this email is yours.",
  'identity.addMobileSubtitle': "We'll send a verification code via WhatsApp to confirm this number is yours.",
  'identity.sendCode': 'Send Code',
  'identity.enterCodeTitle': 'Enter Verification Code',
  'identity.enterCodeSubtitleEmail': "We've sent a code to",
  'identity.enterCodeSubtitleMobile': "We've sent a code via WhatsApp to",
  'identity.verify': 'Verify',
  'identity.changeEmail': 'Change email address',
  'identity.changeMobile': 'Change mobile number',
  'identity.resendCodeIn': 'Resend code in {{seconds}}s',
  'identity.requiredTitle': 'Required',
  'identity.requiredEmail': 'Please enter an email address.',
  'identity.requiredMobile': 'Please enter a mobile number.',
  'identity.invalidTitle': 'Invalid',
  'identity.invalidEmail': 'Please enter a valid email address.',
  'identity.invalidMobile': 'Please enter a valid mobile number.',
  'identity.codeSentTitle': 'Code Sent',
  'identity.codeSentEmail': 'A verification code has been sent to your email.',
  'identity.codeSentMobile': 'A verification code has been sent via WhatsApp.',
  'identity.codeResent': 'A new code has been sent.',
  'identity.invalidCodeTitle': 'Invalid Code',
  'identity.invalidCodeMessage': 'Please enter the complete 6-digit verification code.',
  'identity.verifiedTitle': 'Verified',
  'identity.verifiedEmail': 'Your email has been verified.',
  'identity.verifiedMobile': 'Your mobile number has been verified.',
  'auth.resetPassword': 'Reset Password',
  'auth.newPassword': 'New Password',
  'auth.confirmPassword': 'Confirm New Password',
  'auth.forgotTitle': 'Forgot Password?',
  'auth.forgotSubtitle': "Enter your email address and we'll send you a reset code",
  'auth.sendResetEmail': 'Send Reset Email',
  'auth.rememberPassword': 'Remember your password? ',
  'auth.rememberMe': 'Remember me',
  'auth.getStarted': 'Get Started →',
  'auth.welcomeTagline': 'EVERY CONVERSATION. ONE INBOX.',
  'auth.welcomeSubtitle': 'Reply, automate, and grow across WhatsApp, Messenger, and more — all from a single command center built for modern teams.',
  'auth.firstName': 'First Name',
  'auth.firstNamePlaceholder': 'Enter your first name',
  'auth.lastName': 'Last Name',
  'auth.lastNamePlaceholder': 'Enter your last name',
  'auth.phoneNumber': 'Phone Number',
  'auth.phoneNumberPlaceholder': 'Enter your phone number',
  'auth.chooseBusiness': 'Choose a business',
  'auth.addNewBusiness': 'Add new business',
  'auth.createYourOwnBusiness': 'Create your own business account',
  'auth.pendingInvitations': 'Invitations',
  'auth.invitedBy': 'invited by',
  'auth.invitationExpired': 'Invitation expired',
  'auth.choosePlan': 'Choose your plan',
  'auth.trialSubtitle': 'Every plan starts with a free 1-week trial — no payment required now.',
  'auth.startTrial': 'Start free trial',
  'auth.setUpChannels': 'Set up your channels',
  'auth.setUpChannelsSubtitle': 'Connect your channels now, or skip and finish this later from your home screen.',
  'auth.setUpNow': 'Set up',
  'auth.finishForNow': 'Skip for now — go to Home',
  'auth.skipStep': 'Skip this step',
  'auth.channelWhatsApp': 'WhatsApp',
  'auth.channelWhatsAppDescription': 'Connect your WhatsApp Business number.',
  'auth.channelFacebookMessenger': 'Facebook Messenger',
  'auth.channelFacebookMessengerDescription': 'Connect a Facebook Page for Messenger.',
  'auth.channelXTwitter': 'X (Twitter)',
  'auth.channelXTwitterDescription': 'Connect your X account.',
  'auth.channelPhone': 'Phone',
  'auth.channelPhoneDescription': 'Enable calling for your team.',
  'auth.backToSetupSteps': 'Back to setup steps',
  'auth.verified': 'Verified',
  'auth.verificationCode': 'Verification code',
  'auth.verify': 'Verify',
  'auth.sendCode': 'Send code',
  'auth.finish': 'Finish',
  'subscription.popular': 'Popular',
  'subscription.free': 'Free',
  'planSelection.loadFailedTitle': 'Could not load plans',
  'planSelection.loadFailedMessage': 'Please try again.',
  'planSelection.noBusinessTitle': 'No business selected',
  'planSelection.noBusinessMessage': 'Please create or select a business first.',
  'planSelection.trialStartedTitle': 'Trial started',
  'planSelection.trialStartedMessage': 'Your 1-week trial is now active.',
  'planSelection.activateFailedTitle': 'Could not activate trial',
  'planSelection.activateFailedMessage': 'Please try again.',
  'business.details': 'Business details',
  'business.name': 'Business name',
  'business.email': 'Business email',
  'business.industry': 'Industry',
  'industry.select': 'Select your industry',
  'industry.search': 'Search industries…',
  'industry.none': 'No matching industry',
  'industry.otherPlaceholder': 'Type your industry',
  'industry.retail': 'Retail',
  'industry.ecommerce': 'E-commerce',
  'industry.wholesale_distribution': 'Wholesale & distribution',
  'industry.food_beverage': 'Restaurants & cafés',
  'industry.hospitality_travel': 'Hospitality & travel',
  'industry.real_estate': 'Real estate',
  'industry.construction': 'Construction & contracting',
  'industry.manufacturing': 'Manufacturing',
  'industry.healthcare': 'Healthcare & clinics',
  'industry.pharma_medical': 'Pharmacy & medical supplies',
  'industry.beauty_wellness': 'Beauty & wellness',
  'industry.education_training': 'Education & training',
  'industry.automotive': 'Automotive',
  'industry.logistics_shipping': 'Logistics & shipping',
  'industry.professional_services': 'Professional services (legal, accounting, consulting)',
  'industry.technology_software': 'Technology & software',
  'industry.marketing_media': 'Marketing & media',
  'industry.finance_insurance': 'Finance & insurance',
  'industry.events': 'Events',
  'industry.home_services': 'Home services & maintenance',
  'industry.fashion_apparel': 'Fashion & apparel',
  'industry.electronics': 'Electronics',
  'industry.furniture_home': 'Furniture & home',
  'industry.agriculture_food': 'Agriculture & food production',
  'industry.nonprofit': 'Non-profit',
  'industry.other': 'Other',
  'business.description': 'Description (optional)',
  'business.location': 'Business location',
  'business.searchLocation': 'Search for your business location',
  'business.address': 'Address',
  'business.city': 'City',
  'business.country': 'Country',
  'business.picture': 'Business picture',
  'business.phone': 'Business phone',
  'business.createYourBusiness': 'Create your business',
  'common.skipForNow': 'Skip for now',
  'auth.confirmPasswordPlaceholder': 'Confirm your password',
  'auth.createPasswordPlaceholder': 'Create a password',
  'auth.joinSubtitle': 'Join DISLIX and start communicating',
  'auth.backToLogin': 'Back to Login',
  'auth.logout': 'Log out',
  'auth.backToRegistration': 'Back to Registration',
  'auth.backToWelcome': 'Back to Welcome',
  'auth.chooseYourPath': 'Choose your path',
  'auth.welcomeTitle': 'Welcome to DISLIX! 🚀',
  'auth.welcomeDescription': "Choose how you'd like to get started with our business social hub platform",
  'auth.signInDescription': 'Already have an account? Sign in to access your dashboard and continue managing your business communications.',
  'auth.createAccountDescription': 'New to DISLIX? Create your account and start building your business communication hub from scratch.',
  'auth.setPassword': 'Set Your Password',
  'auth.setPasswordSubtitle': 'Create a password to complete your invitation',
  'auth.resetPasswordSubtitle': 'Enter the reset code and create a new password',

  // ─── Validation ───────────────────────────────────────────────────────────
  'validation.required': 'This field is required',
  'validation.emailInvalid': 'Please enter a valid email',
  'validation.passwordMin': 'Password must be at least 6 characters',
  'validation.passwordMatch': 'Passwords do not match',
  'validation.phoneInvalid': 'Please enter a valid phone number',

  // ─── Inbox & Conversations ────────────────────────────────────────────────
  'inbox.title': 'Inbox',
  'inbox.empty': 'No conversations yet',
  'inbox.search': 'Search conversations',
  'inbox.assigned': 'Assigned',
  'inbox.unassigned': 'Unassigned',
  'inbox.open': 'Open',
  'inbox.closed': 'Closed',
  'inbox.pending': 'Pending',
  'inbox.contactAdded': 'Contact Added',
  'inbox.contactAddedDesc': '{{name}} has been added to your contacts',
  'inbox.conversationStarted': 'Conversation Started',
  'inbox.conversationStartedDesc': 'WhatsApp conversation with {{name}} has been initiated',
  'inbox.loadingMore': 'Loading more conversations...',
  'inbox.loadMore': 'Load More',
  'inbox.department': 'Department',
  'inbox.inProgress': 'In Progress',
  'inbox.completed': 'Completed',
  'inbox.completedWithDepartment': '{{department}} • Completed',
  'inbox.locked': 'Locked',
  'inbox.expired': 'Expired',
  'inbox.windowClosed': 'Window Closed',
  'inbox.timeLeftHoursMinutes': '{{hours}}h {{minutes}}m left',
  'inbox.timeLeftMinutes': '{{minutes}}m left',
  'inbox.noSearchResults': 'No conversations match your search',
  'inbox.noChannelResults': 'No {{channel}} conversations found',
  'inbox.noFilterResults': 'No {{filter}} conversations found',
  'inbox.filter.all': 'All',
  'inbox.filter.unread': 'Unread',
  'inbox.filter.active': 'Active',
  'inbox.filter.nearExpiry': 'Near Expiry',
  'inbox.filter.expired': 'Expired',
  // ─── Product vendors ──────────────────────────────────────────────────────
  'productVendors.title': 'Vendors',
  'productVendors.add': 'Add vendor',
  'productVendors.remove': 'Remove vendor',
  'productVendors.empty': 'This product isn\'t linked to any vendor yet.',
  'productVendors.pickerTitle': 'Add vendors',
  'productVendors.pickerConfirm': 'Link selected',
  'productVendors.added': 'Linked to {{count}} vendor(s)',
  'productVendors.addFailed': 'Some vendors could not be linked.',
  'productVendors.removeFailed': 'Could not remove the vendor.',
  'auth.socialLoginFailedTitle': 'Sign-in failed',
  'auth.socialLoginFailedBody': "We couldn't sign you in with that account. Please try again or use your phone or email.",
  'auth.resendCodeIn': 'Resend code in {{seconds}}s',
  // ─── Billing & plans ──────────────────────────────────────────────────────
  'billing.title': 'Billing',
  'billing.choosePlanTitle': 'Choose your plan',
  'billing.changePlanTitle': 'Change plan',
  'billing.choosePlanSubtitle': 'Pick the plan that fits your team. You can change it any time.',
  'billing.choosePlanSubtitleTrial': 'Start free — paid plans include a free trial, no card needed.',
  'billing.choosePlan': 'Choose a plan',
  'billing.changePlan': 'Change plan',
  'billing.currentPlan': 'Current plan',
  'billing.cycle.monthly': 'Monthly',
  'billing.cycle.quarterly': 'Quarterly',
  'billing.cycle.yearly': 'Yearly',
  'billing.per.monthly': 'month',
  'billing.per.quarterly': '3 months',
  'billing.per.yearly': 'year',
  'billing.save': 'Save {{percent}}%',
  'billing.saveVsMonthly': 'Save {{percent}}% vs monthly',
  'billing.free': 'Free',
  'billing.popular': 'Most popular',
  'billing.trialBadge': '{{days}}-day free trial',
  'billing.startFree': 'Start free',
  'billing.startTrial': 'Start {{days}}-day free trial',
  'billing.subscribeFor': 'Subscribe · {{price}}',
  'billing.notOffered': 'Not offered for this period',
  'billing.unavailableTitle': 'Not available in the app',
  'billing.unavailableInApp': "Subscribing to this plan isn't available in the app.",
  'billing.ownerOnly': 'Only the business owner or an admin can change the plan or pay.',
  'billing.plansLoadFailed': "We couldn't load the plans. Check your connection and try again.",
  'billing.keepCurrent': 'Keep my current plan',
  'billing.securityNote': 'Payments are processed securely by Kashier. We never see your card details.',
  'billing.planActivatedTitle': 'Plan activated',
  'billing.trialStarted': 'Your {{days}}-day free trial has started.',
  'billing.freeStarted': "You're on the Free plan.",
  'billing.errorTitle': 'Something went wrong',
  'billing.errorGeneric': 'Please try again.',
  'billing.noPlan': 'No plan yet',
  'billing.status.active': 'Active',
  'billing.status.free': 'Free',
  'billing.status.trial': 'Free trial',
  'billing.status.expired': 'Ended',
  'billing.status.none': 'No plan',
  'billing.trialEnds': 'Trial ends {{date}} ({{days}} days left)',
  'billing.paidUntil': 'Paid until {{date}} ({{days}} days left)',
  'billing.freeForever': 'Free plan — no payment needed',
  'billing.endedOn': 'Ended on {{date}}',
  'billing.payNow': 'Pay now',
  'billing.renew': 'Renew',
  'billing.manualRenewalNote': "Plans don't renew automatically — renew before the end date to avoid interruption.",
  'billing.lockedBody': 'Your subscription has ended, so your workspace is paused. Pay to continue — everything is kept.',
  'billing.lockedBodyNoPay': 'Your subscription has ended, so your workspace is paused. Everything is kept.',
  'billing.history': 'Payment history',
  'billing.paymentStatus.completed': 'Paid',
  'billing.paymentStatus.failed': 'Failed',
  'billing.paymentStatus.refunded': 'Refunded',
  'billing.paymentStatus.pending': 'Pending',
  'billing.paymentStatus.expired': 'Expired',
  'billing.return.checking': 'Confirming your payment…',
  'billing.return.checkingBody': 'This usually takes a few seconds. Please keep this page open.',
  'billing.return.successTitle': 'Payment successful',
  'billing.return.successBody': 'Your plan is active until {{date}}. A receipt was sent to your email.',
  'billing.return.successBodyShort': 'Your plan is active. A receipt was sent to your email.',
  'billing.return.continueSetup': 'Continue setup',
  'billing.return.goToBilling': 'Go to billing',
  'billing.return.failedTitle': "Payment didn't go through",
  'billing.return.failedBody': 'You were not charged. Please try again or use another card.',
  'billing.return.tryAgain': 'Try again',
  'billing.return.pendingTitle': 'Still confirming',
  'billing.return.pendingBody': "We haven't received the confirmation yet. If you paid, your plan will update within a few minutes.",
  'billing.status.grace': 'Renew now',
  'billing.graceLine': 'Ended {{date}} — keeps working until {{lockDate}}',
  'billing.graceBanner': 'Your plan has ended. Everything keeps working for {{days}} more days (until {{date}}) — renew to avoid a pause.',
  'billing.switchBusiness': 'Switch to another business',
  'picker.billing.trialUntil': 'Trial until {{date}}',
  'picker.billing.renewBy': 'Renew by {{date}}',
  'picker.billing.paused': 'Paused',
  'picker.billing.noPlan': 'No plan',
  'picker.delete.action': 'Delete business',
  'picker.delete.title': 'Delete business',
  'picker.delete.message': '"{{name}}" will be removed for you and every member of its team. Type the business name to confirm.',
  'picker.delete.placeholder': 'Business name',
  'picker.delete.done': 'Business deleted',
  'picker.delete.failed': 'Could not delete the business',
  'home.billing.grace': 'Your plan has ended — {{days}} days left to renew before your workspace pauses.',
  'home.billing.ended': 'Your plan has ended and your workspace is paused.',
  'home.billing.trialEnding': 'Your free trial ends in {{days}} days.',
  'home.billing.noPlan': 'Choose a plan to keep using DISLIX.',
  'home.billing.action': 'View',
  'billing.viewInvoice': 'View invoice',
  'billing.emailInvoice': 'Email',
  'billing.invoiceEmailedTitle': 'Invoice sent',
  'billing.invoiceEmailedBody': 'The invoice was emailed to you.',
  'billing.addons.title': 'Add-ons',
  'billing.addons.intro': 'Add more users, products, channels or whole modules to your plan at any time. You pay only for the days left in this billing period; after that they renew with your plan.',
  'billing.addons.yours': 'Your add-ons',
  'billing.addons.capacity': 'More capacity',
  'billing.addons.modules': 'Extra modules',
  'billing.addons.none': 'No add-ons are available for your plan.',
  'billing.addons.youHave': 'currently {{value}}',
  'billing.addons.active': 'active',
  'billing.addons.add': 'Add',
  'billing.addons.added': 'Added',
  'billing.addons.keep': 'Keep',
  'billing.addons.removeAtRenewal': 'Remove at renewal',
  'billing.addons.removedAtRenewal': 'Will be removed at the next renewal',
  'billing.addons.reducedAtRenewal': 'Changes to {{n}} at the next renewal',
  'billing.addons.payToday': '{{amount}} today ({{days}} days left)',
  'billing.addons.thenEach': 'then +{{amount}} / {{period}} with your plan',
  'billing.addons.afterTrial': 'Add-ons are available once you subscribe to a paid plan.',
  'billing.addons.paidOnly': 'Add-ons are available on paid plans.',
  'billing.addons.renewFirst': 'Your plan has ended — renew it first, then add more.',
  'billing.addons.manage': 'Manage',
  'billing.addons.addMore': 'Add more',
  'billing.addons.pitch': 'Need more users, products or a module? Add just what you need.',
  'billing.return.addonsBody': 'Your add-ons are active now. A receipt was sent to your email.',
  'billing.unlimited': 'Unlimited',
  'billing.soon': 'soon',
  // ─── Onboarding ───────────────────────────────────────────────────────────
  'onboarding.channels.title': 'Connect your channels',
  'onboarding.channels.subtitle': 'Connect what you use now — you can add the rest any time from Home.',
  'onboarding.channels.connect': 'Connect',
  'onboarding.channels.connected': 'Connected',
  'onboarding.channels.goToDashboard': 'Go to dashboard',
  'onboarding.channels.skipForNow': 'Skip for now',
  'onboarding.channels.laterHint': 'Channels can be connected later from Settings.',
  'business.industryPlaceholder': 'e.g. Pharmacy, Retail, Clinic',
  'business.phoneOptional': 'Business phone (optional)',
  'business.extrasTitle': 'Logo & location',
  'business.extrasSubtitle': 'Optional — helps customers recognise you. You can add these later.',
  'business.addLogo': 'Add logo',
  'business.createBusiness': 'Create business',
  'business.skipAndCreate': 'Skip and create',
  'business.createFailed': 'Could not create the business',
  'business.createdTitle': 'Business created',
  'business.signInAgain': 'Please choose your business to continue.',
  'business.photoPermissionTitle': 'Permission needed',
  'business.photoPermissionBody': 'Allow photo access to add your business logo.',
  // ─── Home dashboard ───────────────────────────────────────────────────────
  'home.range.today': 'Today',
  'home.range.week': '7 days',
  'home.range.month': '30 days',
  'home.setup.title': 'Finish setting up your workspace',
  'home.setup.action': 'Continue',
  'setup.title': 'Get your business ready',
  'setup.subtitle': 'A few first steps so your team can start selling. Do them in any order — this list stays on Home until you finish.',
  'setup.progress': '{{done}} of {{total}} done',
  'setup.next': 'Next: {{step}}',
  'setup.start': 'Start',
  'setup.done': 'Done',
  'setup.dismiss': 'Hide',
  'setup.allDone': 'Your business is ready.',
  'setup.section.channels': 'Channels',
  'setup.section.account': 'Your account',
  'setup.section.customers': 'Customers',
  'setup.section.catalogue': 'Catalogue',
  'setup.section.team': 'Team',
  'setup.section.sales': 'Sales',
  'setup.section.calendar': 'Calendar',
  'setup.step.businessSettings.title': 'Set your hours & currency',
  'setup.step.businessSettings.description': 'Timezone, currency, working days and hours.',
  'setup.step.calendars.title': 'Create your booking calendar',
  'setup.step.calendars.description': 'Let customers book times within your working hours.',
  'setup.step.channels.title': 'Connect a channel',
  'setup.step.channels.description': 'WhatsApp, Messenger, X or phone — where your customers reach you.',
  'setup.step.identity_email.title': 'Add your email',
  'setup.step.identity_email.description': 'For account recovery and notifications.',
  'setup.step.identity_mobile.title': 'Add your mobile number',
  'setup.step.identity_mobile.description': 'For WhatsApp login and account recovery.',
  'setup.step.contacts.title': 'Add your contacts',
  'setup.step.contacts.description': 'Import a spreadsheet or add customers one by one.',
  'setup.step.catalogues.title': 'Create a category',
  'setup.step.catalogues.description': 'Group your products into catalogues customers can browse.',
  'setup.step.products.title': 'Add products',
  'setup.step.products.description': 'Prices, photos and stock for what you sell.',
  'setup.step.vendors.title': 'Add a vendor',
  'setup.step.vendors.description': 'Who supplies your products.',
  'setup.step.team.title': 'Invite your team',
  'setup.step.team.description': 'Add the people who will chat, sell and visit.',
  'setup.step.departments.title': 'Create a department',
  'setup.step.departments.description': 'Route conversations and work to the right team.',
  'setup.step.quotations.title': 'Send your first quotation',
  'setup.step.quotations.description': 'Price an offer for a customer.',
  'setup.step.orders.title': 'Create your first order',
  'setup.step.orders.description': 'Record a sale for a customer.',
  'home.attention.title': 'Needs attention',
  'home.attention.allClear': "All caught up — nothing needs you right now.",
  'home.attention.needsResponse': 'Awaiting reply',
  'home.attention.expiringSoon': 'Reply window closing',
  'home.attention.followUpDue': 'Follow-ups due',
  'home.attention.overdueAssignments': 'Overdue assignments',
  'home.attention.visitsToday': 'Visits today',
  'home.attention.visitsOverdue': 'Overdue visits',
  'home.attention.eventsToday': 'Events today',
  'home.attention.pendingOrders': 'Pending orders',
  'home.attention.expiringQuotations': 'Quotes expiring soon',
  'home.kpi.title': 'Performance',
  'home.kpi.messages': 'Messages sent',
  'home.kpi.received': '{{count}} received',
  'home.kpi.reached': 'Customers reached',
  'home.kpi.calls': 'Calls',
  'home.kpi.callsDetail': '{{answered}} answered · {{talk}} talk',
  'home.kpi.visits': 'Visits',
  'home.kpi.visitsDetail': '{{completed}} completed · {{open}} open',
  'home.kpi.orders': 'Orders',
  'home.kpi.quotations': 'Quotations',
  'home.kpi.quotationsDetail': '{{accepted}} accepted',
  'home.agenda.title': 'Your day',
  'home.agenda.empty': 'Nothing else scheduled for today.',
  'home.agenda.visit': 'Visit',
  'home.agenda.event': 'Event',
  'home.trend.title': 'Activity trend',
  'home.trend.messages': 'Messages',
  'home.trend.calls': 'Calls',
  'home.trend.visits': 'Visits',
  'home.team.title': 'Team activity',
  'home.team.viewReports': 'View reports',
  'home.team.stats': '{{messages}} msgs · {{calls}} calls · {{visits}} visits',
  'home.shortcuts.title': 'Shortcuts',
  'home.loadError': "Couldn't load your dashboard. Pull down to retry.",
  'outreachGuidance.title': 'Who to contact next',
  'outreachGuidance.expiringSoon.title': 'Expiring soon',
  'outreachGuidance.expiringSoon.subtitle': '{{count}} contacts are about to miss their reply window or go overdue',
  'outreachGuidance.needsResponse.title': 'Needs a response',
  'outreachGuidance.needsResponse.subtitle': '{{count}} contacts are waiting on a reply from you',
  'outreachGuidance.followUpDue.title': 'Follow-up due',
  'outreachGuidance.followUpDue.subtitle': '{{count}} contacts haven\'t heard back in {{days}}+ days',
  'outreachGuidance.neverContacted.title': 'Never contacted',
  'outreachGuidance.neverContacted.subtitle': '{{count}} contacts have never been messaged on any channel',
  'outreachGuidance.neverContacted.navigateHint': '{{count}} contact(s) have never been messaged on any channel',
  'inbox.channel.allChannels': 'All Channels',
  'inbox.channel.whatsapp': 'WhatsApp',
  'inbox.channel.facebook': 'Facebook',
  'inbox.channel.telegram': 'Telegram',
  'inbox.channel.xTwitter': 'X (Twitter)',
  'inbox.channel.email': 'Email',
  'inbox.groupByContact': 'Group by contact',
  'inbox.emptyUnified': 'Your unified inbox is empty. Start a conversation on any connected channel!',
  'inbox.error.businessRequiredTitle': 'Business Required',
  'inbox.error.businessRequiredMessage': 'Please select a business to view conversations',
  'inbox.error.apiErrorTitle': 'API Error',
  'inbox.error.requestFailedWithStatus': 'Request failed with status {{status}}',
  'inbox.error.networkErrorTitle': 'Network Error',
  'inbox.error.networkErrorMessage': 'Please check your connection and try again',
  'inbox.error.genericTitle': 'Error',
  'inbox.error.loadFailed': 'Failed to load conversations',
  'inbox.noMessagesYet': 'No messages yet',
  'inbox.templateMessageSent': '📋 Template message sent',

  // ─── Chat ─────────────────────────────────────────────────────────────────
  'chat.typeMessage': 'Type a message...',
  'chat.send': 'Send',
  'chat.reply': 'Reply',
  'chat.forward': 'Forward',
  'chat.delete': 'Delete',
  'chat.copy': 'Copy',
  'chat.today': 'Today',
  'chat.yesterday': 'Yesterday',
  'chat.voiceNote': 'Voice Note',
  'chat.document': 'Document',
  'chat.image': 'Image',
  'chat.video': 'Video',
  'chat.assignTo': 'Assign to',
  'chat.closeConversation': 'Close Conversation',
  'chat.reopenConversation': 'Reopen Conversation',
  'chat.camera': 'Camera',
  'chat.gallery': 'Gallery',
  'chat.audio': 'Audio',
  'chat.location': 'Location',
  'chat.sendMedia': 'Send Media',
  'chat.replyingTo': 'Replying to {{name}}',
  'chat.templateMessage': 'Template message',
  'chat.isTyping': '{{name}} is typing...',
  'chat.you': 'You',
  'chat.contact': 'Contact',
  'chat.errorLoadingQuickReplies': 'Failed to load quick reply sets',
  'chat.quickReplySent': 'Quick reply set sent successfully',
  'chat.quickReplySendFailed': 'Failed to send quick reply set',
  'chat.errorLoadingCatalogues': 'Failed to load catalogues',
  'chat.catalogueSent': 'Catalog sent successfully',
  'chat.catalogueSendFailed': 'Failed to send catalog',
  'chat.conversationIdRequired': 'Conversation ID is required',
  'chat.searchStickers': 'Search stickers...',
  'chat.searchQuickReplies': 'Search sets...',
  'chat.searchCatalogs': 'Search catalogs...',
  'chat.interactiveReply': 'Interactive reply',
  'chat.quotedMessage': 'Quoted message',
  'chat.previousMessage': 'Previous message',
  'chat.unknownContact': 'Unknown Contact',
  'chat.noPhoneNumber': 'No phone number',
  'chat.sharedLocation': 'Shared location',
  'chat.sharedContact': 'Shared contact',
  'chat.openLink': 'Open link',
  'chat.replyLabel': 'Reply',
  'chat.copyLabel': 'Copy',
  'chat.shareLabel': 'Share',
  'chat.forwardLabel': 'Forward',
  'chat.contactLabel': 'Contact',
  'chat.imagePlaceholder': 'Image',
  'chat.pdfLoadError': 'Could not load PDF',
  'chat.pdfLoading': 'Loading PDF\u2026',
  'chat.pdfRetry': 'Retry',
  'chat.previewUnavailable': 'Preview not available',
  'chat.previewUnavailableHint': "This document type can\u2019t be previewed in the browser. Use the app on your phone to view it.",
  'chat.sticker': 'Sticker',
  'chat.message': 'Message',
  'chat.interactiveMessage': 'Interactive message',
  'chat.optionsSent': 'Options sent',
  'chat.showOptions': 'Show Options',
  'chat.hideOptions': 'Hide Options',
  'chat.deliveryFailedTitle': 'Delivery Failed',
  'chat.deliveryFailedGeneric': 'This message could not be delivered.',
  'chat.deliveryThrottledExplanation': "WhatsApp suppressed this message to protect delivery health — this contact hasn't been engaging with recent messages. Resending right away is unlikely to work and may delay recovery further. Wait a while before trying again, or reach them another way.",

  // ─── Cards ────────────────────────────────────────────────────────────────
  'card.catalog': 'Catalog',
  'card.catalogProducts': '{{count}} products',
  'card.catalogProduct': '{{count}} product',
  'card.viewCatalog': 'View catalog',
  'card.product': 'Product',
  'card.view': 'View',
  'card.sale': 'Sale',
  'card.viewAndOrder': 'View & order',
  'card.inProducts': 'In products',
  'card.quickReply': 'Quick reply',
  'card.selectedOption': 'Selected option',
  'card.calendarEvent': 'Calendar event',
  'card.eventStart': 'Start: ',
  'card.eventEnd': 'End: ',
  'card.eventStatus': 'Status: ',
  'card.viewEvent': 'View event',
  'card.eventStatusTitle': 'Event status',
  'card.selectNewStatus': 'Select new status',
  'card.cancel': 'Cancel',
  'card.statusScheduled': 'Scheduled',
  'card.statusInProgress': 'In progress',
  'card.statusCompleted': 'Completed',
  'card.statusCancelled': 'Cancelled',
  'card.order': 'Order',
  'card.orderStatus': 'Order status',
  'card.orderNotes': 'Order notes',
  'card.ok': 'OK',
  'card.viewOrder': 'View order',
  'card.modifyOrder': 'Modify',
  'card.orderTotal': 'Total: ',
  'card.orderStatusLabel': 'Status: ',
  'card.orderPayment': ' · Payment: ',
  'card.statusTitle': 'Status',
  'card.orderPlacedDesc': 'Confirm or cancel below',
  'card.orderConfirmedDesc': 'Track your order',
  'card.orderCancelledDesc': 'No further action',
  'card.orderPlaced': 'Order placed',
  'card.orderConfirmed': 'Order confirmed',
  'card.orderCancelledTitle': 'Order cancelled',
  'card.statusPending': 'Pending',
  'card.statusPlaced': 'Placed',
  'card.statusConfirmedOrder': 'Confirmed',
  'card.statusProcessing': 'Processing',
  'card.statusShipped': 'Shipped',
  'card.statusDelivered': 'Delivered',
  'card.statusCancelledOrder': 'Cancelled',
  'card.paymentUnpaid': 'Unpaid',
  'card.paymentPartial': 'Partial',
  'card.paymentPaid': 'Paid',
  'card.paymentRefunded': 'Refunded',
  'card.customer': 'Customer',
  'card.confirmedOrder': '{{name}} confirmed the order',
  'card.cancelledOrder': '{{name}} cancelled the order',
  'card.orderCopied': 'Copied',
  'card.orderCopiedDesc': 'Order number copied to clipboard',
  'card.orderCopyFailed': 'Copy failed',
  'card.orderCopyFailedDesc': 'Could not copy to clipboard',
  'card.statusUpdated': 'Status updated',
  'card.orderStatusUpdated': 'Order status set to {{status}}',
  'card.eventStatusUpdated': 'Event status set to {{status}}',
  'card.paymentUpdated': 'Payment updated',
  'card.paymentStatusUpdated': 'Payment status set to {{status}}',
  'card.updateFailed': 'Update failed',
  'card.updateOrderFailed': 'Could not update order status',
  'card.updatePaymentFailed': 'Could not update payment status',
  'card.updateEventFailed': 'Could not update event status',

  // ─── Conversation ─────────────────────────────────────────────────────────
  'conversation.engagementCooldownTitle': 'This contact recently blocked delivery',
  'conversation.deliveryRetry.title': 'Automatic WhatsApp delivery retry',
  'conversation.deliveryRetry.enable': 'Enable automatic retry',
  'conversation.deliveryRetry.stop': 'Stop automatic retry',
  'conversation.deliveryRetry.next': 'Next check',
  'conversation.deliveryRetry.hint': 'Checks hourly and retries the latest failed template when the cooldown allows. Stops when delivery is confirmed. Changing marketing templates does not remove this restriction.',
  'conversation.deliveryRetry.state.scheduled': 'Retry scheduled',
  'conversation.deliveryRetry.state.cooldown': 'Waiting for the delivery cooldown',
  'conversation.deliveryRetry.state.sending': 'Retry in progress',
  'conversation.deliveryRetry.state.awaiting_delivery': 'Accepted by WhatsApp; waiting for delivery confirmation',
  'conversation.deliveryRetry.state.delivered': 'Delivered; automatic retry stopped',
  'conversation.deliveryRetry.state.cancelled': 'Automatic retry stopped',
  'conversation.deliveryRetry.state.stopped': 'Stopped because the contact or channel changed',
  'conversation.deliveryRetry.state.needs_review': 'Stopped; this message needs review',
  'conversation.engagementCooldownSubtext': "WhatsApp is suppressing messages to protect delivery health. Sending now is unlikely to succeed — wait before trying, or reach them another way.",
  'conversation.loadFailed': 'Failed to load conversation',
  'conversation.messageLoadFailed': 'Failed to load messages',
  'conversation.archived': 'Archived',
  'conversation.archivedDesc': 'Conversation has been archived',
  'conversation.archiveFailed': 'Failed to archive conversation',
  'conversation.forwardMessage': 'Forward Message',
  'conversation.copied': 'Copied',
  'conversation.copiedDesc': 'Message copied to clipboard',
  'conversation.shared': 'Share',
  'conversation.sharedDesc': 'Sharing options opened',
  'conversation.starred': 'Starred',
  'conversation.starredDesc': 'Message starred',
  'conversation.contactUpdated': 'Contact Updated',
  'conversation.contactUpdatedDesc': '{{name}} has been updated',
  'conversation.windowReopened': 'Window Reopened',
  'conversation.windowReopenedDesc': 'You can now send regular messages',
  'conversation.templateSent': 'Template Sent',
  'conversation.templateSentDesc': 'The conversation window has been reopened',
  'conversation.messageSent': 'Message sent',
  'conversation.messageSentDesc': 'You can now send regular messages',
  'conversation.sendFailed': 'Failed to Send',
  'conversation.messageError': 'Message Error',
  'conversation.messageErrorDesc': 'Failed to prepare message for sending',
  'conversation.audioFailed': 'Audio Message Failed',
  'conversation.audioFailedDesc': 'Failed to send audio message. The audio file may be corrupted or deleted.',
  'conversation.imageFailed': 'Image Message Failed',
  'conversation.imageFailedDesc': 'Failed to send image message. The image file may be corrupted or deleted.',
  'conversation.videoFailed': 'Video Message Failed',
  'conversation.videoFailedDesc': 'Failed to send video message. The video file may be corrupted or deleted.',
  'conversation.documentFailed': 'Document Message Failed',
  'conversation.documentFailedDesc': 'Failed to send document message. The document file may be corrupted or deleted.',
  'conversation.messageFailed': 'Message Failed',
  'conversation.messageFailedDesc': 'Failed to send message. Please try again.',
  'conversation.audioFileIssue': 'Audio File Issue',
  'conversation.audioFileIssueDesc': 'This audio file may be corrupted or deleted. Please try recording again.',
  'conversation.imageFileIssue': 'Image File Issue',
  'conversation.imageFileIssueDesc': 'This image file may be corrupted or deleted. Please try selecting another image.',
  'conversation.videoFileIssue': 'Video File Issue',
  'conversation.videoFileIssueDesc': 'This video file may be corrupted or deleted. Please try selecting another video.',
  'conversation.documentFileIssue': 'Document File Issue',
  'conversation.documentFileIssueDesc': 'This document file may be corrupted or deleted. Please try selecting another document.',
  'conversation.fileUploadError': 'File Upload Error',
  'conversation.fileUploadErrorDesc': 'The file could not be uploaded. Please try again.',
  'conversation.loadingMoreMessages': 'Loading more messages...',
  'conversation.online': 'Online',
  'conversation.discussionArchived': 'This discussion has been archived',
  'conversation.discussionSpam': 'This discussion has been marked as spam',
  'conversation.noNewMessages': 'No new messages can be sent to this conversation',
  'conversation.windowClosed': '24-hour messaging window has closed',
  'conversation.cannotReopen': 'This conversation can no longer be reopened',
  'conversation.messagePlaceholderWithName': 'Message {{name}}...',
  'conversation.sendAMessage': 'Send a message…',
  'conversation.groupActions': 'Actions',
  'conversation.viewContact': 'View Contact',
  'conversation.copyNumber': 'Copy Number',
  'conversation.call': 'Call',
  'conversation.noPhoneNumber': 'No phone number available for this contact',
  'conversation.assignTo': 'Assign To',
  'conversation.notes': 'Notes',
  'conversation.assignedTo': 'Assigned to {{name}}',
  'conversation.unassigned': 'Unassigned',
  'conversation.noContactToView': 'No contact to view',
  'conversation.loadContactFailed': 'Failed to load contact',
  'conversation.copiedTitle': 'Copied',
  'conversation.numberCopied': 'Phone number copied to clipboard',
  'conversation.copyFailed': 'Failed to copy phone number',
  'conversation.addNoteFailed': 'Failed to add note',
  'conversation.deleteNoteFailed': 'Failed to delete note',

  // Call History
  'callHistory.title': 'Call History',
  'callHistory.noCalls': 'No calls yet',
  'callHistory.selectCallHint': 'Select a call to see details',
  'callHistory.callBack': 'Call Back',
  'callHistory.incoming': 'Incoming',
  'callHistory.outgoing': 'Outgoing',
  'callHistory.incomingCall': 'Incoming Call',
  'callHistory.outgoingCall': 'Outgoing Call',
  'callHistory.status.completed': 'Completed',
  'callHistory.status.notResponded': 'Not responded',
  'callHistory.status.cancelled': 'Busy',
  'callHistory.status.ended': 'Ended',
  'callHistory.status.failed': 'Failed',
  'callHistory.status.ringing': 'Ringing…',
  'callHistory.status.answered': 'Answered',
  'callHistory.details.duration': 'Duration',
  'callHistory.details.started': 'Started',
  'callHistory.details.ended': 'Ended',
  'callHistory.details.number': 'Number',
  'callHistory.details.provider': 'Provider',
  'callHistory.recording.label': 'Recording',
  'callHistory.recording.play': 'Play recording',
  'callHistory.recording.loading': 'Loading recording…',
  'callHistory.recording.unavailable': 'No recording available for this call',
  'callHistory.recording.retry': 'Failed to load — retry',
  'callHistory.details.title': 'Call Details',
  'callHistory.outcome.label': 'Outcome',
  'callHistory.outcome.record': 'Record outcome',
  'callHistory.outcome.recorded': 'Recorded',
  'reports.title': 'Reports',
  'reports.noAccess': "You don't have access to reports.",
  'reports.noData': 'No data for the selected filters.',
  'reports.tabs.messages': 'Messages',
  'reports.tabs.calls': 'Calls',
  'reports.tabs.visits': 'Visits',
  'reports.tabs.performance': 'Performance',
  'reports.group.visits': '{{count}} visits · {{completed}} done',
  'reports.group.missed': '{{count}} missed',
  'reports.group.calls': '{{count}} calls · {{answered}} answered',
  'reports.group.messages': '{{count}} messages',
  'reports.groupByContact': 'Group by contact',
  'reports.performance.activity': 'Activity',
  'reports.performance.activityHint': 'Counted the same way as the All tab. All messages = sent by agents (replies and broadcasts) + received from customers + automated (flows, auto-replies). With an agent filter, only messages sent by that agent count. Customers reached = distinct people messaged or called.',
  'reports.performance.messagesSent': 'Messages sent',
  'reports.kpi.messagesTotal': 'All messages',
  'reports.performance.messagesAutomated': 'Automated',
  'reports.performance.messagesReceived': 'Received',
  'reports.performance.messagesTotal': 'All messages',
  'reports.performance.callsMade': 'Calls',
  'reports.kpi.callTimeTotal': 'Total call time',
  'reports.performance.col.callTimeTotal': 'Total call time',
  'reports.performance.callTimeTotal': 'Total call time',
  'reports.performance.talkTimeTotal': 'Talk time (connected)',
  'reports.performance.col.talkTimeTotal': 'Talk time',
  'reports.kpi.talkTimeTotal': 'Talk time (connected)',
  'reports.performance.visitsCount': 'Visits',
  'reports.performance.customersReached': 'Customers reached',
  'reports.performance.assignmentsHint': 'New assignments: contacts assigned during the period by someone else (a manager, an auto-assignment rule or a department pool). Conversations or contacts agents open themselves are not assignments.',
  'reports.performance.col.messagesSent': 'Messages sent',
  'reports.performance.col.calls': 'Calls',
  'reports.performance.col.customersReached': 'Customers reached',
  'reports.kpi.messagesSent': 'Messages sent',
  'reports.kpi.customersReached': 'Customers reached',
  'reports.kpi.avgResponse': 'Avg response',
  'reports.kpi.medianResponse': 'Median response',
  'reports.kpi.unanswered': 'Unanswered',
  'reports.kpi.answerRate': 'Call answer rate',
  'reports.kpi.avgRing': 'Avg ring time',
  'reports.kpi.avgCallback': 'Avg callback',
  'reports.kpi.visitCompletion': 'Visit completion',
  'reports.kpi.avgServing': 'Avg serving time',
  'reports.kpi.firstTouch': 'Assign → first touch',
  'reports.filters.contactsSelected': '{{count}} contacts',
  'reports.filters.agentsSelected': '{{count}} selected',
  'reports.filters.clearSelection': 'Clear',
  'reports.filters.done': 'Done',
  'reports.filters.doneCount': 'Done ({{count}})',
  'reports.filters.departments': 'Departments',
  'reports.filters.agents': 'Agents',
  'reports.duration.s': 's',
  'reports.duration.m': 'm',
  'reports.duration.h': 'h',
  'reports.duration.d': 'd',
  'reports.performance.note': 'Real elapsed times (wall clock) for the selected period and filters — average first, then median, slowest 10% (P90) and range.',
  'reports.performance.computedAt': 'Calculated {{time}}.',
  'reports.performance.median': 'Median',
  'reports.performance.p90': 'P90',
  'reports.performance.range': 'Range',
  'reports.performance.samples': '{{count}} samples',
  'reports.performance.messages': 'Messages',
  'reports.performance.replied': 'Conversations replied',
  'reports.performance.unanswered': 'Conversations waiting',
  'reports.performance.responseTime': 'Response time',
  'reports.performance.responseTimeHint': 'Measured per conversation turn: customer message(s) → first agent reply',
  'reports.performance.firstResponseTime': 'First response time',
  'reports.performance.firstResponseTimeHint': 'First customer message of each conversation in the period → first reply',
  'reports.performance.calls': 'Calls',
  'reports.performance.answered': 'Answered',
  'reports.performance.missedInbound': 'Missed',
  'reports.performance.calledBack': 'Called back',
  'reports.performance.notCalledBack': 'Not called back',
  'reports.performance.answerRate': 'Answer rate',
  'reports.performance.callbackTime': 'Callback time',
  'reports.performance.callbackTimeHint': 'Missed call → next call to that customer',
  'reports.performance.talkTime': 'Talk time',
  'reports.performance.ringTime': 'Ring time (answered)',
  'reports.performance.ringTimeHint': 'Started ringing → answered',
  'reports.performance.unansweredRingTime': 'Ring time (unanswered)',
  'reports.performance.unansweredRingTimeHint': 'How long unanswered calls rang before hang-up',
  'reports.performance.col.avgRing': 'Avg ring',
  'reports.performance.visits': 'Visits',
  'reports.performance.completed': 'Completed',
  'reports.performance.inProgress': 'In progress',
  'reports.performance.open': 'Open',
  'reports.performance.missedVisits': 'Missed',
  'reports.performance.completionRate': 'Completion rate',
  'reports.performance.assignmentToStart': 'Assignment → start',
  'reports.performance.startDelay': 'Start vs scheduled',
  'reports.performance.startDelayHint': 'Positive = late, negative = early',
  'reports.performance.servingTime': 'Serving time',
  'reports.performance.servingTimeHint': 'Visit start → end',
  'reports.performance.assignments': 'Assignments',
  'reports.performance.currentlyAssigned': 'Assigned now',
  'reports.performance.reachedInPeriod': 'Reached in period',
  'reports.performance.notReachedInPeriod': 'Not reached in period',
  'reports.performance.currentlyAssignedHint': 'Contacts assigned to the agent right now, whenever they were assigned (same as the Contacts screen filter). Reached = the agent messaged, called or visited them in the selected period.',
  'reports.performance.newAssignments': 'New assignments in this period: {{count}}',
  'reports.performance.col.assignedReached': 'Assigned reached',
  'reports.performance.contacted': 'Contacted',
  'reports.performance.notContacted': 'Not contacted yet',
  'reports.performance.timeToFirstInteraction': 'Assignment → first interaction',
  'reports.performance.timeToFirstInteractionHint': 'First message, call or visit by the assigned agent',
  'reports.performance.byAgent': 'By agent',
  'reports.performance.unassigned': 'Unassigned',
  'reports.performance.col.agent': 'Agent',
  'reports.performance.col.replies': 'Replies',
  'reports.performance.col.avgResponse': 'Avg response',
  'reports.performance.col.unanswered': 'Unanswered',
  'reports.performance.col.callsAnswered': 'Calls answered',
  'reports.performance.col.missed': 'Missed calls',
  'reports.performance.col.avgCallback': 'Avg callback',
  'reports.performance.col.visitsDone': 'Visits done',
  'reports.performance.col.assignToStart': 'Assign → start',
  'reports.performance.col.avgServing': 'Avg serving',
  'reports.performance.col.assignContacted': 'Assigned contacted',
  'reports.performance.col.firstInteraction': 'Assign → first touch',
  'reports.datePreset.today': 'Today',
  'reports.datePreset.7d': 'Last 7 days',
  'reports.datePreset.30d': 'Last 30 days',
  'reports.datePreset.custom': 'Custom',
  'reports.filters.startDate': 'Start date',
  'reports.filters.endDate': 'End date',
  'reports.filters.contactId': 'Contact ID',
  'reports.filters.actionType': 'Action / type',
  'reports.filters.allTypes': 'All types',
  'reports.filters.allContacts': 'All contacts',
  'reports.filters.contact': 'Contact',
  'reports.filters.searchContacts': 'Search contacts by name or phone...',
  'reports.filters.noContactsFound': 'No contacts found.',
  'reports.filters.allTemplates': 'All templates',
  'reports.filters.template': 'Template',
  'reports.filters.allStatuses': 'All statuses',
  'reports.filters.callStatus': 'Call status',
  'reports.filters.visitStatus': 'Visit status',
  'reports.tabs.all': 'All',
  'reports.sort.title': 'Sort by',
  'reports.sort.time': 'Time',
  'reports.sort.name': 'Name',
  'reports.sort.status': 'Status',
  'reports.filters.user': 'Agent',
  'reports.filters.allUsers': 'All agents',
  'reports.filters.searchUsers': 'Search agents by name or email...',
  'reports.filters.noUsersFound': 'No agents found.',
  'reports.openConversation': 'Open conversation',
  'reports.grouped.messageCount': 'Messages',
  'reports.grouped.lastMessage': 'Last message',
  'reports.filters.channel': 'Channel',
  'reports.selectRowHint': 'Select a row to view details.',
  'reports.export.title': 'Export report',
  'reports.export.csv': 'Export CSV',
  'reports.export.excel': 'Export Excel',
  'reports.export.pdf': 'Export PDF',
  'reports.kpi.messages': 'Messages',
  'reports.kpi.inbound': 'Inbound',
  'reports.kpi.outbound': 'Outbound',
  'reports.kpi.calls': 'Calls',
  'reports.kpi.completedCalls': 'Completed calls',
  'reports.kpi.visits': 'Visits',
  'reports.kpi.completedVisits': 'Completed visits',
  'reports.charts.messageVolume': 'Message volume',
  'reports.charts.callVolume': 'Call volume',
  'reports.charts.visitVolume': 'Visit volume',
  'reports.charts.typeBreakdown': 'By type',
  'reports.charts.channelBreakdown': 'By channel',
  'reports.charts.outcomeBreakdown': 'By outcome',
  'reports.calls.play': 'Play',
  'reports.calls.noRecording': 'No recording',
  'reports.calls.recordingError': 'Failed to load',
  'reports.calls.direction': 'Direction',
  'reports.calls.status': 'Status',
  'reports.calls.duration': 'Duration',
  'reports.calls.startedAt': 'Started at',
  'reports.calls.answeredAt': 'Answered at',
  'reports.calls.endedAt': 'Ended at',
  'reports.break.label': 'Break before',
  'reports.break.before': 'Break {{time}} before',
  'reports.break.firstOfDay': 'First action of the day',
  'reports.performance.breakTotal': 'Total break time',
  'reports.performance.breakTime': 'Break between actions',
  'reports.performance.breakTimeHint': 'From the end of one call or message thread to the start of the next, same day. Messages in a row to the same contact are one thread.',
  'reports.performance.col.avgBreak': 'Avg break',
  'reports.visits.priority': 'Priority',
  'reports.visits.scheduledFor': 'Scheduled For',
  'reports.visits.startedAt': 'Started At',
  'reports.visits.endedAt': 'Ended At',
  'reports.visits.minutes': 'min',
  'reports.visits.outcome': 'Outcome',
  'reports.saved.title': 'Saved Reports',
  'reports.saved.empty': 'No saved reports yet.',
  'reports.saved.template': 'Template',
  'reports.save.title': 'Save Report',
  'reports.save.namePlaceholder': 'Report name',
  'reports.save.asTemplate': 'Save as a shared template',
  'conversation.notesTitle': 'Contact Notes',
  'conversation.notesPlaceholder': 'Write a note about this contact...',
  'conversation.newNotesIndicator': 'New notes',

  // ─── Assignment ───────────────────────────────────────────────────────────
  'assignment.started': 'Assignment Started',
  'assignment.startedDesc': 'Assignment status updated.',
  'assignment.startFailed': 'Start Failed',
  'assignment.startFailedDesc': 'Failed to start assignment.',
  'assignment.transferred': 'Assignment Transferred',
  'assignment.transferredDesc': 'Assignment transferred successfully.',
  'assignment.transferFailed': 'Transfer Failed',
  'assignment.transferFailedDesc': 'Failed to transfer assignment.',
  'assignment.completed': 'Assignment Completed',
  'assignment.completedDesc': 'Assignment marked as completed.',
  'assignment.completeFailed': 'Complete Failed',
  'assignment.completeFailedDesc': 'Failed to complete assignment.',
  'assignment.cancelled': 'Assignment Cancelled',
  'assignment.cancelledDesc': 'Assignment cancelled successfully.',
  'assignment.cancelFailed': 'Cancel Failed',
  'assignment.cancelFailedDesc': 'Failed to cancel assignment.',
  'assignment.modal.assignContact': 'Assign Contact',
  'assignment.modal.assignFailed': 'Failed to update assignment.',
  'assignment.modal.loadingAssignments': 'Loading assignments...',
  'assignment.modal.users': 'Users',
  'assignment.modal.selectUsers': 'Select one or more users',
  'assignment.modal.loadingUsers': 'Loading users...',
  'assignment.modal.noUsers': 'No users available',
  'assignment.modal.departments': 'Departments',
  'assignment.modal.selectDepartments': 'Select one or more departments',
  'assignment.modal.loadingDepartments': 'Loading departments...',
  'assignment.modal.noDepartments': 'No departments available',
  'assignment.overlay.startTitle': 'Tap to start assignment',
  'assignment.overlay.startSubtitle': 'This conversation has an active assignment waiting to begin.',
  'assignment.action.start': 'Start assignment',
  'assignment.action.transfer': 'Transfer assignment',
  'assignment.action.complete': 'Complete assignment',
  'assignment.action.cancel': 'Cancel assignment',
  'assignment.transfer.title': 'Transfer Assignment',
  'assignment.transfer.subtitle': 'Choose a user or department to transfer this assignment to',
  'assignment.manage.title': 'Manage Assignment',
  'assignment.manage.subtitle': 'Assign this conversation to users or departments',

  // ─── Settings Content (Left Pane) ───────────────────────────────────────
  'settings.items.profile.title': 'Profile & Preferences',
  'settings.items.profile.description': 'Update your personal info, timezone, and notification tone.',
  'settings.items.phone.title': 'Phone Numbers',
  'settings.items.phone.description': 'Manage your phone numbers and verification status.',
  'settings.items.notifications.title': 'Alerts & Notifications',
  'settings.items.notifications.description': 'Choose how you get notified about campaigns and chats.',
  'settings.items.business.title': 'Business Settings',
  'settings.items.business.description': 'Location, timezone, currency and working hours.',
  'settings.items.team.title': 'Team & Permissions',
  'settings.items.team.description': 'Invite teammates, assign roles, and lock sensitive actions.',
  'settings.items.departments.title': 'Departments',
  'settings.items.departments.description': 'Create departments, assign users, and manage team structure.',
  'settings.items.billing.title': 'Billing & Usage',
  'settings.items.billing.description': 'Invoices, payment methods, and conversation usage.',
  'settings.items.devices.title': 'Devices',
  'settings.items.devices.description': 'Manage scanners, printers, cameras and other hardware.',
  'settings.items.units.title': 'Units',
  'settings.items.units.description': 'Define measurement units for your products and services.',
  'settings.items.shippingMethods.title': 'Shipping Methods',
  'settings.items.shippingMethods.description': 'Configure delivery options, carriers, and shipping rates.',
  'settings.items.inventory.title': 'Inventory',
  'settings.items.inventory.description': 'Track stock levels, adjust quantities, and monitor low-stock products.',
  'settings.items.businessConfig.title': 'Taxes & Charges',
  'settings.items.businessConfig.description': 'Configure tax rates, extra charges, and discount settings.',
  'settings.items.coupons.title': 'Coupons',
  'settings.items.coupons.description': 'Create and manage discount codes for your customers.',
  'settings.items.referrals.title': 'Referral Program',
  'settings.items.referrals.description': 'Manage referral codes, track redemptions, and configure reward rules.',
  'settings.items.developer.title': 'Developer Access',
  'settings.items.developer.description': 'API keys, inbound webhooks, and integration reference.',
  'settings.update.title': 'Update Available',
  'settings.update.message': 'A new version is ready. The app will restart to apply it.',
  'settings.update.later': 'Later',
  'settings.update.now': 'Update Now',
  'settings.deleteAccount.title': 'Delete Account',
  'settings.deleteAccount.confirmMessage': 'Are you sure you want to permanently delete your account? This action cannot be undone and all your data will be removed.',
  'settings.deleteAccount.cancel': 'Cancel',
  'settings.deleteAccount.confirm': 'Delete Account',
  'settings.deleteAccount.successTitle': 'Account Deleted',
  'settings.deleteAccount.successMessage': 'Your account has been successfully deleted.',
  'settings.deleteAccount.errorTitle': 'Error',
  'settings.deleteAccount.errorMessage': 'Failed to delete account. Please try again.',
  'settings.header.title': 'Workspace Settings',
  'settings.header.subtitle': 'Tailor DISLIX to match how your team works.',
  'settings.section.personalPreferences': 'Personal Preferences',
  'settings.language.title': 'Language',
  'settings.language.description': 'Choose your preferred display language',
  'settings.section.business': 'Business',
  'settings.business.fallbackName': 'Active Business',
  'settings.business.active': 'Active',
  'settings.brand.title': 'Brand Appearance',
  'settings.brand.description': 'Logos, colors, quick replies, and conversation templates.',
  'settings.section.adminControls': 'Admin Controls',
  'settings.role.owner': 'Owner',
  'settings.role.admin': 'Admin',
  'comments.someone': 'Someone',
  'comments.like': 'Like',
  'comments.reply': 'Reply',
  'comments.replied': 'Replied',
  'comments.replyPlaceholder': 'Reply to {{name}}…',
  'comments.replyOnMessenger': 'Messenger',
  'comments.openMessenger': 'Open chat',
  'comments.addContact': 'Add contact',
  'comments.openContact': 'Contact',
  'comments.messengerPlaceholder': 'Message {{name}} privately…',
  'comments.messengerHint': 'Sent as a private Messenger message. Facebook allows one per comment.',
  'comments.messengerSent': 'Sent on Messenger',
  'comments.messengerSentHint': 'When they answer, the chat continues in your Inbox.',
  'comments.messengerFailed': 'Couldn’t send on Messenger',
  'comments.messengerExpired': 'Too late for a Messenger reply',
  'comments.messengerExpiredHint': 'Facebook allows it only within 7 days of the comment. Reply on the post instead.',
  'comments.contactAdded': '{{name}} added to contacts',
  'comments.contactFailed': 'Couldn’t add the contact',
  'comments.addContactTitle': 'Add {{name}}',
  'comments.newContact': 'New contact',
  'comments.newContactHint': 'Create a contact for this person.',
  'comments.existingContact': 'Add to an existing contact',
  'comments.existingContactHint': 'This person is already one of your contacts.',
  'comments.chooseContact': 'Choose the contact',
  'comments.addHere': 'Add',
  'comments.addedToContact': '{{name}} added to the contact',
  'comments.messengerLinked': 'Their Messenger chat is linked to the contact.',
  'comments.messengerLinksLater': 'Messenger links when they message your page, or when you reply to them on Messenger.',
  'notifications.title': 'Notifications',
  'notifications.markAllRead': 'Mark all as read',
  'notifications.settings': 'Notification settings',
  'notifications.empty': 'No notifications yet',
  'notifications.emptyHint': 'Messages, orders, bookings and team updates will show up here.',
  'notifications.caughtUp': 'You’re all caught up',
  'notifications.seeAll': 'See all notifications',
  'notifications.delete': 'Delete',
  'notifications.unreadCount': '{{count}} unread',
  'notifications.allRead': 'All read',
  'notifications.loadMore': 'Load more',
  'notifications.filter.all': 'All',
  'notifications.filter.unread': 'Unread',
  'notifications.section.today': 'Today',
  'notifications.section.yesterday': 'Yesterday',
  'notifications.section.earlier': 'Earlier',
  'notifications.time.now': 'Just now',
  'notifications.time.minutes': '{{count}}m',
  'notifications.time.hours': '{{count}}h',
  'notifications.time.yesterday': 'Yesterday',
  'notifications.group.messages': 'Messages',
  'notifications.group.social': 'Page activity',
  'notifications.group.sales': 'Sales',
  'notifications.group.calendar': 'Calendar',
  'notifications.group.visits': 'Visits',
  'notifications.group.team': 'Team',
  'notifications.group.forms': 'Forms',
  'notifications.group.campaigns': 'Campaigns',
  'notifications.group.channels': 'Channels',
  'notifications.group.billing': 'Billing',
  'notificationSettings.title': 'Notifications',
  'notificationSettings.subtitle': 'Choose what reaches you, and how.',
  'notificationSettings.saveFailed': 'Couldn’t save — try again',
  'notificationSettings.loadFailed': 'Couldn’t load your notification settings.',
  'notificationSettings.pauseAll': 'Pause all notifications',
  'notificationSettings.pauseAllHint': 'Nothing will reach you until you turn this off.',
  'notificationSettings.sendTest': 'Send me a test notification',
  'notificationSettings.testSent': 'Test sent',
  'notificationSettings.testSentHint': 'It should arrive in a few seconds.',
  'notificationSettings.testFailed': 'Couldn’t send the test',
  'notificationSettings.scope.title': 'Which conversations',
  'notificationSettings.scope.hint': 'For messages, missed calls and customers waiting for a reply.',
  'notificationSettings.scope.unassigned': 'Unassigned and mine',
  'notificationSettings.scope.unassignedHint': 'Conversations nobody owns yet, and the ones assigned to you.',
  'notificationSettings.scope.all': 'All conversations',
  'notificationSettings.scope.allHint': 'Everything, including conversations assigned to others.',
  'notificationSettings.scope.mine': 'Only mine',
  'notificationSettings.scope.mineHint': 'Just the conversations assigned to you.',
  'notificationSettings.push': 'Push',
  'notificationSettings.inApp': 'In app',
  'notificationSettings.onCount': '{{on}} of {{total}} on',
  'notificationSettings.turnAllOn': 'Turn all on',
  'notificationSettings.turnAllOff': 'Turn all off',
  'notificationSettings.type.new_message.title': 'New messages',
  'notificationSettings.type.new_message.description': 'A customer writes on WhatsApp, Messenger or X.',
  'notificationSettings.type.new_contact.title': 'New contacts',
  'notificationSettings.type.new_contact.description': 'Someone messages you for the first time.',
  'notificationSettings.type.conversation_expiring.title': 'Waiting for a reply',
  'notificationSettings.type.conversation_expiring.description': 'A customer’s 24-hour reply window is about to close.',
  'notificationSettings.type.missed_call.title': 'Missed calls',
  'notificationSettings.type.missed_call.description': 'An incoming call nobody answered.',
  'notificationSettings.type.facebook_post_comment.title': 'Comments on posts',
  'notificationSettings.type.facebook_post_comment.description': 'Someone comments or replies on your page’s posts.',
  'notificationSettings.type.facebook_post_reaction.title': 'Reactions on posts',
  'notificationSettings.type.facebook_post_reaction.description': 'Someone reacts to your page’s posts.',
  'notificationSettings.type.new_order.title': 'New orders',
  'notificationSettings.type.new_order.description': 'An order is placed.',
  'notificationSettings.type.quotation_status.title': 'Quotation answers',
  'notificationSettings.type.quotation_status.description': 'A quotation you created is accepted or rejected.',
  'notificationSettings.type.quotation_expiring.title': 'Quotations expiring',
  'notificationSettings.type.quotation_expiring.description': 'Your sent quotations expire in two days without an answer.',
  'notificationSettings.type.low_stock.title': 'Low stock',
  'notificationSettings.type.low_stock.description': 'A product falls to its stock alert level.',
  'notificationSettings.type.calendar_reminder.title': 'Event reminders',
  'notificationSettings.type.calendar_reminder.description': 'Before your events start.',
  'notificationSettings.type.new_booking.title': 'New bookings',
  'notificationSettings.type.new_booking.description': 'A customer books a time on your calendar.',
  'notificationSettings.type.calendar_event_assigned.title': 'Shared calendars',
  'notificationSettings.type.calendar_event_assigned.description': 'A calendar is shared with you.',
  'notificationSettings.type.visit_assigned.title': 'New visits',
  'notificationSettings.type.visit_assigned.description': 'A visit is assigned to you.',
  'notificationSettings.type.visit_sla_approaching.title': 'Visits due soon',
  'notificationSettings.type.visit_sla_approaching.description': 'A visit is close to its deadline.',
  'notificationSettings.type.visit_sla_breached.title': 'Overdue visits',
  'notificationSettings.type.visit_sla_breached.description': 'A visit missed its deadline.',
  'notificationSettings.type.new_assignment.title': 'Assigned to you',
  'notificationSettings.type.new_assignment.description': 'A contact or task is assigned to you.',
  'notificationSettings.type.assignment_update.title': 'Assignment changes',
  'notificationSettings.type.assignment_update.description': 'Something assigned to you is moved or cancelled.',
  'notificationSettings.type.member_joined.title': 'New team members',
  'notificationSettings.type.member_joined.description': 'Someone accepts an invitation.',
  'notificationSettings.type.new_data_list_submission.title': 'Form entries',
  'notificationSettings.type.new_data_list_submission.description': 'Someone fills in one of your forms.',
  'notificationSettings.type.campaign_finished.title': 'Campaign results',
  'notificationSettings.type.campaign_finished.description': 'A campaign finishes or is paused.',
  'notificationSettings.type.task_finished.title': 'Scheduled jobs',
  'notificationSettings.type.task_finished.description': 'A scheduled job finishes or fails.',
  'notificationSettings.type.channel_problem.title': 'Channel problems',
  'notificationSettings.type.channel_problem.description': 'A channel stops working and needs reconnecting.',
  'notificationSettings.type.template_status_update.title': 'Template reviews',
  'notificationSettings.type.template_status_update.description': 'Meta approves, rejects or pauses a template.',
  'notificationSettings.type.whatsapp_quality_alert.title': 'Number quality',
  'notificationSettings.type.whatsapp_quality_alert.description': 'Your WhatsApp number’s quality drops.',
  'notificationSettings.type.whatsapp_account_alert.title': 'Account restrictions',
  'notificationSettings.type.whatsapp_account_alert.description': 'Meta restricts or blocks your WhatsApp account.',
  'notificationSettings.type.subscription_reminder.title': 'Renewal reminders',
  'notificationSettings.type.subscription_reminder.description': 'Before your trial or plan ends.',
  'notificationSettings.type.subscription_expired.title': 'Plan ended',
  'notificationSettings.type.subscription_expired.description': 'Your plan ended and the account is paused.',
  'notificationSettings.type.payment_succeeded.title': 'Payments received',
  'notificationSettings.type.payment_succeeded.description': 'A payment goes through.',
  'notificationSettings.type.payment_failed.title': 'Failed payments',
  'notificationSettings.type.payment_failed.description': 'A payment doesn’t go through.',
  'posts.facebookPage': 'Facebook page',
  'posts.scheduledFor': 'Scheduled for {{date}}',
  'posts.justNow': 'Just now',
  'posts.status.published': 'Published',
  'posts.status.scheduled': 'Scheduled',
  'posts.status.draft': 'Draft',
  'posts.status.failed': 'Failed',
  'posts.actions': 'Post actions',
  'posts.insights': 'Insights',
  'posts.post': 'Post',
  'posts.error.permissions': 'Facebook didn’t allow DISLIX to post on this page. Reconnect the page from Settings → Channels → Messenger and approve posting.',
  'posts.error.generic': 'Facebook didn’t publish this post.',
  'posts.action.openOnFacebook': 'Open on Facebook',
  'posts.action.schedule': 'Schedule',
  'posts.action.publishNow': 'Publish now',
  'posts.action.retry': 'Try again',
  'posts.action.edit': 'Edit',
  'posts.action.editText': 'Edit text',
  'posts.action.cancelSchedule': 'Cancel schedule',
  'posts.action.delete': 'Delete',
  'posts.done.published': 'Post published',
  'posts.done.scheduled': 'Post scheduled',
  'posts.done.draftSaved': 'Draft saved',
  'posts.done.updated': 'Post updated',
  'posts.done.deleted': 'Post deleted',
  'posts.done.unscheduled': 'Schedule cancelled — saved as a draft',
  'posts.failed.publish': 'Couldn’t publish the post',
  'posts.failed.delete': 'Couldn’t delete the post',
  'posts.failed.cancel': 'Couldn’t cancel the schedule',
  'posts.confirm.deleteTitle': 'Delete post?',
  'posts.confirm.deleteLive': 'It will also be removed from Facebook. This can’t be undone.',
  'posts.confirm.deleteLocal': 'This post was never on Facebook. It will be removed from DISLIX.',
  'posts.confirm.cancelSchedule': 'It won’t be published. You’ll keep it as a draft.',
  'posts.noActions': 'Nothing to do with this post.',
  'posts.composer.title': 'Create post',
  'posts.composer.editTitle': 'Edit post',
  'posts.composer.page': 'Page',
  'posts.composer.pages': 'Post to',
  'posts.composer.placeholder': 'What’s on your mind?',
  'posts.composer.addPhotos': 'Add photos',
  'posts.composer.camera': 'Take a photo',
  'posts.composer.addVideo': 'Add a video',
  'posts.composer.addLink': 'Add a link',
  'posts.composer.emoji': 'Emoji',
  'posts.composer.when': 'When',
  'posts.composer.now': 'Now',
  'posts.composer.later': 'Schedule',
  'posts.composer.publishAt': 'Publish on',
  'posts.composer.pickTime': 'Choose a date and time',
  'posts.composer.tooSoon': 'Schedule at least 10 minutes ahead.',
  'posts.composer.tooFar': 'Facebook schedules posts up to 75 days ahead.',
  'posts.composer.preview': 'Preview',
  'posts.composer.saveDraft': 'Save draft',
  'posts.composer.publish': 'Publish',
  'posts.composer.schedule': 'Schedule',
  'posts.composer.saveChanges': 'Save changes',
  'posts.composer.uploadFailed': 'Upload failed — try again',
  'posts.composer.failed': 'Couldn’t save the post',
  'posts.composer.partial': '{{count}} page(s) didn’t publish',
  'posts.composer.partialHint': 'See the Failed tab to try again.',
  'posts.composer.multiHint': 'One post will be published on each of the {{count}} pages.',
  'posts.noPages': 'Connect a Facebook page to publish posts.',
  'posts.connectPage': 'Connect a page',
  'posts.synced': 'Synced',
  'posts.syncedCount': 'Imported {{count}} post(s) from Facebook',
  'posts.syncFailed': 'Sync failed',
  'posts.sync': 'Import older posts',
  'posts.noMatches': 'No posts match your search.',
  'posts.selectPost': 'Select a post to see its details and comments.',
  'posts.empty.published': 'No published posts yet.',
  'posts.empty.scheduled': 'Nothing scheduled.',
  'posts.empty.draft': 'No drafts.',
  'posts.empty.failed': 'No failed posts.',
  'posts.allPages': 'All pages',
  'posts.tab.published': 'Published',
  'posts.tab.scheduled': 'Scheduled',
  'posts.tab.draft': 'Drafts',
  'posts.tab.failed': 'Failed',
  'posts.search': 'Search posts',
  'posts.videoPost': 'Video',
  'posts.photoPost': 'Photo',
  'home.posts.title': 'Page posts',
  'home.posts.empty': 'No posts yet',
  'home.posts.viewAll': 'View all',
  'home.posts.create': 'Create post',
  'home.posts.shortcut': 'Publish and review your Facebook page posts',
  'settings.entry.posts.title': 'Page posts',
  'settings.entry.posts.description': 'Publish, schedule and review Facebook page posts.',
  'settings.role.manager': 'Manager',
  'settings.role.member': 'Member',
  'settings.role.viewer': 'Viewer',
  'settings.search': 'Search settings',
  'settings.noResults': 'No settings match your search.',
  'settings.upgrade': 'Upgrade',
  'settings.selectFromMenu': 'Choose a setting from the menu.',
  'settings.theme.title': 'Appearance',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.group.preferences': 'Preferences',
  'settings.group.account': 'Account',
  'settings.group.business': 'Business',
  'settings.group.team': 'Team',
  'settings.group.channels': 'Channels',
  'settings.group.sales': 'Sales & catalogue',
  'settings.group.messaging': 'Messaging',
  'settings.group.advanced': 'Advanced',
  'settings.entry.profile.title': 'Profile',
  'settings.entry.profile.description': 'Your name, photo and personal details.',
  'settings.entry.phone.title': 'Sign-in & phone numbers',
  'settings.entry.phone.description': 'The phone numbers and email you sign in with.',
  'settings.entry.notifications.title': 'Notifications',
  'settings.entry.notifications.description': 'Which alerts you get and how.',
  'settings.entry.business.title': 'Business profile',
  'settings.entry.business.description': 'Name, logo, location, timezone, currency and working hours.',
  'settings.entry.billing.title': 'Plan & billing',
  'settings.entry.billing.description': 'Your plan, add-ons, payments and invoices.',
  'settings.entry.setup.title': 'Get your business ready',
  'settings.entry.setup.description': 'Your setup checklist and what’s left.',
  'settings.entry.team.title': 'Team members',
  'settings.entry.team.description': 'Invite people and manage their roles.',
  'settings.entry.permissions.title': 'Permissions',
  'settings.entry.permissions.description': 'What each person and department can see and do.',
  'settings.entry.departments.title': 'Departments',
  'settings.entry.departments.description': 'Group your team and route work to them.',
  'settings.entry.whatsapp.title': 'WhatsApp',
  'settings.entry.whatsapp.description': 'Connect and manage your WhatsApp numbers.',
  'settings.entry.messenger.title': 'Messenger',
  'settings.entry.messenger.description': 'Connect your Facebook pages.',
  'settings.entry.x.title': 'X (Twitter)',
  'settings.entry.x.description': 'Connect your X accounts for direct messages.',
  'settings.entry.phoneChannel.title': 'Phone calls',
  'settings.entry.phoneChannel.description': 'Calling for your team.',
  'settings.entry.visits.title': 'Field visits',
  'settings.entry.visits.description': 'Visit rules, routes and check-ins.',
  'settings.entry.taxes.title': 'Taxes & charges',
  'settings.entry.taxes.description': 'Tax rates, extra charges and discounts on orders.',
  'settings.entry.shipping.title': 'Shipping methods',
  'settings.entry.shipping.description': 'How and where you deliver.',
  'settings.entry.units.title': 'Units',
  'settings.entry.units.description': 'Units of measure for your products.',
  'settings.entry.inventory.title': 'Inventory',
  'settings.entry.inventory.description': 'Stock levels and locations.',
  'settings.entry.coupons.title': 'Coupons',
  'settings.entry.coupons.description': 'Discount codes for your customers.',
  'settings.entry.referrals.title': 'Referral program',
  'settings.entry.referrals.description': 'Reward customers who bring others.',
  'settings.entry.quotationTemplates.title': 'Document templates',
  'settings.entry.quotationTemplates.description': 'Invoices, quotations, receipts, delivery notes, packing slips and purchase orders.',
  'settings.entry.templates.title': 'Message templates',
  'settings.entry.templates.description': 'Approved WhatsApp templates.',
  'settings.entry.quickReplies.title': 'Quick replies',
  'settings.entry.quickReplies.description': 'Saved answers your team can send in one tap.',
  'settings.entry.devices.title': 'Devices',
  'settings.entry.devices.description': 'Scanners, printers and other connected devices.',
  'settings.entry.developer.title': 'Developer access',
  'settings.entry.developer.description': 'API keys and integrations.',
  'settings.section.account': 'Account',
  'settings.deleteAccount.cardTitle': 'Delete Account',
  'settings.deleteAccount.cardDescription': 'Permanently delete your account and all associated data.',
  'settings.version.label': 'Version {{version}}',
  'settings.version.builtIn': 'built-in',
  'settings.version.update': 'update {{date}} ({{commit}})',
  'settings.version.upToDate': 'Up to date',
  'settings.version.checkForUpdate': 'Check for update',

  // ─── Contacts List (Right Pane) ──────────────────────────────────────────
  'contacts.header.title': 'Contacts',
  'contacts.header.selectedCount': '{{count}} selected',
  'contacts.header.selectContacts': 'Select contacts',
  'contacts.header.createVisits': 'Create visits',
  'contacts.search.placeholder': 'Search contacts...',
  'contacts.quickFilter.needsResponse': '{{count}} need a response',
  'contacts.quickFilter.followUpDue': '{{count}} follow-up due',
  'contacts.quickFilter.neverContacted': '{{count}} never contacted',
  'contacts.quickFilter.expiringSoon': '{{count}} expiring soon',
  'contacts.provider.whatsapp': 'WhatsApp',
  'contacts.provider.messenger': 'Messenger',
  'contacts.provider.xTwitter': 'X (Twitter)',
  'contacts.provider.phone': 'Phone',
  'contacts.provider.telegram': 'Telegram',
  'contacts.provider.email': 'Email',
  'contacts.filter.allChannels': 'All Channels',
  'contacts.filter.allAssignments': 'All Assignments',
  'contacts.filter.unassigned': 'Unassigned',
  'contacts.filter.users': 'Users',
  'contacts.filter.loadingUsers': 'Loading users...',
  'contacts.filter.noUsers': 'No users available',
  'contacts.filter.departments': 'Departments',
  'contacts.filter.loadingDepartments': 'Loading departments...',
  'contacts.filter.noDepartments': 'No departments available',
  'contacts.filter.channel': 'Channel',
  'contacts.filter.pageSize': 'Contacts per page',
  'contacts.filter.pageSizeRange': '{{min}}+ contacts',
  'contacts.filter.clearAll': 'Clear all filters',
  'contacts.filter.assignment': 'Assignment',
  'contacts.filter.tags': 'Tags',
  'contacts.filter.clearTagFilters': 'Clear all tag filters',
  'contacts.filter.excludedSuffix': ' (excluded)',
  'contacts.filter.searchTagsPlaceholder': 'Search tags...',
  'contacts.filter.noTagsMatch': 'No tags match your search',
  'contacts.filter.loadMore': 'Load {{count}} more',
  'contacts.filter.dataList': 'Data List',
  'contacts.filter.allDataLists': 'All Contacts',
  'contacts.filter.location.filterTitle': 'Filter by location',
  'contacts.filter.location.cityPlaceholder': 'City',
  'contacts.filter.location.countryPlaceholder': 'Country',
  'contacts.filter.location.anyCity': 'Any city',
  'contacts.filter.location.anyCountry': 'Any country',
  'contacts.filter.location.noCities': 'No cities on file yet',
  'contacts.filter.location.sortTitle': 'Sort by distance',
  'contacts.filter.location.nearest': 'Nearest to me',
  'contacts.filter.location.farthest': 'Farthest from me',
  'contacts.filter.location.pickOnMap': 'Or pick a point on the map',
  'contactsBulkUpload.mapper.title': 'Map your columns',
  'contactsBulkUpload.mapper.subtitle': 'Choose what each column means — {{count}} rows found',
  'contactsBulkUpload.mapper.rememberedBanner': 'Pre-filled from your last import of a file with these same columns',
  'contactsBulkUpload.mapper.sample': 'Sample',
  'contactsBulkUpload.mapper.customFieldNamePlaceholder': 'Custom field name',
  'contactsBulkUpload.mapper.unmappedBecomeCustom': '{{count}} unmapped column(s) will be imported as custom fields',
  'contactsBulkUpload.mapper.needsName': 'Map at least one column to "Name" to continue',
  'contactsBulkUpload.mapper.needsIdentifier': 'Map at least one column to Phone, Email, WhatsApp, or another identifier to continue',
  'contactsBulkUpload.mapper.confirm': 'Import {{count}} contacts',
  'contactsBulkUpload.mapper.processingInBackground': 'Importing in the background — this can take a few minutes for large files. You can leave this screen; the import will keep running.',
  'contacts.filter.location.radiusPlaceholder': 'Radius (km)',
  'contacts.filter.location.includeUnlocated': 'Include contacts with only a city/address (no exact pin)',
  'contacts.filter.location.apply': 'Apply',
  'contacts.filter.moreFilters': 'More filters',
  'contacts.analyticalFilters.title': 'Analytical filters',
  'contacts.analyticalFilters.responseSection': 'Response status',
  'contacts.analyticalFilters.responseHint': 'Needs a response: they messaged, we haven\'t replied. Expiring soon: their WhatsApp reply window (20-24h since their last message) is about to close. Never contacted: zero messages, calls, or orders ever.',
  'contacts.analyticalFilters.noReplySection': 'Didn\'t return back',
  'contacts.analyticalFilters.noReplyHint': 'Contacts who haven\'t replied since we last reached out — the classic "needs a follow-up" list. You choose how long counts as silence.',
  'contacts.analyticalFilters.noReplyPrefix': 'No reply for at least',
  'contacts.analyticalFilters.noReplySuffix': 'days',
  'contacts.analyticalFilters.orderSection': 'Products / orders',
  'contacts.analyticalFilters.orderHint': 'Has this contact ever placed an order?',
  'contacts.analyticalFilters.orderDateHint': 'Optionally narrow to orders placed within a date range.',
  'contacts.analyticalFilters.hasOrder': 'Has an order',
  'contacts.analyticalFilters.noOrder': 'No order',
  'contacts.analyticalFilters.contactedSection': 'Contacted',
  'contacts.analyticalFilters.contactedHint': 'Find contacts last reached on any channel, or a specific one, within a date range you pick.',
  'contacts.analyticalFilters.wasContacted': 'Was contacted',
  'contacts.analyticalFilters.wasNotContacted': 'Was NOT contacted',
  'contacts.analyticalFilters.returnedMultipleSection': 'Returned multiple times',
  'contacts.analyticalFilters.returnedMultipleHint': 'Contacts who\'ve messaged back and forth with the business repeatedly, not just once.',
  'contacts.analyticalFilters.returnedMultiplePrefix': 'Contacted us at least',
  'contacts.analyticalFilters.returnedMultipleSuffix': 'times',
  'contacts.analyticalFilters.applyWithCount': 'Apply ({{count}})',
  'contacts.sort.field.name': 'Name',
  'contacts.sort.field.phone': 'Phone',
  'contacts.sort.field.email': 'Email',
  'contacts.sort.field.city': 'City',
  'contacts.sort.field.country': 'Country',
  'contacts.sort.field.nationality': 'Nationality',
  'contacts.sort.field.location': 'Location',
  'contacts.sort.field.hasChannels': 'Contacted (any channel)',
  'contacts.sort.field.needsResponse': 'Needs a response',
  'contacts.sort.field.followUpDue': 'Follow-up due',
  'contacts.sort.field.expiringSoon': 'Expiring soon',
  'contacts.sort.field.createdAt': 'Date added',
  'contacts.sort.field.lastActivityAt': 'Last activity',
  'contacts.sort.sortTitle': 'Sort by',
  'contacts.sort.clearSort': 'Clear sort',
  'contacts.sort.extraFieldsTitle': 'Extra fields',
  'contacts.sort.extraFieldsHint': 'Custom fields found in your imported files',
  'contacts.sort.anyValue': 'Any value',
  'contacts.sort.hasValue': 'Has a value',
  'contacts.sort.noValueOption': 'No value',
  'contacts.sort.noValues': 'No values found',
  'contacts.sort.modalTitle': 'Sort & Filter',
  'contacts.sort.reset': 'Reset',
  'contacts.sort.searchFieldsPlaceholder': 'Search fields',
  'contacts.sort.ascending': 'Ascending',
  'contacts.sort.descending': 'Descending',
  'contacts.sort.noFieldsMatch': 'No fields match your search',
  'contacts.sort.filterTitle': 'Filter by value',
  'contacts.sort.filterHint': 'Tap a field to search its values and pick one or more',
  'contacts.sort.searchValuesPlaceholder': 'Search values',
  'contacts.sort.selected': 'selected',
  'contacts.sort.noValuesMatchSearch': 'No values match your search',
  'contacts.filter.location.geolocationUnavailable': 'Geolocation is not supported in this browser.',
  'contacts.filter.location.geolocationFailed': 'Could not get your current location.',
  'contacts.filter.location.geolocationPermissionDenied': 'Location permission is required for this sort.',
  'contacts.fallback.user': 'User',
  'contacts.fallback.department': 'Department',
  'contacts.empty.loading': 'Loading contacts...',
  'contacts.empty.updating': 'Updating...',
  'contacts.empty.noConfiguredChannels': 'No configured channels',
  'contacts.empty.noConfiguredChannelsHint': 'Configure WhatsApp or Facebook Messenger to see contacts here',
  'contacts.empty.noResultsFound': 'No contacts found',
  'contacts.empty.noContactsYet': 'No contacts yet',
  'contacts.empty.tryAdjusting': 'Try adjusting your search or filters',
  'contacts.empty.willAppear': 'Contacts will appear here once you start conversations',
  'contacts.loadingMore': 'Loading more contacts...',
  'contacts.loadMore': 'Load more',
  'contacts.loadMoreRemaining': '{{count}} remaining',
  'contacts.bulkAssign.title': 'Assign Selected Contacts',
  'contacts.bulkAssign.assignTab': 'Assign',
  'contacts.bulkAssign.unassignTab': 'Unassign',
  'contacts.bulkAssign.close': 'Close',
  'contacts.bulkTag.title': 'Tag Selected Contacts',
  'contacts.bulkUploadProgress.singleTitle': 'Importing contacts',
  'contacts.bulkUploadProgress.multipleTitle': 'Importing contacts ({{count}} uploads)',
  'contacts.bulkUploadProgress.countLabel': '{{processed}}/{{total}} contacts',
  'contacts.bulkUploadProgress.modalTitle': 'Active imports',
  'contacts.bulkUploadProgress.close': 'Close',
  'contacts.bulkUploadProgress.doneTitle': 'Import complete',
  'contacts.bulkUploadProgress.doneMessage': 'Bulk contact upload finished — check Contacts for the results.',
  'contacts.bulkUploadProgress.pause': 'Pause',
  'contacts.bulkUploadProgress.resume': 'Resume',
  'contacts.bulkUploadProgress.cancel': 'Cancel',
  'contacts.bulkUploadProgress.pausedBadge': 'Paused',
  'contacts.bulkUploadProgress.actionErrorTitle': 'Something went wrong',
  'contacts.bulkUploadProgress.pauseFailed': 'Could not pause this import. Please try again.',
  'contacts.bulkUploadProgress.resumeFailed': 'Could not resume this import. Please try again.',
  'contacts.bulkUploadProgress.cancelFailed': 'Could not cancel this import. Please try again.',
  'contacts.bulkUploadProgress.cancelConfirmTitle': 'Cancel this import?',
  'contacts.bulkUploadProgress.cancelConfirmMessage': 'Contacts already imported will stay — only the remaining rows will be skipped. This can\'t be undone.',
  'contacts.bulkUploadProgress.cancelConfirmAction': 'Cancel import',
  'contacts.bulkUploadProgress.cancelConfirmDismiss': 'Keep going',
  'contacts.bulkTag.addTags': 'Add tags',
  'contacts.bulkTag.removeTags': 'Remove tags',
  'contacts.bulkTag.placeholder': 'e.g. VIP, follow-up, newsletter',
  'contacts.bulkTag.hint': 'Separate multiple tags with commas',
  'contacts.bulkTag.removeHint': 'Tap tags to select them for removal',
  'contacts.bulkTag.cancel': 'Cancel',
  'contacts.bulkTag.submitAdd': 'Add Tags',
  'contacts.bulkTag.submitRemove': 'Remove Tags',
  'contacts.bulkList.title': 'Add/Remove From Data List',
  'contacts.bulkList.addTo': 'Add to list',
  'contacts.bulkList.removeFrom': 'Remove from list',
  'contacts.bulkList.submitAdd': 'Add to List',
  'contacts.bulkList.submitRemove': 'Remove from List',
  'contacts.errors.bulkAssignFailed': 'Failed to bulk assign contacts',
  'contacts.errors.bulkUnassignFailed': 'Failed to bulk unassign contacts',
  'contacts.errors.bulkTagFailed': 'Failed to update tags',
  'contacts.errors.bulkListFailed': 'Failed to update list membership',
  'contacts.errors.prefix': 'Error: {{message}}',
  'contacts.tags.viewAll': 'View tags',
  'contacts.tags.title': 'Tags',
  'contacts.primary': 'Primary',

  // ─── Contacts Screen (list header + actions) ────────────────────────────
  'contactsScreen.title': 'All Contacts',
  'contactsScreen.searchPlaceholder': 'Search contacts by name or phone...',
  'contactsScreen.selectContact.title': 'Select a contact to view',
  'contactsScreen.selectContact.hint': 'Choose a contact from the list to see their details here.',
  'contactsScreen.moreActions': 'More actions',
  'contactsScreen.actions.addContact': 'Add Contact',
  'contactsScreen.actions.downloadCsv': 'Download CSV',
  'contactsScreen.actions.importContacts': 'Import Contacts',
  'contactsScreen.bulkSendWhatsApp': 'Send WhatsApp ({{count}})',
  'contactsScreen.notifications.contactAddedTitle': 'Contact Added',
  'contactsScreen.notifications.contactAddedMessage': '{{name}} has been added successfully',
  'contactsScreen.notifications.conversationStartedTitle': 'Conversation Started',
  'contactsScreen.notifications.conversationStartedMessage': 'Conversation with {{name}} has been initiated',
  'contactsScreen.notifications.contactUpdatedTitle': 'Contact Updated',
  'contactsScreen.notifications.contactUpdatedMessage': '{{name}} has been updated successfully',
  'contactsScreen.notifications.contactDeletedTitle': 'Contact Deleted',
  'contactsScreen.notifications.contactDeletedMessage': 'Contact has been deleted successfully',
  'contactsScreen.notifications.exportCompleteTitle': 'Export Complete',
  'contactsScreen.notifications.exportCompleteMessage': 'Downloaded {{count}} contacts as CSV',
  'contactsScreen.export.title': 'Download contacts',
  'contactsScreen.export.templateTitle': 'Blank template',
  'contactsScreen.export.templateSubtitle': 'An empty CSV with the right columns, ready to fill in and upload',
  'contactsScreen.export.selectionTitle': '{{count}} selected contacts',
  'contactsScreen.export.allTitle': 'All contacts',
  'contactsScreen.export.selectionSubtitle': 'Phone numbers are masked unless you have permission to view them',
  'contactsScreen.export.allExportedMessage': 'All contacts exported',
  'contactsScreen.export.nativeUnsupported': 'Downloading files isn\'t supported on this device yet — try from the web app',
  'contactsScreen.export.fieldsModalTitle': 'Choose fields to export',
  'contactsScreen.export.selectAll': 'Select all',
  'contactsScreen.export.selectNone': 'Select none',
  'contactsScreen.export.fixedFieldsTitle': 'Contact fields',
  'contactsScreen.export.field.tags': 'Tags',
  'contactsScreen.export.maskedHint': 'Masked unless you have permission to view phone numbers',
  'contactsScreen.export.formatTitle': 'File format',
  'contactsScreen.export.formatExcel': 'Excel (.xlsx)',
  'contactsScreen.export.formatCsv': 'CSV',
  'contactsScreen.export.csvEncodingHint': 'Some spreadsheet apps can misread Arabic text in CSV files — use Excel format if that happens',
  'contactsScreen.export.downloadButton': 'Download ({{count}} fields)',
  'contactsScreen.errors.title': 'Error',
  'contactsScreen.errors.resolveSendTargetsFailed': 'Failed to resolve phone numbers for the selected contacts. Please try again.',
  'contactsScreen.notifications.templateDownloadedTitle': 'Template Downloaded',
  'contactsScreen.notifications.templateDownloadedEmptyMessage': 'Downloaded empty CSV template. Fill it with your contacts and upload.',
  'contactsScreen.notifications.templateDownloadedFallbackMessage': 'Downloaded CSV template. Fill it with your contacts and upload.',

  // ─── Contact Edit Form (Right Pane) ─────────────────────────────────────
  'contactEdit.permission.title': 'Permission Required',
  'contactEdit.permission.message': 'Please grant permission to access your photo library.',
  'contactEdit.errors.avatarUpload': 'Failed to upload avatar. Please try again.',
  'contactEdit.info.title': 'Info',
  'contactEdit.info.saveContactFirst': 'Please save the contact first before uploading documents',
  'contactEdit.errors.documentUpload': 'Failed to upload document. Please try again.',
  'contactEdit.validation.title': 'Validation Error',
  'contactEdit.validation.nameRequired': 'Contact name is required',
  'contactEdit.validation.identifierRequired': 'At least one contact identifier (phone, email, etc.) is required',
  'contactEdit.success.title': 'Success',
  'contactEdit.success.updated': 'Contact updated successfully',
  'contactEdit.success.created': 'Contact created successfully',
  'contactEdit.errors.title': 'Error',
  'contactEdit.errors.saveFailed': 'Failed to save contact',
  'contactEdit.errors.addNoteFailed': 'Failed to add note',
  'contactEdit.errors.deleteNoteFailed': 'Failed to delete note',
  'contactEdit.errors.setPrimaryFailed': 'Failed to set primary identifier',
  'contactEdit.delete.title': 'Delete Contact',
  'contactEdit.delete.confirmMessage': 'Are you sure you want to delete {{name}}?',
  'contactEdit.delete.cancel': 'Cancel',
  'contactEdit.delete.confirm': 'Delete',
  'contactEdit.delete.success': 'Contact deleted successfully',
  'contactEdit.delete.failed': 'Failed to delete contact',
  'contactEdit.header.addContact': 'Add Contact',
  'contactEdit.header.editContact': 'Edit Contact',
  'contactEdit.photo.change': 'Change Photo',
  'contactEdit.photo.add': 'Add Photo',
  'contactEdit.section.basicInfo': 'Basic Information',
  'contactEdit.field.name': 'Name *',
  'contactEdit.field.namePlaceholder': 'Enter contact name',
  'contactEdit.section.identifiers': 'Contact Identifiers',
  'contactEdit.channel.phone': 'Phone',
  'contactEdit.channel.email': 'Email',
  'contactEdit.channel.whatsapp': 'WhatsApp',
  'contactEdit.channel.facebookMessenger': 'Facebook Messenger',
  'contactEdit.channel.facebook': 'Facebook',
  'contactEdit.channel.instagram': 'Instagram',
  'contactEdit.channel.telegram': 'Telegram',
  'contactEdit.identifier.enterNumber': 'Enter {{channel}} number',
  'contactEdit.identifier.enter': 'Enter {{channel}}',
  'contactEdit.identifier.emptyHint': 'Add at least one identifier (phone, email, etc.)',
  'contactEdit.identifier.setPrimary': 'Set as primary',
  'contactEdit.identifier.addForChannel': 'Add for {{channel}}',
  'contactEdit.identifier.useForChannel': 'Use for {{channel}} too',
  'contactEdit.identifier.undoAdd': 'Undo',
  'contactEdit.section.location': 'Location',
  'contactEdit.location.select': 'Select location',
  'contactEdit.location.addressLine': 'Address line',
  'contactEdit.location.city': 'City',
  'contactEdit.location.country': 'Country',
  'contactEdit.location.nationality': 'Nationality',
  'contactEdit.location.pasteLinkPlaceholder': 'Paste a Google/Apple Maps link',
  'contactEdit.location.linkResolved.title': 'Location found',
  'contactEdit.location.linkResolved.message': 'Address details filled in from the link.',
  'contactEdit.location.linkFailed.title': 'Could not read link',
  'contactEdit.location.linkFailed.message': 'Could not extract a location from that link.',
  'contactEdit.location.showLinkPaste': 'Paste a maps link instead',
  'contactEdit.location.hideLinkPaste': 'Hide link paste',
  'contactEdit.section.assignment': 'Assignment',
  'contactEdit.assignment.reassign': 'Reassign',
  'contactEdit.assignment.unassigned': 'Not assigned',
  'contactEdit.section.orders': 'Orders',
  'contactEdit.orders.empty': 'No orders yet',
  'contactEdit.section.quotations': 'Quotations',
  'contactEdit.quotations.empty': 'No quotations yet',
  'contactEdit.section.visits': 'Visits',
  'contactEdit.visits.empty': 'No visits yet',
  'contactEdit.visits.endVisit': 'End Visit',
  'contactEdit.visits.showAll': 'Show all ({{count}})',
  'contactEdit.visits.showLess': 'Show less',
  'orders.form.extraFieldsUpdated': 'Extra fields updated successfully.',
  'orders.form.extraFieldsFailed': 'Failed to update extra fields',
  'orders.form.businessNotFound': 'Business not found',
  'orders.form.couponInvalidMsg': 'Coupon is not valid',
  'orders.form.zoneUnavailableCustomer': 'This shipping method is not available for the customer’s location.',
  'orders.form.zoneUnavailableLocation': 'The selected location is outside this shipping method’s zones.',
  'orders.form.orderIdRequired': 'Order ID is required',
  'orders.form.loadFailed': 'Failed to load order',
  'orders.form.productLoadFailed': 'Failed to load product details',
  'orders.form.addProductsFailed': 'Failed to add products to order',
  'orders.form.scannedAdded': 'Scanned product added to order.',
  'orders.form.customerPrefilled': 'Order customer was selected from the contact.',
  'orders.form.errCustomerName': 'Please select a contact or enter customer name',
  'orders.form.errCustomerPhone': 'Please select a contact or enter phone number',
  'orders.form.errItems': 'Order must have at least one item',
  'orders.form.errTotal': 'Total price must be greater than 0',
  'orders.form.fixErrors': 'Please fix the errors in the form',
  'orders.form.businessIdRequired': 'Business ID is required',
  'orders.form.created': 'Order created successfully.',
  'orders.form.updated': 'Order updated successfully.',
  'orders.form.copyNumber': 'Copy order number',
  'orders.form.couponApplied': 'Coupon Applied',
  'orders.form.couponInvalid': 'Invalid Coupon',
  'orders.form.zoneUnavailable': 'Zone Not Available',
  'orders.form.productAdded': 'Product Added',
  'orders.form.orderCustomer': 'Order Customer',
  'orders.form.validationError': 'Validation Error',
  'orders.form.editTitle': 'Edit Order',
  'orders.form.newTitle': 'New Order',
  'orders.form.free': 'Free',
  'orders.form.typePhysical': 'Physical',
  'orders.form.typeDigital': 'Digital',
  'orders.form.typeService': 'Service',
  'orders.form.couponSaved': 'Saved {{currency}} {{amount}}',
  'orders.form.loading': 'Loading order...',
  'orders.form.viewQuotation': 'View originating quotation',
  'orders.form.customerInfo': 'Customer Information',
  'orders.form.shippingInfo': 'Shipping Information',
  'orders.form.shippingAddress': 'Shipping Address',
  'orders.form.locationOptional': 'Location (Optional)',
  'orders.form.selectLocation': 'Select location',
  'orders.form.shippingMethod': 'Shipping Method',
  'orders.form.selectShippingMethod': 'Select shipping method',
  'orders.form.items': 'Order Items',
  'orders.form.add': 'Add',
  'orders.form.addons': 'Add-ons:',
  'orders.form.apply': 'Apply',
  'orders.form.subtotal': 'Subtotal',
  'orders.form.total': 'Total',
  'orders.form.noItems': 'No items in this order',
  'orders.form.addItems': 'Add Items',
  'orders.form.extraFields': 'Extra Fields',
  'orders.form.selectShippingMethodTitle': 'Select Shipping Method',
  'orders.form.noShippingMethods': 'No shipping methods configured',
  'orders.form.express': 'Express',
  'orders.form.selectStatus': 'Select status',
  'orders.form.selectPaymentStatus': 'Select payment status',
  'orders.form.enterShippingAddress': 'Enter shipping address',
  'orders.form.trackingNumber': 'Tracking Number',
  'orders.form.enterTrackingNumber': 'Enter tracking number',
  'orders.form.couponCode': 'Coupon code',
  'orders.form.discountReason': 'Discount reason (optional)',
  'orders.form.notePlaceholder': 'Add a note about this order...',
  'orders.form.notes': 'Notes',
  'orders.form.saveExtraFields': 'Save Extra Fields',
  'orders.form.addProductsTitle': 'Add Products to Order',
  'orders.form.lowStockTitle': 'Low Stock Warning',
  'orders.form.proceedAnyway': 'Proceed Anyway',
  'orders.form.delivery': 'Delivery',
  'orders.form.freeAbove': 'Free above {{currency}} {{amount}}',
  'orders.form.discount': 'Discount',
  'orders.status.pending': 'Pending',
  'orders.status.placed': 'Placed',
  'orders.status.confirmed': 'Confirmed',
  'orders.status.processing': 'Processing',
  'orders.status.shipped': 'Shipped',
  'orders.status.delivered': 'Delivered',
  'orders.status.cancelled': 'Cancelled',
  'orders.payment.unpaid': 'Unpaid',
  'orders.payment.partial': 'Partial',
  'orders.payment.paid': 'Paid',
  'orders.payment.refunded': 'Refunded',
  'orders.source.checkout': 'Checkout',
  'orders.source.catalog': 'Catalog',
  'orders.source.quick_reply': 'Quick Reply',
  'orders.source.manual': 'Manual',
  'orders.source.api': 'API',
  'orders.field.orderStatus': 'Order Status',
  'orders.field.paymentStatus': 'Payment Status',
  'orders.field.source': 'Source',
  'orders.field.currency': 'Currency',
  'orders.field.orderDate': 'Order Date',
  'orders.field.totalPrice': 'Total Price',
  'orders.common.error': 'Error',
  'orders.common.success': 'Success',
  'orders.msg.loginAgain': 'Please log in again',
  'orders.msg.statusUpdated': 'Order status updated successfully',
  'orders.msg.statusFailed': 'Failed to update order status',
  'orders.msg.paymentUpdated': 'Payment status updated successfully',
  'orders.msg.paymentFailed': 'Failed to update payment status',
  'orders.msg.generatingInvoice': 'Generating invoice...',
  'orders.msg.invoiceRegenerated': 'Invoice regenerated',
  'orders.msg.invoiceGenerated': 'Invoice generated',
  'orders.msg.invoiceFailed': 'Failed to generate invoice',
  'orders.msg.deleted': 'Order deleted successfully',
  'orders.msg.deleteFailed': 'Failed to delete order',
  'orders.msg.numberCopied': 'Order number copied to clipboard',
  'orders.msg.copyFailed': 'Failed to copy order number',
  'orders.msg.regenerating': 'Regenerating',
  'orders.msg.generating': 'Generating',
  'orders.msg.copied': 'Copied',
  'orders.action.edit': 'Edit',
  'orders.action.invoice': 'Invoice',
  'orders.action.regen': 'Regen',
  'orders.list.loading': 'Loading orders...',
  'orders.list.loadErrorTitle': 'Unable to Load Orders',
  'orders.list.tryAgain': 'Try Again',
  'orders.list.emptyTitle': 'No Orders Yet',
  'orders.list.emptyText': 'Create your first order or quotation to get started!',
  'orders.list.createOrder': 'Create Order',
  'orders.list.loadingMore': 'Loading more orders...',
  'orders.list.exitToDataLists': 'Exit to Data Lists',
  'orders.list.exitToOrders': 'Exit to Orders',
  'orders.filter.from': 'From',
  'orders.filter.to': 'To',
  'orders.filter.clear': 'Clear',
  'orders.modal.updateStatus': 'Update Order Status',
  'orders.modal.updatePayment': 'Update Payment Status',
  'orders.filter.search': 'Search...',
  'orders.delete.title': 'Delete Order',
  'orders.delete.message': 'Are you sure you want to delete this order? This action cannot be undone.',
  'orders.delete.confirm': 'Delete',
  'orders.common.cancel': 'Cancel',
  'orders.toolbar.sortFilter': 'Sort & Filter Fields',
  'orders.toolbar.filters': 'Filters',
  'settings.pushDiagnostics.title': 'Push notifications status',
  'settings.pushDiagnostics.permission': 'Permission',
  'settings.pushDiagnostics.registration': 'Server registration',
  'settings.pushDiagnostics.test': 'Last test',
  'settings.pushDiagnostics.reRegister': 'Re-register',
  'settings.pushDiagnostics.sendTest': 'Send test push',
  'quotations.form.customerPrefilled': 'Quotation customer was selected from the contact.',
  'orders.toolbar.createQuotation': 'Create Quotation',
  'orders.list.itemsCount': '{{count}} item(s)',
  'contactEdit.status.none': 'None',
  'contactEdit.status.order.pending': 'Pending',
  'contactEdit.status.order.placed': 'Placed',
  'contactEdit.status.order.confirmed': 'Confirmed',
  'contactEdit.status.order.processing': 'Processing',
  'contactEdit.status.order.shipped': 'Shipped',
  'contactEdit.status.order.delivered': 'Delivered',
  'contactEdit.status.order.cancelled': 'Cancelled',
  'contactEdit.status.payment.unpaid': 'Unpaid',
  'contactEdit.status.payment.partial': 'Partial',
  'contactEdit.status.payment.paid': 'Paid',
  'contactEdit.status.payment.refunded': 'Refunded',
  'contactEdit.status.quotation.draft': 'Draft',
  'contactEdit.status.quotation.sent': 'Sent',
  'contactEdit.status.quotation.accepted': 'Accepted',
  'contactEdit.status.quotation.converted': 'Converted',
  'contactEdit.status.quotation.rejected': 'Rejected',
  'contactEdit.status.quotation.expired': 'Expired',
  'contactEdit.status.assignment.active': 'Active',
  'contactEdit.status.assignment.inProgress': 'In Progress',
  'contactEdit.status.assignment.completed': 'Completed',
  'contactEdit.status.assignment.cancelled': 'Cancelled',
  'contactEdit.status.assignment.transferred': 'Transferred',
  'contactEdit.cards.copied': 'Copied',
  'contactEdit.cards.copiedMessage': '{{label}} copied to clipboard',
  'contactEdit.cards.copyFailed': 'Could not copy to clipboard',
  'contactEdit.cards.extraFields': 'Extra Fields',
  'contactEdit.cards.extraFieldsUpdated': 'Extra fields updated successfully.',
  'contactEdit.cards.extraFieldsFailed': 'Failed to update extra fields',
  'contactEdit.cards.updated': 'Updated',
  'contactEdit.cards.updateFailed': 'Update failed',
  'contactEdit.cards.orderStatusUpdated': 'Order status updated',
  'contactEdit.cards.paymentStatusUpdated': 'Payment status updated',
  'contactEdit.cards.orderUpdateFailed': 'Could not update order',
  'contactEdit.cards.quotationStatusUpdated': 'Quotation status updated',
  'contactEdit.cards.quotationUpdateFailed': 'Could not update quotation',
  'contactEdit.cards.assignmentUpdated': 'Assignment marked {{status}}',
  'contactEdit.cards.assignmentUpdateFailed': 'Could not update assignment',
  'contactEdit.cards.listUpdateFailed': 'List update failed',
  'contactEdit.cards.listUpdateFailedMessage': 'Could not update list membership',
  'contactEdit.cards.start': 'Start',
  'contactEdit.cards.complete': 'Complete',
  'contactEdit.cards.lists': 'Lists',
  'contactEdit.cards.listsAdded': 'Added',
  'contactEdit.cards.listsAvailable': 'Available',
  'contactEdit.cards.listsEmpty': 'Not added to any list.',
  'contactEdit.cards.listsNoOthers': 'No other contact lists.',
  'contactEdit.cards.order': 'Order',
  'contactEdit.cards.orderNumber': 'Order number',
  'contactEdit.cards.orderDetails': 'Order details',
  'contactEdit.cards.orderStatus': 'Order status',
  'contactEdit.cards.paymentStatus': 'Payment status',
  'contactEdit.cards.quotation': 'Quotation',
  'contactEdit.cards.quotationNumber': 'Quotation number',
  'contactEdit.cards.quotationDetails': 'Quotation details',
  'contactEdit.cards.quotationStatus': 'Quotation status',
  'contactEdit.cards.itemsCount': '{{count}} item(s)',
  'contactEdit.cards.edit': 'Edit',
  'contactEdit.documents.deleteFailed': 'Failed to delete document',
  'contactEdit.section.tags': 'Tags',
  'contactEdit.tags.addPlaceholder': 'Add tag',
  'contactEdit.tags.searchPlaceholder': 'Search tags…',
  'contactEdit.tags.noMatch': 'No tags match your search',
  'contactEdit.section.documents': 'Documents',
  'contactEdit.documents.sizeKb': '{{size}} KB',
  'contactEdit.documents.empty': 'No documents attached',
  'contactEdit.section.notes': 'Notes',
  'contactEdit.notes.loading': 'Loading notes…',
  'contactEdit.action.saving': 'Saving...',
  'contactEdit.action.create': 'Create Contact',
  'contactEdit.action.save': 'Save Changes',
  'contactEdit.action.delete': 'Delete Contact',

  // ─── Phone Setup ──────────────────────────────────────────────────────────
  'phoneSetup.headerTitle': 'Phone',
  'phoneSetup.heroTitle': 'Phone',
  'phoneSetup.heroSubtitle': 'Connect a phone provider to place and track calls with your contacts directly from your DISLIX inbox.',
  'phoneSetup.accessDeniedTitle': 'Access Denied',
  'phoneSetup.accessDeniedText': 'You need to be an admin or owner to manage the phone channel.',
  'phoneSetup.goBack': 'Go Back',
  'phoneSetup.field.apiId': 'API ID',
  'phoneSetup.field.apiIdPlaceholder': 'From Developer > API Gateway Credentials',
  'phoneSetup.field.apiSecret': 'API Secret',
  'phoneSetup.field.apiSecretPlaceholder': 'From Developer > API Gateway Credentials',
  'phoneSetup.field.apiKey': 'API Key',
  'phoneSetup.field.apiKeyPlaceholder': 'From the WebRTC credentials tab',
  'phoneSetup.field.campaignId': 'Campaign ID (optional)',
  'phoneSetup.field.campaignIdPlaceholder': 'Only needed for automated campaign dialing',
  'phoneSetup.field.callerNumber': 'Caller Number (optional)',
  'phoneSetup.field.callerNumberPlaceholder': 'Your outbound caller ID',
  'phoneSetup.connectButton': 'Connect InnoCalls Account',
  'phoneSetup.missingFieldsTitle': 'Missing Fields',
  'phoneSetup.missingFieldsMessage': 'API ID, API secret, and API key are required.',
  'phoneSetup.connectedTitle': 'Connected!',
  'phoneSetup.connectedMessage': 'Your phone account is now connected.',
  'phoneSetup.connectionFailedTitle': 'Connection Failed',
  'phoneSetup.connectionFailedMessage': 'Failed to connect phone account. Check your credentials and try again.',
  'phoneSetup.disconnectedTitle': 'Disconnected',
  'phoneSetup.disconnectedMessage': 'Your phone account has been disconnected.',
  'phoneSetup.errorTitle': 'Error',
  'phoneSetup.disconnectFailed': 'Failed to disconnect account',
  'phoneSetup.agentsSectionTitle': 'Calling Agents',
  'phoneSetup.agentsSectionSubtitle': 'Extensions found on your connected InnoCalls account. Assign each one to a teammate so they can place and receive calls.',
  'phoneSetup.noAgentsFound': 'No extensions found on this InnoCalls account yet. Create one from the InnoCalls dashboard, then tap refresh.',
  'phoneSetup.extensionLabel': 'Ext. {{extension}}',
  'phoneSetup.notAssigned': 'Not assigned',
  'phoneSetup.assign': 'Assign',
  'phoneSetup.reassign': 'Reassign',
  'phoneSetup.discoveryFailedTitle': 'Discovery Failed',
  'phoneSetup.discoveryFailedMessage': 'Failed to discover InnoCalls extensions.',
  'phoneSetup.assignExtensionTitle': 'Assign Extension {{extension}}',
  'phoneSetup.pinRequiredTitle': 'PIN Required',
  'phoneSetup.pinRequiredMessage': "Enter this extension's PIN to confirm the assignment.",
  'phoneSetup.agentLinkedTitle': 'Agent Linked',
  'phoneSetup.agentLinkedMessage': 'Extension {{extension}} is now assigned.',
  'phoneSetup.assignmentFailedTitle': 'Assignment Failed',
  'phoneSetup.assignmentFailedMessage': 'Failed to link this extension. Confirm the extension still exists on InnoCalls.',
  'phoneSetup.confirmPinTitle': 'Confirm Extension PIN',
  'phoneSetup.confirmPinText': 'Enter the PIN for extension {{extension}} to link it to {{user}}.',
  'phoneSetup.confirmPinThisUser': 'this user',
  'phoneSetup.pinPlaceholder': 'PIN',
  'phoneSetup.confirmAndLink': 'Confirm & Link',

  // ─── Avatar / Account Menu ───────────────────────────────────────────────
  'avatarMenu.loadingBusinesses': 'Loading businesses…',
  'avatarMenu.business': 'Business',
  'avatarMenu.fallbackBusinessName': 'Business',
  'avatarMenu.fallbackUserName': 'User',
  'avatarMenu.role.owner': 'Owner',
  'avatarMenu.createBusiness': 'Create Business',
  'avatarMenu.switchBusiness.title': 'Business Switching',
  'avatarMenu.switchBusiness.message': 'Business switching is being configured. Please contact support for assistance.',
  'avatarMenu.option.userManagement': 'User Management',
  'avatarMenu.option.departments': 'Departments',
  'avatarMenu.option.subscription': 'Subscription',
  'avatarMenu.option.products': 'Products',
  'avatarMenu.option.taskHistory': 'Task History',
  'avatarMenu.option.notifications': 'Notifications',
  'avatarMenu.option.settings': 'Settings',
  'avatarMenu.option.setupProgress': 'Get your business ready',
  'businessHours.title': 'How you work',
  'businessHours.subtitle': 'Used for orders, bookings and reports. You can change these later in Settings.',
  'businessHours.timezone': 'Timezone',
  'businessHours.currency': 'Currency',
  'businessHours.workingDays': 'Working days',
  'businessHours.workingHours': 'Working hours',
  'businessHours.opens': 'Opens',
  'businessHours.closes': 'Closes',
  'businessHours.perDay': 'Set different hours per day',
  'businessHours.sameHours': 'Use the same hours every day',
  'businessHours.skipLocation': 'Skip for now',
  'businessHours.errorNoDays': 'Choose at least one working day.',
  'businessHours.errorTimes': 'Closing time must be after opening time.',
  'businessHours.day.sunday': 'Sunday',
  'businessHours.day.monday': 'Monday',
  'businessHours.day.tuesday': 'Tuesday',
  'businessHours.day.wednesday': 'Wednesday',
  'businessHours.day.thursday': 'Thursday',
  'businessHours.day.friday': 'Friday',
  'businessHours.day.saturday': 'Saturday',
  'businessHours.dayShort.sunday': 'Sun',
  'businessHours.dayShort.monday': 'Mon',
  'businessHours.dayShort.tuesday': 'Tue',
  'businessHours.dayShort.wednesday': 'Wed',
  'businessHours.dayShort.thursday': 'Thu',
  'businessHours.dayShort.friday': 'Fri',
  'businessHours.dayShort.saturday': 'Sat',
  'businessProfile.title': 'Business profile',
  'businessProfile.details': 'Business details',
  'businessProfile.changeLogo': 'Change logo',
  'businessProfile.detailsInvalid': 'Enter the business name and a valid email.',
  'businessProfile.location': 'Location',
  'businessProfile.address': 'Address',
  'businessProfile.pinSet': 'Location pinned on the map',
  'businessProfile.saved': 'Business profile saved',
  'businessProfile.saveFailed': 'Could not save the business profile',
  'avatarMenu.option.faq': 'FAQ',
  'avatarMenu.option.logout': 'Logout',
  'avatarMenu.faq.title': 'FAQ',
  'avatarMenu.faq.message': 'FAQ is being configured. Please contact support for assistance.',
  'avatarMenu.logout.title': 'Logged Out',
  'avatarMenu.logout.message': 'You have been successfully logged out.',

  // User Setup / Team Members
  'userSetup.pendingInvite': 'Pending invite',
  'userSetup.teamMembers': 'Team Members',
  'userSetup.teamMembersCount': 'Team Members ({{count}})',
  'userSetup.teamMembersFiltered': 'Team Members ({{filtered}} of {{total}})',
  'userSetup.inviteUser': 'Invite User',
  'userSetup.userLimits': 'User Limits',
  'userSetup.slotsRemaining': '{{count}} slots remaining',
  'userSetup.currentUsers': 'Current Users',
  'userSetup.maximumUsers': 'Maximum Users',
  'userSetup.usersOfMax': '{{current}} of {{max}} users',
  'userSetup.searchPlaceholder': 'Search users by name, email, or phone...',
  'userSetup.searchPlaceholderLoading': 'Loading business...',
  'userSetup.searchPlaceholderNoBusiness': 'Please select a business first',
  'userSetup.loadingBusiness': 'Loading business...',
  'userSetup.loadingUsers': 'Loading users...',
  'userSetup.noBusinessFound': 'No Business Found',
  'userSetup.noBusinessFoundDesc': 'Please create a business first to manage users',
  'userSetup.createBusiness': 'Create Business',
  'userSetup.reloadBusiness': 'Reload Business',
  'userSetup.debugInfo': 'Debug Information:',
  'userSetup.debugBusiness': 'Business: {{value}}',
  'userSetup.debugLoading': 'Loading: {{value}}',
  'userSetup.debugUser': 'User: {{value}}',
  'userSetup.debugBusinessId': 'Business ID: {{id}}',
  'userSetup.found': 'Found',
  'userSetup.notFound': 'Not Found',
  'userSetup.yes': 'Yes',
  'userSetup.no': 'No',
  'userSetup.loggedIn': 'Logged In',
  'userSetup.notLoggedIn': 'Not Logged In',
  'userSetup.demoModeTitle': 'Temporary Demo Mode',
  'userSetup.demoModeDesc': "Since business is not detected, here's a demo of the user management interface:",
  'userSetup.demoUsersCount': 'Demo Users ({{count}})',
  'userSetup.demoModeRoleChange': 'This is a demo - role change not available',
  'userSetup.demoModeRemove': 'This is a demo - user removal not available',
  'userSetup.noUsersFound': 'No Users Found',
  'userSetup.inviteFirstUser': 'Invite your first user to get started',
  'userSetup.userLimitReached': 'User limit reached. Upgrade your plan to add more users.',
  'userSetup.noUsersMatchSearch': 'No users match your search for "{{query}}"',
  'userSetup.clearSearch': 'Clear Search',
  'userSetup.owner': 'Owner',
  'userSetup.noDepartmentsAssigned': 'No departments assigned',
  'userSetup.roleAdmin': 'Admin',
  'userSetup.roleManager': 'Manager',
  'userSetup.roleMember': 'Member',
  'userSetup.roleViewer': 'Viewer',
  'userSetup.statusActive': 'Active',
  'userSetup.statusPending': 'Pending',
  'userSetup.statusSuspended': 'Suspended',
  'userSetup.statusLeft': 'Left',
  'userSetup.inviteModalTitle': 'Invite New User',
  'userSetup.emailAddress': 'Email Address',
  'userSetup.emailPlaceholder': 'user@example.com',
  'userSetup.emailRequired': 'Email address is required',
  'userSetup.firstName': 'First Name',
  'userSetup.firstNamePlaceholder': 'John',
  'userSetup.firstNameRequired': 'First name is required',
  'userSetup.lastName': 'Last Name',
  'userSetup.lastNamePlaceholder': 'Doe',
  'userSetup.lastNameRequired': 'Last name is required',
  'userSetup.role': 'Role',
  'userSetup.departmentsOptional': 'Departments (Optional)',
  'userSetup.selectDepartments': 'Select Departments',
  'userSetup.noDepartmentsSelected': 'No departments selected',
  'userSetup.notesOptional': 'Notes (Optional)',
  'userSetup.notesPlaceholder': 'Additional notes about this user...',
  'userSetup.cancel': 'Cancel',
  'userSetup.sending': 'Sending...',
  'userSetup.sendInvitation': 'Send Invitation',
  'userSetup.removeUserTitle': 'Remove User',
  'userSetup.removeUserMessage': 'This will remove {{name}} from your business. This action cannot be undone.',
  'userSetup.resendInvitationTitle': 'Resend Invitation',
  'userSetup.resendInvitationMessage': 'This will send a new invitation email to {{name}}.',
  'userSetup.resendInvitationConfirm': 'Resend Invitation',
  'userSetup.changeRoleTitle': 'Change Role',
  'userSetup.selectNewRoleFor': 'Select new role for {{name}}',
  'userSetup.noBusinessError': 'No Business',
  'userSetup.noBusinessErrorDesc': 'Please select a business first',
  'userSetup.emailRequiredTitle': 'Email Required',
  'userSetup.emailRequiredDesc': 'Please enter a valid email address',
  'userSetup.firstNameRequiredTitle': 'First Name Required',
  'userSetup.firstNameRequiredDesc': "Please enter the user's first name",
  'userSetup.lastNameRequiredTitle': 'Last Name Required',
  'userSetup.lastNameRequiredDesc': "Please enter the user's last name",
  'userSetup.invalidEmailTitle': 'Invalid Email',
  'userSetup.invalidEmailDesc': 'Please enter a valid email address',
  'userSetup.invitationSentTitle': 'Invitation Sent',
  'userSetup.invitationSentDesc': 'Invitation sent to {{email}}',
  'userSetup.invitationFailedTitle': 'Invitation Failed',
  'userSetup.invitationFailedDefault': 'Failed to send invitation',
  'userSetup.errorTitle': 'Error',
  'userSetup.userRemovedTitle': 'User Removed',
  'userSetup.userRemovedDesc': 'User has been removed from the business',
  'userSetup.removeFailedTitle': 'Remove Failed',
  'userSetup.removeFailedDefault': 'Failed to remove user',
  'userSetup.removeUserErrorDefault': 'Failed to remove user',
  'userSetup.invitationResentTitle': 'Invitation Resent',
  'userSetup.invitationResentDesc': 'Invitation has been resent to the user',
  'userSetup.resendFailedTitle': 'Resend Failed',
  'userSetup.resendFailedDefault': 'Failed to resend invitation',
  'userSetup.resendErrorDefault': 'Failed to resend invitation',
  'userSetup.roleUpdatedTitle': 'Role Updated',
  'userSetup.roleUpdatedDesc': 'User role has been updated successfully',
  'userSetup.updateFailedTitle': 'Update Failed',
  'userSetup.updateFailedDefault': 'Failed to update user role',
  'userSetup.updateRoleErrorDefault': 'Failed to update user role',
  'userSetup.failedToLoadUsersTitle': 'Failed to Load Users',
  'userSetup.failedToLoadLimitsTitle': 'Failed to Load Limits',
  'userSetup.unknownError': 'Unknown error',
  'userSetup.loadUserDataError': 'Failed to load user data',
  'userSetup.debugModeTitle': 'Debug',
  'userSetup.debugModeReloading': 'Reloading businesses...',

  // ─── Data Lists ───────────────────────────────────────────────────────────
  'assignmentRules.title': "Assignment Setup",
  'assignmentRules.subtitle': "{{count}} rules",
  'assignmentRules.new': "New rule",
  'assignmentRules.save': "Save rule",
  'assignmentRules.saved': "Rule saved.",
  'assignmentRules.delete': "Delete rule",
  'assignmentRules.deleteTitle': "Delete this rule?",
  'assignmentRules.deleteMessage': "It stops right away; its queued actions are skipped.",
  'assignmentRules.error.load': "Couldn't load the assignment rules.",
  'assignmentRules.error.save': "Couldn't save the rule.",
  'assignmentRules.intro': "Rules run when something is assigned — to anyone, chosen people or departments. For a bulk assignment, a rule runs once for each assigned item and you get one summary.",
  'assignmentRules.empty.title': "No assignment rules yet",
  'assignmentRules.empty.message': "For example: when a contact is assigned to Sales, run the welcome workflow on WhatsApp and escalate to the manager if nobody starts it within 4 hours.",
  'assignmentRules.when': "When assigned to {{who}}",
  'assignmentRules.to.anyone': "Anyone",
  'assignmentRules.to.users': "Chosen people",
  'assignmentRules.to.departments': "Chosen departments",
  'assignmentRules.type.contact': "Contacts",
  'assignmentRules.type.conversation': "Conversations",
  'assignmentRules.type.task': "Tasks",
  'assignmentRules.type.ticket': "Tickets",
  'assignmentRules.type.calendar': "Calendar",
  'assignmentRules.type.email': "Emails",
  'assignmentRules.type.lead': "Leads",
  'assignmentRules.type.deal': "Deals",
  'assignmentRules.type.project': "Projects",
  'assignmentRules.type.visit': "Visits",
  'assignmentRules.type.phone_call': "Calls",
  'assignmentRules.batch.any': "Single or bulk",
  'assignmentRules.batch.single': "Single only",
  'assignmentRules.batch.bulk': "Bulk",
  'assignmentRules.source.manual': "By hand",
  'assignmentRules.source.bulk': "Bulk assign",
  'assignmentRules.source.flow': "Workflows & AI",
  'assignmentRules.source.channel_settings': "Channel auto-assign",
  'assignmentRules.source.quick_reply': "Quick replies",
  'assignmentRules.source.webhook': "API / webhook",
  'assignmentRules.source.conversation_create': "New conversation",
  'assignmentRules.source.contact_add': "New contact",
  'assignmentRules.summary.workflow': "Run \"{{name}}\"",
  'assignmentRules.summary.notify': "Notify",
  'assignmentRules.summary.tags': "Tag",
  'assignmentRules.summary.due': "Due in {{hours}}h",
  'assignmentRules.summary.priority': "Set priority",
  'assignmentRules.summary.escalate': "Escalate after {{hours}}h",
  'assignmentRules.stats.handled': "{{count}} handled",
  'assignmentRules.stats.failed': "{{count}} failed",
  'assignmentRules.stats.last': "Last run: {{done}} of {{total}} · {{when}}",
  'assignmentRules.section.when': "When",
  'assignmentRules.section.then': "Then",
  'assignmentRules.section.history': "Recent runs",
  'assignmentRules.field.name': "Rule name",
  'assignmentRules.field.active': "Rule is on",
  'assignmentRules.field.assignedTo': "Assigned to",
  'assignmentRules.field.types': "What is assigned",
  'assignmentRules.field.batch': "Single or bulk",
  'assignmentRules.field.sources': "Assigned from",
  'assignmentRules.field.workflow': "Workflow",
  'assignmentRules.field.channel': "Run it on",
  'assignmentRules.field.managers': "The department's manager",
  'assignmentRules.field.people': "These people",
  'assignmentRules.field.message': "Message (optional)",
  'assignmentRules.field.tagsAdd': "Add tags",
  'assignmentRules.field.tagsRemove': "Remove tags",
  'assignmentRules.field.priority': "Priority",
  'assignmentRules.field.dueIn': "Due in (hours)",
  'assignmentRules.field.after': "After (hours)",
  'assignmentRules.field.reassignUser': "Reassign to a person",
  'assignmentRules.field.reassignDepartment': "Or to a department",
  'assignmentRules.field.notifyManagers': "Notify the department's manager",
  'assignmentRules.field.notifyPeople': "Notify these people",
  'assignmentRules.hint.anyType': "None chosen = anything assigned.",
  'assignmentRules.hint.anySource': "None chosen = from anywhere.",
  'assignmentRules.hint.bulk': "Actions run in this order. For a bulk assignment they repeat for each assigned item.",
  'assignmentRules.hint.template': "WhatsApp only allows free messages within 24 hours of the contact's last message. Start the workflow with a template message to reach contacts outside that window.",
  'assignmentRules.action.workflow': "Run a workflow",
  'assignmentRules.action.workflowHint': "For the assigned contact, in their conversation.",
  'assignmentRules.action.notify': "Notify people",
  'assignmentRules.action.notifyHint': "Besides the usual notification to whoever is assigned.",
  'assignmentRules.action.tags': "Tag the contact",
  'assignmentRules.action.tagsHint': "Add or remove contact tags.",
  'assignmentRules.action.deadline': "Set a deadline",
  'assignmentRules.action.deadlineHint': "Priority, and when it is due.",
  'assignmentRules.action.escalate': "Escalate if not handled",
  'assignmentRules.action.escalateHint': "After some hours, reassign it or tell someone.",
  'assignmentRules.when.not_started': "If not started",
  'assignmentRules.when.not_completed': "If not done",
  'assignmentRules.channel.whatsapp': "WhatsApp",
  'assignmentRules.channel.facebook_messenger': "Messenger",
  'assignmentRules.priority.low': "Low",
  'assignmentRules.priority.normal': "Normal",
  'assignmentRules.priority.high': "High",
  'assignmentRules.priority.urgent': "Urgent",
  'assignmentRules.flow.unpublished': "not published",
  'assignmentRules.none.users': "No team members yet.",
  'assignmentRules.none.departments': "No departments yet.",
  'assignmentRules.none.flows': "No workflows yet — create one in Workflows.",
  'assignmentRules.placeholder.name': "e.g. Welcome new Sales contacts",
  'assignmentRules.placeholder.message': "e.g. New contact for you — call within the hour",
  'assignmentRules.placeholder.tags': "Comma separated — e.g. new-lead, sales",
  'assignmentRules.history.actions': "Actions",
  'assignmentRules.history.escalate': "Escalation check",
  'assignmentRules.history.counts': "{{done}} of {{total}}",
  'assignmentRules.history.skipped': "{{count}} skipped",
  'assignmentRules.history.empty': "This rule has not run yet.",
  'setup.step.assignmentRules.title': "Set up assignment rules",
  'setup.step.assignmentRules.description': "Run a workflow, notify or escalate when contacts are assigned",
  'settings.items.assignmentRules.title': "Assignment Setup",
  'settings.items.assignmentRules.description': "What happens when something is assigned",
  'permissions.general.assignmentRules.label': "Assignment rules",
  'permissions.general.assignmentRules.description': "See and change what happens when something is assigned (Assignment Setup)",
  'leadFinder.rerun.action': "Rerun",
  'leadFinder.rerun.title': "Run this search again?",
  'leadFinder.rerun.hint': "Starts a new search with the same settings. It counts toward this month's searches.",
  'leadFinder.rerun.onlyNew': "Only new businesses",
  'leadFinder.rerun.onlyNewHint': "Skip businesses earlier runs of this search already found.",
  'leadFinder.rerun.start': "Run again",
  'leadFinder.rerun.started': "The search is running again.",
  'leadFinder.duplicate.action': "Duplicate",
  'leadFinder.form.duplicateTitle': "New search from a copy",
  'leadFinder.form.phoneType': "Phone must be",
  'leadFinder.phoneType.any': "Mobile or landline",
  'leadFinder.phoneType.mobile': "Mobile",
  'leadFinder.phoneType.landline': "Landline",
  'leadFinder.filter.hasMobile': "Has mobile",
  'leadFinder.stat.previous': "Found before",
  'leadFinder.act.toList': "Add to list",
  'leadFinder.act.list': "List",
  'leadFinder.result.inLists': "In {{count}} list(s)",
  'leadFinder.addList.title': "Add {{count}} to a list",
  'leadFinder.addList.locked': "Data lists are not in your plan.",
  'leadFinder.addList.existing': "Existing list",
  'leadFinder.addList.new': "New list",
  'leadFinder.addList.namePlaceholder': "List name — e.g. Riyadh cafés",
  'leadFinder.addList.kind.static': "Static list",
  'leadFinder.addList.kind.contacts': "Contacts list",
  'leadFinder.addList.staticHint': "A row per business with its name, phone, mobile, email, website, address, city, category, rating, social and map links.",
  'leadFinder.addList.contactsHint': "Each business becomes a contact (or uses the contact it already is) and joins the list.",
  'leadFinder.addList.mapping': "Fill each column with",
  'leadFinder.addList.skip': "Leave empty",
  'leadFinder.addList.add': "Add to list",
  'leadFinder.addList.done': "{{count}} added to \"{{name}}\".",
  'leadFinder.addList.failed': "{{count}} failed",
  'leadFinder.listField.name': "Name",
  'leadFinder.listField.phone': "Phone",
  'leadFinder.listField.mobile': "Mobile",
  'leadFinder.listField.landline': "Landline",
  'leadFinder.listField.email': "Email",
  'leadFinder.listField.website': "Website",
  'leadFinder.listField.address': "Address",
  'leadFinder.listField.city': "City",
  'leadFinder.listField.country': "Country",
  'leadFinder.listField.category': "Category",
  'leadFinder.listField.description': "Description",
  'leadFinder.listField.rating': "Rating",
  'leadFinder.listField.reviews': "Reviews",
  'leadFinder.listField.socials': "Social links",
  'leadFinder.listField.mapLink': "Map link",
  'leadFinder.listField.aiScore': "Fit score",
  'leadFinder.listField.source': "Source",
  'contacts.bulkList.createFailed': "Couldn't create the list.",
  'contacts.bulkList.locked': "Data lists are not in your plan — upgrade to group contacts into lists.",
  'contacts.bulkList.upgrade': "See plans",
  'contacts.bulkList.newPlaceholder': "New list name",
  'contacts.bulkList.create': "Create",
  'contacts.bulkList.empty': "No contacts lists yet — name one above to create it.",
  'leadFinder.title': "Lead Finder",
  'leadFinder.shortcut': "Find businesses to reach, with AI",
  'leadFinder.refresh': "Refresh",
  'leadFinder.subtitle.one': "1 search",
  'leadFinder.subtitle.count': "{{count}} searches",
  'leadFinder.started': "\"{{name}}\" started — results arrive as they are found.",
  'leadFinder.error.load': "Couldn't load Lead Finder.",
  'leadFinder.error.start': "Couldn't start the search.",
  'leadFinder.error.plan': "The AI couldn't set up the search. Try describing it differently.",
  'leadFinder.error.act': "Couldn't update the results.",
  'leadFinder.error.export': "Couldn't export the results.",
  'leadFinder.locked.title': "Lead Finder is not in your plan",
  'leadFinder.locked.message': "Find businesses by area, category and platform, then add them as contacts or vendors. Upgrade to use it.",
  'leadFinder.locked.upgrade': "See plans",
  'leadFinder.ai.title': "Describe who you are looking for",
  'leadFinder.ai.hint': "Describe entities or individuals and the information you need. AI translates your request into filters to review before searching.",
  'leadFinder.ai.placeholder': "e.g. Coffee shops in Riyadh with a phone number and Instagram",
  'leadFinder.ai.run': "Find with AI",
  'leadFinder.ai.plan': "Review settings first",
  'leadFinder.form.manual': "Or set it up yourself",
  'leadFinder.form.title': "New search",
  'leadFinder.form.reviewTitle': "Review the AI's search",
  'leadFinder.form.name': "Name",
  'leadFinder.form.namePlaceholder': "e.g. Riyadh coffee shops",
  'leadFinder.form.keywords': "Keywords",
  'leadFinder.form.keywordsPlaceholder': "Comma separated, any language — e.g. coffee, قهوة",
  'leadFinder.form.categories': "Map categories",
  'leadFinder.form.categoriesPlaceholder': "Search categories — e.g. restaurant, clinic",
  'leadFinder.form.region': "Area",
  'leadFinder.form.regionPick': "Pick on the map",
  'leadFinder.form.regionChange': "Change area",
  'leadFinder.form.regionPicked': "Selected area",
  'leadFinder.form.sources': "Search in",
  'leadFinder.form.notInPlan': "not in plan",
  'leadFinder.form.links': "Links",
  'leadFinder.form.linksPlaceholder': "One link per line — websites, Facebook / Instagram pages, Google Maps places",
  'leadFinder.form.required': "Every result must have",
  'leadFinder.form.platforms': "Platforms wanted",
  'leadFinder.form.platformsHint': "Results on these platforms are preferred (none = any).",
  'leadFinder.form.enrich': "Read their websites",
  'leadFinder.form.enrichHint': "Fills missing phones, emails, social pages and descriptions from each business's website.",
  'leadFinder.form.limit': "Most results",
  'leadFinder.form.start': "Start search",
  'leadFinder.map.title': "Area to search",
  'leadFinder.map.confirm': "Use this area",
  'leadFinder.map.name': "Area name",
  'leadFinder.usage.title': "This month",
  'leadFinder.usage.runsLabel': "Searches",
  'leadFinder.usage.resultsLabel': "Results",
  'leadFinder.usage.runs': "{{used}} of {{limit}} searches",
  'leadFinder.usage.runsUnlimited': "{{used}} searches",
  'leadFinder.usage.results': "{{used}} of {{limit}} results",
  'leadFinder.usage.resultsUnlimited': "{{used}} results",
  'leadFinder.usage.perRun': "Up to {{limit}} results per search",
  'leadFinder.usage.noGoogle': "Google Maps search is not in your plan — the Dislix map, websites and links are searched.",
  'leadFinder.runs.title': "Searches",
  'leadFinder.runs.empty': "No searches yet. Describe who you are looking for above.",
  'leadFinder.origin.workflow': "From a workflow",
  'leadFinder.status.queued': "Waiting to start",
  'leadFinder.status.running': "Running",
  'leadFinder.status.done': "Done",
  'leadFinder.status.partial': "Target not reached",
  'leadFinder.run.shortfall': "Found {{count}} of {{target}} requested businesses. Check the source notes below, then adjust the search or add sources and rerun.",
  'leadFinder.status.failed': "Failed",
  'leadFinder.status.cancelled': "Stopped",
  'leadFinder.phase.sources': "Starting…",
  'leadFinder.phase.links': "Reading your links…",
  'leadFinder.phase.map': "Searching the Dislix map…",
  'leadFinder.phase.google_maps': "Searching Google Maps…",
  'leadFinder.phase.enrich': "Reading websites for contact details…",
  'leadFinder.phase.checking': "Checking against your contacts and vendors…",
  'leadFinder.phase.scoring': "AI is rating each result…",
  'leadFinder.progress': "{{kept}} kept · {{found}} found · {{duplicates}} duplicates · {{existing}} already yours",
  'leadFinder.stat.kept': "AI matches",
  'leadFinder.stat.found': "Found",
  'leadFinder.stat.duplicates': "Duplicates",
  'leadFinder.stat.rejected': "Other found",
  'leadFinder.view.matches': "AI matches",
  'leadFinder.view.other': "Other found",
  'leadFinder.view.otherHint': "Found but turned away by a check (reason shown). Keep one to make it a match with its full details — it then counts toward this month's results.",
  'leadFinder.act.keep': "Keep",
  'leadFinder.act.done.keep': "{{count}} kept as matches.",
  'leadFinder.rejection.outside_area': 'Outside the area',
  'leadFinder.rejection.missing_contact': 'No usable phone or location',
  'leadFinder.suggestions.title': 'Suggested for your business',
  'leadFinder.suggestions.hint': 'Your profile and AI persona help suggest relevant customers or partners. Review the prompt and filters before starting.',
  'leadFinder.suggestions.loading': 'Reviewing your business and preparing searches…',
  'leadFinder.suggestions.failed': 'Could not prepare suggestions. Retry or write your search below.',
  'leadFinder.suggestions.review': 'Review this search',
  'leadFinder.suggestions.refresh': 'Refresh suggestions',
  'leadFinder.suggestions.source.business_profile': 'Business profile',
  'leadFinder.suggestions.source.business_settings': 'Business settings',
  'leadFinder.suggestions.source.ai_knowledge': 'AI business knowledge',
  'leadFinder.suggestions.source.ai_persona': 'AI persona',
  'leadFinder.suggestions.source.products': 'Products and services',
  'leadFinder.rejection.outside_area_or_missing_details': 'Outside area or missing contact details',
  'leadFinder.rejection.missing_details': 'Missing required details',
  'leadFinder.rejection.excluded': 'Excluded activity',
  'leadFinder.rejection.wrong_type': 'Wrong target type',
  'leadFinder.rejection.topic_unverified': 'Profession or activity not verified',
  'leadFinder.rejection.ai_mismatch': 'Does not match the request',
  'leadFinder.rejection.type_unverified': 'Person or business type not verified',
  'leadFinder.rejection.missing_requested_fields': 'Required custom fields not verified',
  'leadFinder.rejection.below_min_score': 'Below minimum score',
  'leadFinder.stat.enriched': "From websites",
  'leadFinder.stat.existing': "Already yours",
  'leadFinder.source.map': "Dislix map",
  'leadFinder.source.google_maps': "Google Maps",
  'leadFinder.source.links': "Links",
  'leadFinder.source.web': "Web (profiles & sites)",
  'leadFinder.phase.web': "Searching the web…",
  'leadFinder.usage.noWeb': "Web search (LinkedIn and other public profiles, business sites) is not in your plan.",
  'leadFinder.opener.title': "Suggested opener",
  'leadFinder.opener.copy': "Copy the suggested opener",
  'leadFinder.opener.copied': "Copied — paste it into your message.",
  'leadFinder.field.name': "Name",
  'leadFinder.field.phone': "Phone",
  'leadFinder.field.location': "Location",
  'leadFinder.field.email': "Email",
  'leadFinder.field.website': "Website",
  'leadFinder.field.description': "Description",
  'leadFinder.platform.website': "Website",
  'leadFinder.platform.google': "Google",
  'leadFinder.platform.facebook': "Facebook",
  'leadFinder.platform.instagram': "Instagram",
  'leadFinder.platform.linkedin': "LinkedIn",
  'leadFinder.platform.x': "X",
  'leadFinder.platform.tiktok': "TikTok",
  'leadFinder.platform.youtube': "YouTube",
  'leadFinder.platform.snapchat': "Snapchat",
  'leadFinder.platform.whatsapp': "WhatsApp",
  'leadFinder.tab.new': "To review",
  'leadFinder.tab.contact': "Contacts",
  'leadFinder.tab.vendor': "Vendors",
  'leadFinder.tab.dismissed': "Dismissed",
  'leadFinder.tab.all': "All",
  'leadFinder.results.search': "Search name, category, city, phone",
  'leadFinder.results.selectAll': "Select all",
  'leadFinder.results.count': "{{count}} results",
  'leadFinder.results.selected': "{{count}} selected",
  'leadFinder.results.waiting': "Searching — results appear here as they are found.",
  'leadFinder.results.empty': "No results here.",
  'leadFinder.filter.hasPhone': "Has phone",
  'leadFinder.filter.hasEmail': "Has email",
  'leadFinder.filter.hasWebsite': "Has website",
  'leadFinder.filter.notExisting': "Not yet a contact",
  'leadFinder.filter.goodFit': "Good fit (70+)",
  'leadFinder.target.any': 'Entities and individuals',
  'leadFinder.target.entity': 'Entities / businesses',
  'leadFinder.target.individual': 'Individual professionals',
  'leadFinder.criteria.target': 'Who are you looking for?',
  'leadFinder.criteria.purpose': 'Search purpose and evaluation brief',
  'leadFinder.criteria.professions': 'Specific professions / activities (comma-separated)',
  'leadFinder.criteria.professionsPlaceholder': 'e.g. life coach, مدرب حياة',
  'leadFinder.criteria.exclude': 'Exclude these words or activities (comma-separated)',
  'leadFinder.criteria.minimum': 'Minimum acceptable fit score (0–100)',
  'leadFinder.criteria.useAi': 'Evaluate relevance and extract fields with AI',
  'leadFinder.criteria.evaluationHint': 'Matches are checked before counting toward the target. Rules remain available if AI cannot evaluate a result.',
  'leadFinder.criteria.noAi': 'AI is not connected. Set the search filters below; published evidence and matching rules will evaluate results.',
  'leadFinder.criteria.individualHint': 'Searches use public professional listings and pages. Maps mainly contain places; add public profile links for people not listed there. Unverified people will not count as matches.',
  'leadFinder.criteria.fields': 'Fields to collect for this search',
  'leadFinder.criteria.fieldsHint': 'Choose your own labels. Available values become contact custom fields and list columns. Missing values stay blank; required values must be evidenced.',
  'leadFinder.criteria.fieldPlaceholder': 'e.g. Specialty, Languages, Years of experience',
  'leadFinder.criteria.addField': 'Add field',
  'leadFinder.criteria.remove': 'Remove',
  'leadFinder.criteria.required': 'Require a published value',
  'leadFinder.criteria.expected': 'Optional value to match (yes/no for boolean)',
  'leadFinder.criteria.type.text': 'Text',
  'leadFinder.criteria.type.number': 'Number',
  'leadFinder.criteria.type.boolean': 'Yes / no',
  'leadFinder.criteria.scoreRange': 'Fit score range (0–100)',
  'leadFinder.criteria.min': 'Minimum',
  'leadFinder.criteria.max': 'Maximum',
  'leadFinder.criteria.filterValue': 'Exact field value',
  'leadFinder.criteria.method.ai': 'AI evaluated',
  'leadFinder.criteria.method.rules': 'Rules evaluated',
  'leadFinder.listField.profession': 'Profession',
  'leadFinder.listField.entityType': 'Target type',
  'leadFinder.sort.title': "Sort:",
  'leadFinder.sort.score': "Best fit",
  'leadFinder.sort.rating': "Rating",
  'leadFinder.sort.name': "Name",
  'leadFinder.result.new': "To review",
  'leadFinder.result.contact': "Contact",
  'leadFinder.result.vendor': "Vendor",
  'leadFinder.result.dismissed': "Dismissed",
  'leadFinder.result.platformMatch': 'On a wanted platform',
  'leadFinder.result.existingContact': "Already a contact",
  'leadFinder.result.existingVendor': "Already a vendor",
  'leadFinder.act.contact': "Add contact",
  'leadFinder.act.linkContact': "Use existing contact",
  'leadFinder.act.vendor': "Add vendor",
  'leadFinder.act.restore': "Restore",
  'leadFinder.act.message': "Message",
  'leadFinder.act.openVendors': "Open vendors",
  'leadFinder.act.contacts': "Add as contacts",
  'leadFinder.act.vendors': "Add as vendors",
  'leadFinder.act.dismiss': "Dismiss",
  'leadFinder.act.done.contact': "{{count}} added as contacts.",
  'leadFinder.act.done.vendor': "{{count}} added as vendors.",
  'leadFinder.act.done.dismiss': "{{count}} dismissed.",
  'leadFinder.act.done.restore': "{{count}} restored.",
  'leadFinder.act.partial': "{{done}} done, {{failed}} failed",
  'leadFinder.assign.title': "Add {{count}} as contacts",
  'leadFinder.assign.hint': "Assign them to a team member to follow up, or just add them.",
  'leadFinder.assign.nobody': "Just add them (no assignment)",
  'leadFinder.run.cancel': "Stop search",
  'leadFinder.run.cancelTitle': "Stop this search?",
  'leadFinder.run.cancelMessage': "What was found so far is kept.",
  'leadFinder.run.cancelled': "The search is stopping.",
  'leadFinder.run.stopping': "Stopping…",
  'leadFinder.run.export': "Export CSV",
  'leadFinder.run.exportWebOnly': "Export is available on the web app.",
  'dataLists.title': 'Data Lists',
  'dataLists.subtitle.count': '{{count}} lists',
  'dataLists.subtitle.countOne': '1 list',
  'dataLists.searchPlaceholder': 'Search lists...',
  'dataLists.create': 'Create List',
  'dataLists.empty.title': 'No data lists yet',
  'dataLists.empty.message': 'Create your first list to start collecting structured records.',
  'dataLists.loading': 'Loading lists...',
  'dataLists.error.loadTitle': 'Unable to Load Lists',
  'dataLists.error.loadFailed': 'Failed to load data lists',
  'dataLists.card.columns': '{{count}} columns',
  'dataLists.card.columnsOne': '1 column',
  'dataLists.card.hasRecords': 'Has records',
  'dataLists.card.noRecords': 'Empty',
  'dataLists.actions.edit': 'Edit schema',
  'dataLists.actions.records': 'Records',
  'dataLists.actions.delete': 'Delete',
  'dataLists.delete.title': 'Delete List',
  'dataLists.delete.message': 'Are you sure you want to delete "{{name}}"? This cannot be undone.',
  'dataLists.delete.confirm': 'Delete',
  'dataLists.delete.cancel': 'Cancel',
  'dataLists.delete.success': 'List deleted successfully',
  'dataLists.delete.failed': 'Failed to delete list',
  'dataLists.notifications.errorTitle': 'Error',
  'dataLists.notifications.successTitle': 'Success',

  // Schema screen
  'dataLists.schema.createTitle': 'Create List',
  'dataLists.schema.editTitle': 'Edit List',
  'dataLists.schema.nameLabel': 'Name',
  'dataLists.schema.namePlaceholder': 'e.g. Support Tickets',
  'dataLists.schema.descriptionLabel': 'Description (optional)',
  'dataLists.schema.descriptionPlaceholder': 'What is this list for?',
  'dataLists.schema.aiMeaningLabel': 'AI understands this list',
  'dataLists.schema.aiMeaningHint': 'The AI assistant finds records by what they mean, in any language — not only by exact words. Turn on for lists you ask about often (e.g. services, rooms, models). Phone and email fields are never sent to the AI.',
  'dataLists.schema.aiMeaningFailed': 'AI understanding could not be turned on for this list.',
  'dataLists.schema.columnsSection': 'Columns',
  'dataLists.schema.addColumn': 'Add Column',
  'dataLists.schema.repeaterFieldsHint': 'Define the fields each row in this list will have',
  'dataLists.schema.repeaterFieldNamePlaceholder': 'Field name',
  'dataLists.schema.addRepeaterField': 'Add Field',
  'dataLists.schema.columnName': 'Column name',
  'dataLists.schema.columnNamePlaceholder': 'e.g. Full name',
  'dataLists.schema.columnType': 'Type',
  'dataLists.schema.typeLocked': 'Type is locked because this list already has records.',
  'dataLists.schema.nullable': 'Nullable',
  'dataLists.schema.notNullable': 'Not null',
  'dataLists.schema.required': 'Required',
  'dataLists.schema.unique': 'Unique',
  'dataLists.schema.advanced': 'Advanced',
  'dataLists.schema.dateOnly': 'Date only',
  'dataLists.schema.dateTime': 'Date & time',
  'dataLists.schema.relationMultiple': 'Many-to-many (multiple records)',
  'dataLists.schema.min': 'Min',
  'dataLists.schema.max': 'Max',
  'dataLists.schema.enum': 'Allowed values (comma-separated)',
  'dataLists.schema.enumPlaceholder': 'red, green, blue',
  'dataLists.schema.regex': 'Regex pattern',
  'dataLists.schema.regexPlaceholder': '^[A-Z]{3}$',
  'dataLists.schema.relationTarget': 'Related list',
  'dataLists.schema.relationTargetPlaceholder': 'Select a list',
  'dataLists.schema.onDelete': 'On delete',
  'dataLists.schema.onDelete.cascade': 'Cascade',
  'dataLists.schema.onDelete.setNull': 'Set null',
  'dataLists.schema.onDelete.restrict': 'Restrict',
  'dataLists.schema.moveUp': 'Move up',
  'dataLists.schema.moveDown': 'Move down',
  'dataLists.schema.removeColumn': 'Remove column',
  'dataLists.schema.assignedSection': 'Assigned to',
  'dataLists.schema.assignedHint': 'Only assigned users or departments (plus admins) can manage records manually. Leave empty for everyone.',
  'dataLists.schema.assignUsers': 'Users',
  'dataLists.schema.assignDepartments': 'Departments',
  'dataLists.schema.selectUsers': 'Select users',
  'dataLists.schema.selectDepartments': 'Select departments',
  'dataLists.schema.usersSelected': '{{count}} selected',
  'dataLists.schema.save': 'Save List',
  'dataLists.schema.creating': 'Creating...',
  'dataLists.schema.saving': 'Saving...',
  'dataLists.schema.validation.nameRequired': 'List name is required',
  'dataLists.schema.validation.columnRequired': 'Add at least one column',
  'dataLists.schema.validation.columnNameRequired': 'Every column needs a name',
  'dataLists.schema.validation.relationTargetRequired': 'Relation columns need a target list',
  'dataLists.schema.createSuccess': 'List created successfully',
  'dataLists.schema.updateSuccess': 'List updated successfully',
  'dataLists.schema.saveFailed': 'Failed to save list',
  'dataLists.schema.loadFailed': 'Failed to load list',
  'dataLists.schema.validation.systemModuleRequired': 'Select a system module',
  'dataLists.schema.validation.webhookUrlRequired': 'Webhook URL is required',
  'dataLists.schema.validation.fieldMappingRequired': 'Map at least one field',

  // Shape picker (System / Webhook / Custom / System+Webhook)
  'dataLists.schema.tabs.basic': 'Basic',
  'dataLists.schema.tabs.fields': 'Fields',
  'dataLists.schema.tabs.webhook': 'Webhook',
  'dataLists.schema.tabs.access': 'Access',
  'dataLists.schema.shapeSection': 'List Type',
  'dataLists.schema.shapeLocked': 'List type cannot be changed after creation.',
  'dataLists.schema.columnsSourceLabel': 'Columns',
  'dataLists.schema.columnsSource.custom': 'Custom columns',
  'dataLists.schema.columnsSource.system': 'System module',
  'dataLists.schema.dataSourceLabel': 'Data',
  'dataLists.schema.dataSource.manual': 'Manual entry',
  'dataLists.schema.dataSource.webhook': 'Live webhook',
  'dataLists.schema.systemModuleLabel': 'Module',
  'dataLists.schema.systemModule.contacts': 'Contacts',
  'dataLists.schema.systemModule.products': 'Products',
  'dataLists.schema.systemModule.catalog': 'Catalog',
  'dataLists.schema.systemModule.calendar': 'Calendar',
  'dataLists.schema.systemModule.orders': 'Orders',
  'dataLists.schema.systemModuleColumnsHint': 'This list will show {{count}} fixed columns from the module — download a template to bulk-fill them.',
  'dataLists.schema.resyncColumns': 'Refresh columns from module',
  'dataLists.schema.resyncColumnsSuccess': 'Columns refreshed from the module',
  'dataLists.schema.resyncColumnsFailed': 'Failed to refresh columns',
  'dataLists.schema.customColumnsSection': 'Custom Fields',
  'dataLists.schema.customColumnsHint': 'Extra fields alongside the module\'s own columns above — only these can be added, edited, or removed here.',
  'httpRequestBuilder.urlLabel': 'URL',
  'httpRequestBuilder.headersLabel': 'Headers',
  'httpRequestBuilder.noHeaders': 'No custom headers set.',
  'httpRequestBuilder.headerKeyPlaceholder': 'Header name (e.g. User-Agent)',
  'httpRequestBuilder.headerValuePlaceholder': 'Value',
  'httpRequestBuilder.addHeader': 'Add header',
  'httpRequestBuilder.bodyTemplateLabel': 'Request Body (JSON, optional)',
  'httpRequestBuilder.bodyTemplatePlaceholder': '{ "key": "value" }',
  'httpRequestBuilder.responseRootPathLabel': 'Response array path (optional)',
  'dataLists.schema.webhook.title': 'Webhook Configuration',
  'dataLists.schema.webhook.urlLabel': 'Webhook URL',
  'dataLists.schema.webhook.responseRootPathLabel': 'Response array path (optional)',
  'dataLists.schema.webhook.test': 'Test Webhook',
  'dataLists.schema.webhook.testing': 'Testing...',
  'dataLists.schema.webhook.testSuccess': 'Webhook responded successfully',
  'dataLists.schema.webhook.testFailed': 'Failed to reach webhook',
  'dataLists.schema.webhook.mappingSection': 'Field Mapping',
  'dataLists.schema.webhook.mappingHint': 'Map each column to a field path in the webhook response.',
  'dataLists.schema.webhook.sourcePathPlaceholder': 'e.g. customer.email',
  'dataLists.schema.webhook.externalId': 'Use as external ID',
  'dataLists.schema.webhook.productSkuField': 'Use as product SKU',
  'dataLists.schema.webhook.contactIdField': 'Use as contact ID',
  'dataLists.schema.webhook.contactIdentifierField': 'Use as contact identifier',
  'dataLists.schema.webhook.sampleHint': 'Received {{count}} sample rows from the last test.',
  'dataLists.schema.webhook.mapperNeedsSample': 'Test the webhook to auto-detect field paths, or map columns manually below.',
  'dataLists.schema.webhook.mode.field': 'Field',
  'dataLists.schema.webhook.mode.fixed': 'Fixed',
  'dataLists.schema.webhook.mode.expression': 'Expression',
  'dataLists.schema.webhook.fixedValuePlaceholder': 'Same value for every row',
  'dataLists.schema.webhook.expressionPlaceholder': 'e.g. {{firstName}} {{lastName}}',
  'dataLists.schema.webhook.expressionHint': 'Combine fields with {{fieldPath}} — plain text outside the braces is kept as-is.',
  'dataLists.schema.webhook.notConnected': 'Not connected — drag a field here or tap to type a path',
  'dataLists.schema.webhook.connectedTo': 'Connected to {{path}}',
  'dataLists.schema.webhook.sourceFieldsTitle': 'Webhook Fields',
  'dataLists.schema.webhook.targetColumnsTitle': 'Datalist Columns',
  'dataLists.schema.webhook.dragHint': 'Drag a line from a field on the left to a column on the right.',
  'dataLists.schema.webhook.selectFieldPlaceholder': 'Search or select a field…',
  'dataLists.schema.webhook.typeManually': 'Type a path manually instead',
  'dataLists.schema.webhook.noFieldsDetected': 'No fields detected yet — test the webhook first, or type a path manually.',
  'dataLists.schema.webhook.itemsMappingSection': 'Items Mapping (Multi-Item Orders / Quotations)',
  'dataLists.schema.webhook.itemsMappingHint': 'Configure this if each webhook row is one order or quotation with MULTIPLE line items nested inside it. Leave the array path blank to keep using the single-item SKU field above instead. There is no default/fallback product — a row that doesn\'t resolve to a real product SKU will fail.',
  'dataLists.schema.webhook.itemsMappingArrayBadge': 'One array — sub-fields below read from each item in it',
  'dataLists.schema.webhook.itemsMappingSubFieldsHint': 'Each field below is a path WITHIN one element of the array above, not a separate mapping.',
  'dataLists.schema.webhook.itemsArrayPathLabel': 'Items Array Path',
  'dataLists.schema.webhook.itemsQuantityPathLabel': 'Quantity Field (within each item)',
  'dataLists.schema.webhook.itemsSkuPathLabel': 'SKU Field (within each item)',
  'dataLists.schema.webhook.itemsNamePathLabel': 'Name Field (within each item, fallback)',
  'dataLists.schema.webhook.itemsPricePathLabel': 'Price Field (within each item, fallback)',
  'dataLists.schema.webhook.relationsSection': 'Relations',
  'dataLists.schema.webhook.relationsHint': 'Which field on Products/Contacts to search against when resolving this list\'s items and customer. Only fields marked "unique" are selectable — add a unique custom field on that module\'s own data list if the external system uses an identifier DISLIX doesn\'t have a fixed field for (e.g. "External Product ID").',
  'dataLists.schema.webhook.relationProductsLabel': 'Search Products by',
  'dataLists.schema.webhook.relationContactsLabel': 'Search Contacts by',
  'dataLists.schema.webhook.relationDefaultPlaceholder': 'Default ({{field}})',
  'dataLists.schema.webhook.syncSection': 'Periodic Sync',
  'dataLists.schema.webhook.triggerOutboundWebhooksLabel': 'Notify Developer Access webhooks on sync',
  'dataLists.schema.webhook.triggerOutboundWebhooksHint': 'Off by default. When a sync creates or updates a record here, it can also fire your business\'s own outbound webhooks (Settings > Developer Access) for that same event — e.g. product.updated. Leave this off if the same external system is both the source of this sync AND the receiver of that webhook, since that can create a feedback loop or just spam it once per synced row. Turn it on only if a DIFFERENT system needs to hear about these sync-driven changes.',
  'schedulePicker.enable': 'Run on a schedule',
  'schedulePicker.type.minutes': 'Minutes',
  'schedulePicker.type.hours': 'Hours',
  'schedulePicker.type.daily': 'Daily',
  'schedulePicker.type.weekly': 'Weekly',
  'schedulePicker.type.monthly': 'Monthly',
  'schedulePicker.type.quarterly': 'Quarterly',
  'schedulePicker.type.yearly': 'Yearly',
  'schedulePicker.everyMinutesLabel': 'Every N minutes',
  'schedulePicker.everyHoursLabel': 'Every N hours',
  'schedulePicker.hourLabel': 'Hour (0-23)',
  'schedulePicker.minuteLabel': 'Minute (0-59)',
  'schedulePicker.timeLabel': 'Time',
  'schedulePicker.timezoneLabel': 'Timezone',
  'schedulePicker.dayOfMonthLabel': 'Day of month (1-28)',
  'schedulePicker.quarterlyHint': 'Runs in {{months}}.',
  'schedulePicker.summary.minutes': 'Runs every {{n}} minute(s)',
  'schedulePicker.summary.hours': 'Runs every {{n}} hour(s)',
  'schedulePicker.summary.daily': 'Runs daily at {{time}} {{tz}}',
  'schedulePicker.summary.weekly': 'Runs {{days}} at {{time}} {{tz}}',
  'schedulePicker.summary.monthly': 'Runs on day {{day}} of every month at {{time}} {{tz}}',
  'schedulePicker.summary.quarterly': 'Runs on day {{day}} of {{months}} at {{time}} {{tz}}',
  'schedulePicker.summary.yearly': 'Runs on {{month}} {{day}} at {{time}} {{tz}}',
  'dataLists.schema.webhook.syncIntervalHint': 'Leave blank to only sync when someone views this list. Set an interval to sync automatically in the background.',
  'dataLists.schema.webhook.syncIntervalLabel': 'Sync every N minutes',
  'dataLists.schema.webhook.maxRetriesLabel': 'Max retries',
  'dataLists.schema.webhook.retryDelayLabel': 'Retry delay (seconds)',
  'dataLists.schema.webhook.syncNow': 'Sync Now',
  'dataLists.schema.webhook.syncingNow': 'Syncing...',
  'dataLists.schema.webhook.syncNowSuccess': 'Sync completed successfully',
  'dataLists.schema.webhook.syncNowFailed': 'Sync failed',
  'dataLists.schema.webhook.loadingSyncHistory': 'Loading last sync status...',
  'dataLists.schema.webhook.lastSyncSuccess': 'Last synced successfully at {{time}}',
  'dataLists.schema.webhook.lastSyncFailed': 'Last sync failed: {{error}}',
  'dataLists.schema.webhook.syncOutcomeSummary': '{{synced}} synced, {{updated}} updated, {{reactivated}} reactivated, {{skipped}} skipped, {{removed}} removed, {{failed}} failed',
  'dataLists.schema.webhook.syncOutcomeFailureRow': 'Row {{row}}: {{error}}',
  'dataLists.schema.webhook.syncOutcomeFailureGeneral': '{{error}}',
  'dataLists.schema.webhook.viewRuns': 'View sync runs and history →',
  'dataLists.runs.nextRun': 'Next scheduled run',
  'dataLists.runs.manualOnly': 'No schedule — runs only when you sync manually',
  'dataLists.runs.inTime': 'in {{time}}',
  'dataLists.runs.dueNow': 'due now',
  'dataLists.runs.runningSince': 'Sync running since {{time}} — you can leave this screen',
  'dataLists.runs.syncRunning': 'Sync in progress…',
  'dataLists.runs.syncNowHint': 'Runs in the background exactly like a scheduled run, so large sources no longer time out.',
  'dataLists.runs.started': 'Sync started in the background',
  'dataLists.runs.alreadyRunning': 'A sync is already running for this list',
  'dataLists.runs.history': 'Run history',
  'dataLists.runs.refresh': 'Refresh',
  'dataLists.runs.empty': 'No runs yet.',
  'dataLists.runs.status.success': 'Succeeded',
  'dataLists.runs.status.partial': 'Completed with failures',
  'dataLists.runs.status.failed': 'Failed',
  'dataLists.runs.status.running': 'Running',
  'dataLists.runs.status.pending': 'Pending',
  'dataLists.runs.trigger.manual': 'Manual',
  'dataLists.runs.trigger.scheduled': 'Scheduled',
  'dataLists.runs.attempt': 'attempt {{n}}',
  'dataLists.runs.summary': '{{created}} created, {{updated}} updated, {{removed}} removed, {{failed}} failed',
  'dataLists.runs.startedAt': 'Started',
  'dataLists.runs.finishedAt': 'Finished',
  'dataLists.runs.counts.fetched': 'Fetched',
  'dataLists.runs.counts.created': 'Created',
  'dataLists.runs.counts.updated': 'Updated',
  'dataLists.runs.counts.reactivated': 'Reactivated',
  'dataLists.runs.counts.skipped': 'Skipped',
  'dataLists.runs.counts.removed': 'Removed',
  'dataLists.runs.counts.failed': 'Failed',
  'dataLists.runs.error': 'Error',
  'dataLists.runs.showStack': 'Show technical details',
  'dataLists.runs.hideStack': 'Hide technical details',
  'dataLists.runs.failures': 'Failed rows ({{count}})',
  'dataLists.runs.rowN': 'Row {{n}}',
  'dataLists.runs.removal': 'Removal',
  'dataLists.runs.moreNotListed': '{{count}} more not listed',
  'dataLists.runs.records': 'Records',
  'dataLists.runs.priceBefore': 'Before (price / sale price)',
  'dataLists.runs.priceMapped': 'Mapped (price / sale price)',
  'dataLists.runs.priceSaved': 'Saved (price / sale price)',
  'dataLists.runs.priceFinal': 'End of run (price / sale price)',
  'dataLists.runs.priceMismatch': 'Stored prices do not match this source row',
  'dataLists.runs.filterAll': 'All',
  'dataLists.runs.showMore': 'Show more ({{count}})',
  'dataLists.runs.recordsTruncated': 'Only the first {{count}} records are listed.',
  'dataLists.runs.log': 'Run log',
  'dataLists.runs.noDetails': 'No record details were saved for this run.',
  'storefront.shop': 'Shop',
  'storefront.product': 'Product',
  'storefront.loading': 'Loading…',
  'storefront.loadFailed': 'We couldn\'t load this page. Check your connection and try again.',
  'storefront.notFound': 'This product is no longer available.',
  'storefront.retry': 'Try again',
  'storefront.itemsCount': '{{count}} items',
  'storefront.oneItem': '1 item',
  'storefront.search': 'Search products',
  'storefront.noResults': 'No products match "{{query}}"',
  'storefront.empty': 'No products yet',
  'storefront.emptyBody': 'Check back soon for new items.',
  'storefront.addToCart': 'Add to cart',
  'storefront.chooseOptions': 'Choose options',
  'storefront.outOfStock': 'Out of stock',
  'storefront.inStock': 'In stock',
  'storefront.preorder': 'Pre-order',
  'storefront.backorder': 'Backorder',
  'storefront.unitsAvailable': '{{count}} available',
  'storefront.price': 'Price',
  'storefront.added': 'Added to cart',
  'storefront.viewCart': 'View cart',
  'storefront.poweredBy': 'Powered by DISLIX',
  'storefront.close': 'Close',
  'storefront.gridView': 'Grid view',
  'storefront.slideView': 'Slide view',
  'storefront.description': 'Description',
  'storefront.details': 'Product details',
  'storefront.sku': 'SKU',
  'storefront.barcode': 'Barcode',
  'storefront.weight': 'Weight',
  'storefront.addons': 'Add-ons',
  'storefront.required': 'Required',
  'storefront.add': 'Add',
  'storefront.variant': 'Option',
  'storefront.selectVariant': 'Choose an option ({{count}})',
  'storefront.addAgain': 'Add again ({{count}} in cart)',
  'storefront.requiredAddonsMissing': 'Please choose: {{names}}',
  'storefront.noImage': 'No image',
  'storefront.imageUnavailable': 'Image unavailable',
  'storefront.cart.otherNumber': 'You have a cart from your other number: {{count}} items · {{total}}',
  'storefront.cart.continueHere': 'Continue it here',
  'storefront.cart.startNew': 'Start a new cart',
  'storefront.cart.total': 'Total',
  'storefront.cart.deliveryNote': 'Delivery is chosen at checkout.',
  'storefront.cart.title': 'Your cart',
  'storefront.cart.empty': 'Your cart is empty',
  'storefront.cart.emptyBody': 'Browse the catalog and add items to get started.',
  'storefront.cart.startShopping': 'Start shopping',
  'storefront.cart.continueShopping': 'Continue shopping',
  'storefront.cart.subtotal': 'Subtotal',
  'storefront.cart.each': '{{price}} each',
  'storefront.cart.remove': 'Remove',
  'storefront.cart.checkout': 'Checkout',
  'storefront.cart.feesNote': 'Delivery and taxes are calculated at checkout.',
  'storefront.checkout.title': 'Checkout',
  'storefront.checkout.stepDetails': 'Details',
  'storefront.checkout.stepDelivery': 'Delivery',
  'storefront.checkout.stepReview': 'Review',
  'storefront.checkout.contact': 'Your details',
  'storefront.checkout.name': 'Full name',
  'storefront.checkout.namePlaceholder': 'Your full name',
  'storefront.checkout.phone': 'Phone number',
  'storefront.checkout.phonePlaceholder': 'e.g. +20 100 000 0000',
  'storefront.checkout.email': 'Email (optional)',
  'storefront.checkout.location': 'Delivery location',
  'storefront.checkout.locationHint': 'Pin your location so we can calculate delivery fees and find you easily.',
  'storefront.checkout.setLocation': 'Set delivery location',
  'storefront.checkout.changeLocation': 'Change',
  'storefront.checkout.detectingLocation': 'Detecting your location…',
  'storefront.checkout.address': 'Address details (optional)',
  'storefront.checkout.addressPlaceholder': 'Building, floor, apartment, landmark',
  'storefront.checkout.notes': 'Order notes (optional)',
  'storefront.checkout.notesPlaceholder': 'Special instructions, delivery preferences…',
  'storefront.checkout.shipping': 'Delivery method',
  'storefront.checkout.findingShipping': 'Finding delivery options…',
  'storefront.checkout.free': 'Free',
  'storefront.checkout.days': '{{min}}–{{max}} days',
  'storefront.checkout.express': 'Express delivery',
  'storefront.checkout.optionalAddons': 'Extras',
  'storefront.checkout.promo': 'Promo code',
  'storefront.checkout.promoPlaceholder': 'Enter promo code',
  'storefront.checkout.referral': 'Referral code',
  'storefront.checkout.referralPlaceholder': 'Enter referral code',
  'storefront.checkout.apply': 'Apply',
  'storefront.checkout.youSave': 'You save {{amount}}',
  'storefront.checkout.invalidCode': 'This code is not valid',
  'storefront.checkout.codeCheckFailed': 'Couldn\'t check the code. Try again.',
  'storefront.checkout.orderItems': 'Your order',
  'storefront.checkout.summary': 'Payment summary',
  'storefront.checkout.subtotal': 'Subtotal',
  'storefront.checkout.shippingLine': 'Delivery — {{name}}',
  'storefront.checkout.coupon': 'Promo "{{code}}"',
  'storefront.checkout.referralLine': 'Referral "{{code}}"',
  'storefront.checkout.optionalLine': '{{name}} (optional)',
  'storefront.checkout.total': 'Total',
  'storefront.checkout.payOnDelivery': 'Payment is collected on delivery',
  'storefront.checkout.deliverTo': 'Delivering to',
  'storefront.checkout.edit': 'Edit',
  'storefront.checkout.continue': 'Continue',
  'storefront.checkout.placeOrder': 'Place order · {{total}}',
  'storefront.checkout.placing': 'Placing your order…',
  'storefront.checkout.nameRequired': 'Please enter your name',
  'storefront.checkout.phoneRequired': 'Please enter a valid phone number',
  'storefront.checkout.emailInvalid': 'Please enter a valid email or leave it empty',
  'storefront.checkout.shippingRequired': 'Please choose a delivery method',
  'storefront.checkout.orderFailed': 'We couldn\'t place your order. Please try again.',
  'storefront.checkout.cartEmpty': 'Your cart is empty',
  'storefront.checkout.missingStore': 'This link is missing the store details. Please open it again from the chat.',
  'storefront.success.title': 'Order placed!',
  'storefront.success.orderNumber': 'Order #{{number}}',
  'storefront.success.body': 'Thank you! The store has received your order and will contact you to confirm it.',
  'storefront.success.sentWhatsApp': 'Your invoice was sent to your WhatsApp ({{phone}}). Please confirm the order there.',
  'storefront.success.sentChat': 'We sent the order confirmation to your chat with the store.',
  'storefront.success.track': 'Track my order',
  'storefront.success.invoice': 'View invoice',
  'storefront.success.continue': 'Continue shopping',
  'storefront.success.total': 'Total',
  'vendors.minimumOrder.section': 'Minimum order',
  'vendors.minimumOrder.hint': 'Orders must include at least this amount of this vendor\'s products. Leave empty for no minimum.',
  'vendors.minimumOrder.amount': 'Minimum order amount',
  'vendors.minimumOrder.currency': 'Currency',
  'vendors.minimumOrder.none': 'No minimum',
  'vendors.minimumOrder.invalidTitle': 'Invalid amount',
  'vendors.minimumOrder.invalidAmount': 'Minimum order amount must be a number of 0 or more.',
  'products.minimumOrderQuantity.label': 'Minimum order quantity',
  'products.minimumOrderQuantity.placeholder': 'No minimum',
  'products.minimumOrderQuantity.hint': 'Orders must include at least this many (all variants together).',
  'orders.form.currency': 'Currency',
  'mapPicker.searchPlaceholder': 'Search a place, or paste a Google / Apple Maps link',
  'mapPicker.resolvingLink': 'Opening map link…',
  'mapPicker.linkFailed': 'Couldn\'t find a location in this link. Check the link or search by place name.',
  'visitWorkspace.title': 'Visit',
  'visitWorkspace.startedAt': 'Started {{time}}',
  'visitWorkspace.directions': 'Directions',
  'visitWorkspace.locating': 'Getting your location…',
  'visitWorkspace.distance': 'You are {{distance}} away',
  'visitWorkspace.inRange': 'within check-in range',
  'visitWorkspace.outOfRange': 'check-in needs {{radius}} m or less',
  'visitWorkspace.checkLocation': 'Check my distance',
  'visitWorkspace.rulesTitle': 'Visit rules',
  'visitWorkspace.rules.radius': 'Check in within {{radius}} m of the location',
  'visitWorkspace.rules.radiusOverride': 'Check in within {{radius}} m (or give a reason)',
  'visitWorkspace.rules.startPhotos': 'At least {{count}} photo(s) to start',
  'visitWorkspace.rules.endPhotos': 'At least {{count}} photo(s) to end',
  'visitWorkspace.rules.cameraOnly': 'Photos must be taken with the camera',
  'visitWorkspace.rules.duration': 'Expected duration: {{minutes}} min',
  'visitWorkspace.rules.dueBy': 'Due by {{time}}',
  'visitWorkspace.notYours': 'This visit is assigned to someone else.',
  'visitWorkspace.geofenceBlocked': 'You\'re {{distance}} from the location — you must be within {{radius}} m to start.',
  'visitWorkspace.start': 'Start visit',
  'visitWorkspace.needLocation': 'Waiting for your location to check in.',
  'visitWorkspace.needStartPhotos': 'Add the required start photo(s) first.',
  'visitWorkspace.needReason': 'You\'re outside the range — add a reason to start anyway.',
  'visitWorkspace.actionsTitle': 'While you are here',
  'visitWorkspace.addQuotation': 'Quotation',
  'visitWorkspace.addOrder': 'Order',
  'visitWorkspace.addVendor': 'Add as vendor',
  'visitWorkspace.notePlaceholder': 'Add a note about this visit…',
  'visitWorkspace.noteTag': '[Visit]',
  'visitWorkspace.noteAdded': 'Note added to the contact',
  'visitWorkspace.end': 'End visit',
  'visitWorkspace.confirmEnd': 'End visit',
  'visitWorkspace.outcomeNoteOptional': 'Note (optional)',
  'visitWorkspace.assigneeChosen': 'Assignee selected',
  'visitWorkspace.needEndPhotos': 'Add the required end photo(s) to finish.',
  'visitWorkspace.ended': 'Visit ended — {{outcome}}',
  'visitWorkspace.viewVendor': 'View vendor',
  'visitWorkspace.activitiesTitle': 'Done during this visit',
  'visitWorkspace.activity.order': 'Order created',
  'visitWorkspace.activity.quotation': 'Quotation created',
  'visitWorkspace.activity.vendor': 'Added as vendor',
  'visitWorkspace.activity.reminder': 'Reminder set',
  'visitWorkspace.activity.list': 'Added to a list',
  'visitWorkspace.activity.assignment': 'Assignment changed',
  'visitWorkspace.activity.note': 'Note',
  'contactEdit.vendor.linked': 'Vendor: {{name}}',
  'contactEdit.vendor.view': 'View',
  'contactEdit.vendor.add': 'Add as vendor',
  'visitWorkspace.turnByTurn': 'Turn-by-turn',
  'orderMinimums.title': 'Minimum order not reached',
  'orderMinimums.productLine': '{{name}}: minimum quantity is {{min}} (you have {{qty}})',
  'orderMinimums.vendorLine': '{{name}}: minimum order is {{min}} — add {{remaining}} more',
  'storefront.minQty': 'Min. {{count}}',
  'storefront.minQtyLong': 'Minimum order quantity: {{count}}',
  'storefront.vendorMinimum': 'Minimum order for {{name}} items: {{amount}}',
  'dataLists.schema.tabs.runs': 'Runs',

  // Column type labels
  'dataLists.type.text': 'Text',
  'dataLists.type.number': 'Number',
  'dataLists.type.boolean': 'Yes / No',
  'dataLists.type.date': 'Date',
  'dataLists.type.phone': 'Phone',
  'dataLists.type.voice': 'Voice',
  'dataLists.type.image': 'Image',
  'dataLists.type.video': 'Video',
  'dataLists.type.object': 'Object (JSON)',
  'dataLists.type.relation': 'Relation',
  'dataLists.type.repeater': 'Repeater',

  // Records screen
  'dataLists.records.title': 'Records',
  'dataLists.records.subtitle.count': '{{count}} records',
  'dataLists.records.subtitle.countOne': '1 record',
  'dataLists.records.searchPlaceholder': 'Search records...',
  'dataLists.records.add': 'Add Record',
  'dataLists.records.bulkAdd': 'Bulk Add',
  'dataLists.records.empty.title': 'No records yet',
  'dataLists.records.empty.message': 'Add your first record to this list.',
  'dataLists.records.empty.webhookMessage': 'No data returned by the webhook yet.',
  'dataLists.records.liveWebhookBadge': 'Live from webhook — read only',
  'dataLists.records.template.download': 'Download Template',
  'dataLists.records.template.upload': 'Upload Filled Template',
  'dataLists.records.template.downloadFailed': 'Failed to download template',
  'dataLists.records.template.importFailed': 'Failed to import template',
  'dataLists.records.template.importSuccess': 'Imported {{count}} of {{total}} rows',
  'dataLists.records.loading': 'Loading records...',
  'dataLists.records.loadFailed': 'Failed to load records',
  'dataLists.records.delete.title': 'Delete Record',
  'dataLists.records.delete.message': 'Are you sure you want to delete this record? This cannot be undone.',
  'dataLists.records.delete.success': 'Record deleted successfully',
  'dataLists.records.delete.failed': 'Failed to delete record',
  'dataLists.records.emptyValue': '—',

  // Record form
  'dataLists.recordForm.createTitle': 'New Record',
  'dataLists.recordForm.editTitle': 'Edit Record',
  'dataLists.recordForm.save': 'Save',
  'dataLists.recordForm.create': 'Create',
  'dataLists.recordForm.saving': 'Saving...',
  'dataLists.recordForm.assignedSection': 'Assigned to',
  'dataLists.recordForm.assignUser': 'Assign a user',
  'dataLists.recordForm.createSuccess': 'Record created successfully',
  'dataLists.recordForm.updateSuccess': 'Record updated successfully',
  'dataLists.recordForm.saveFailed': 'Failed to save record',
  'dataLists.recordForm.loadFailed': 'Failed to load record',
  'dataLists.recordForm.uploadFailed': 'Failed to upload one or more files',
  'dataLists.recordForm.validation.title': 'Please fix the errors',
  'dataLists.recordForm.validation.required': 'This field is required',
  'dataLists.recordForm.validation.invalidJson': 'Invalid JSON',
  'dataLists.recordForm.validation.notNumber': 'Must be a number',
  'dataLists.recordForm.validation.min': 'Must be at least {{min}}',
  'dataLists.recordForm.validation.max': 'Must be at most {{max}}',

  // Field renderer
  'dataLists.field.textPlaceholder': 'Enter text',
  'dataLists.field.numberPlaceholder': 'Enter a number',
  'dataLists.field.jsonPlaceholder': '{ "key": "value" }',
  'dataLists.field.selectOption': 'Select an option',
  'dataLists.field.pickFile': 'Pick a file',
  'dataLists.field.pickImage': 'Pick an image',
  'dataLists.field.pickVideo': 'Pick a video',
  'dataLists.field.pickVoice': 'Pick an audio file',
  'dataLists.field.recordVoice': 'Record a voice note',
  'dataLists.field.uploading': 'Uploading...',
  'dataLists.field.fileSelected': 'File selected',
  'dataLists.field.replaceFile': 'Replace',
  'dataLists.field.removeFile': 'Remove',
  'dataLists.field.selectRecord': 'Select a record',
  'dataLists.field.addAnotherRecord': 'Add another record',
  'dataLists.field.permissionTitle': 'Permission Required',
  'dataLists.field.permissionMessage': 'Please grant permission to access your media library.',
  'dataLists.field.repeaterRow': 'Row {{number}}',
  'dataLists.field.addRow': 'Add Row',
  'dataLists.field.quantityPlaceholder': 'Qty',
  'dataLists.field.addProducts': 'Add Products',
  'dataLists.field.selectProductsTitle': 'Select Products',

  // Relation record picker
  'dataLists.recordPicker.title': 'Select Record',
  'dataLists.recordPicker.searchPlaceholder': 'Search records...',
  'dataLists.recordPicker.empty': 'No records found',
  'dataLists.recordPicker.loading': 'Loading records...',
  'dataLists.recordPicker.unnamed': 'Untitled record',
  'dataLists.recordPicker.done': 'Done ({{count}} selected)',

  // Flow node — write_data_list
  'dataLists.flowNode.label': 'Write Data List',
  'dataLists.flowNode.description': 'Create, update, find, or delete a data list record',
  'dataLists.flowNode.listLabel': 'Data List *',
  'dataLists.flowNode.selectList': 'Select a data list',
  'dataLists.flowNode.listSelected': 'List selected',
  'dataLists.flowNode.pickerTitle': 'Select Data List',
  'dataLists.flowNode.pickerEmpty': 'No data lists found',
  'dataLists.flowNode.operationLabel': 'Operation',
  'dataLists.flowNode.operation.create': 'Create',
  'dataLists.flowNode.operation.update': 'Update',
  'dataLists.flowNode.operation.find': 'Find',
  'dataLists.flowNode.operation.delete': 'Delete',
  'dataLists.flowNode.valueMappings': 'Values',
  'dataLists.flowNode.valueMappingsHint': 'Set each column to a value or template, e.g. {{contact.name}}.',
  'dataLists.flowNode.matchCriteria': 'Match Criteria',
  'dataLists.flowNode.matchCriteriaHint': 'Find records where each column matches. Most-recent match wins.',
  'dataLists.flowNode.selectColumn': 'Select a column',
  'dataLists.flowNode.valuePlaceholder': 'Value or {{variable}}',
  'dataLists.flowNode.addRow': 'Add row',
  'dataLists.flowNode.operator.eq': 'Equals',
  'dataLists.flowNode.operator.contains': 'Contains',
  'dataLists.flowNode.operator.gt': 'Greater than',
  'dataLists.flowNode.operator.lt': 'Less than',
  'dataLists.flowNode.operator.gte': 'Greater or equal',
  'dataLists.flowNode.operator.lte': 'Less or equal',
  'dataLists.flowNode.saveResultAs': 'Save Result As (optional)',
  'dataLists.flowNode.saveResultAsPlaceholder': 'e.g. foundRecord',
  'dataLists.flowNode.saveResultAsHint': 'The matched record is saved under this name for later nodes.',
  'dataLists.flowNode.then': 'Then',
  'dataLists.flowNode.validation.listRequired': 'Select a data list',
  'dataLists.flowNode.validation.operationRequired': 'Select an operation',
  'dataLists.flowNode.validation.mappingRequired': 'Add at least one value mapping',
  'dataLists.flowNode.validation.matchRequired': 'Add at least one match criterion',

  // Flow builder — add-node picker
  'flows.nodePicker.title': 'Add a Node',
  'flows.nodePicker.searchPlaceholder': 'Search nodes...',
  'flows.nodePicker.noResults': 'No nodes match your search',
  'flows.nodePicker.frequentlyUsed': 'Frequently Used',
  'flows.nodePicker.whatsappOnly': 'WhatsApp only',
  'flows.nodePicker.facebookOnly': 'Facebook only',
  'flows.nodePicker.category.messaging': 'Messaging',
  'flows.nodePicker.category.logic': 'Logic & Routing',
  'flows.nodePicker.category.data': 'Data',
  'flows.nodePicker.category.people': 'People',
  'flows.nodePicker.category.commerce': 'Commerce',
  'flows.nodePicker.category.integrations': 'Integrations',
  'flows.nodePicker.category.control': 'Control',

  // Flow node — check_language
  'flows.checkLanguage.label': 'Check Language',
  'flows.checkLanguage.description': 'Detect the message language and route accordingly',
  'flows.checkLanguage.inputLabel': 'Text to detect *',
  'flows.checkLanguage.inputPlaceholder': '{{Start.input.text}}',
  'flows.checkLanguage.inputHint': 'A variable or template — usually the message that triggered this flow',
  'flows.checkLanguage.saveResultAs': 'Save detected language as (optional)',
  'flows.checkLanguage.routesLabel': 'Routes',
  'flows.checkLanguage.addRoute': 'Add Route',
  'flows.checkLanguage.routeLanguages': 'Languages',
  'flows.checkLanguage.selectLanguages': 'Select languages',
  'flows.checkLanguage.routeNextNode': 'Go to',
  'flows.checkLanguage.defaultRoute': 'All other languages go to',
  'flows.checkLanguage.searchLanguage': 'Search languages...',
  'flows.checkLanguage.validation.inputRequired': 'Add a message/variable to detect the language of',
  'flows.checkLanguage.validation.routeLanguagesRequired': 'Every route needs at least one language selected',

  // ─── Business Permissions (Users & Departments Rebuild) ───────────────────
  'permissions.screenTitle': 'Permissions',
  'permissions.generalSection.title': 'General Business Permissions',
  'permissions.systemSection.title': 'System Permissions',
  'permissions.otherSection.title': 'Other',
  'permissions.search.placeholder': 'Search permissions...',
  'permissions.search.noResults': 'No permissions match your search',
  'permissions.enableAll': 'Enable all',
  'permissions.disableAll': 'Disable all',
  'permissions.resetToDepartmentDefault': 'Reset to department default',
  'permissions.summaryChip.label': '{{count}} granted',
  'permissions.summaryChip.empty': 'No permissions granted yet',
  'permissions.summaryChip.manageLink': 'Manage permissions',
  'permissions.targetPicker.usersTab': 'Users',
  'permissions.targetPicker.departmentsTab': 'Departments',
  'permissions.targetPicker.editingFor': 'Editing permissions for: {{name}}',
  'permissions.targetPicker.change': 'Change',
  'permissions.targetPicker.selectTarget': 'Select a user or department to manage their permissions',
  'permissions.unsavedChangesWarning.title': 'Unsaved Changes',
  'permissions.unsavedChangesWarning.message': 'You have unsaved permission changes. Are you sure you want to leave?',
  'permissions.save': 'Save Changes',
  'permissions.cancel': 'Cancel',
  'permissions.saveSuccess': 'Permissions updated successfully',
  'permissions.saveFailed': 'Failed to update permissions',
  'permissions.levels.none': 'None',
  'permissions.levels.view': 'View',
  'permissions.levels.edit': 'Edit',
  'permissions.levels.admin': 'Admin',
  'permissions.inherited': 'Inherited',
  'permissions.categoryLabel.general': 'General',
  'permissions.categoryLabel.wabu': 'WhatsApp',
  'permissions.categoryLabel.fbm': 'Messenger',
  'permissions.categoryLabel.sms': 'SMS',
  'permissions.categoryLabel.email': 'Email',
  'permissions.categoryLabel.telegram': 'Telegram',
  'permissions.categoryLabel.instagram': 'Instagram',
  'permissions.categoryLabel.contacts': 'Contacts',
  'permissions.categoryLabel.reports': 'Reports',
  'permissions.categoryLabel.phone': 'Calls',
  'permissions.categoryLabel.notifications': 'Notifications',
  'permissions.categoryLabel.storage': 'Storage',
  'userSetup.bulk.selectAll': 'Select all',
  'userSetup.bulk.selectedCount': '{{count}} selected',
  'userSetup.bulk.changeRole': 'Change Role',
  'userSetup.bulk.assignDepartment': 'Assign Department',
  'userSetup.bulk.setPermissions': 'Set Permissions',
  'userSetup.bulk.remove': 'Remove',
  'userSetup.bulk.confirmRemoveTitle': 'Remove Users',
  'userSetup.bulk.confirmRemoveMessage': 'Are you sure you want to remove {{count}} user(s) from this business?',
  'userSetup.bulk.exitSelection': 'Cancel selection',
  'userSetup.bulk.enterSelection': 'Select',
  'userSetup.bulk.roleUpdateSuccess': '{{count}} user(s) updated',
  'userSetup.bulk.removeSuccess': '{{count}} user(s) removed',
  'userSetup.bulk.departmentAssignSuccess': '{{count}} user(s) assigned',
  'departments.memberCount': '{{count}} members',
  'departments.bulk.manageMembers': 'Manage Members',
  'departments.bulk.setPermissions': 'Set Permissions',
  'departments.bulk.selectAll': 'Select all',
  'departments.bulk.selectedCount': '{{count}} selected',
  'departments.bulk.exitSelection': 'Cancel selection',
  'departments.bulk.enterSelection': 'Select',
  'departments.bulk.membersAddSuccess': '{{count}} member(s) added',
  'departments.bulk.permissionsSetSuccess': 'Permissions updated for {{count}} department(s)',
  'departments.profilePane.title': 'Departments',
  'departments.profilePane.selectPrompt': 'Select a department to edit its profile.',
  'departments.profilePane.nameLabel': 'Name',
  'departments.profilePane.namePlaceholder': 'Department name',
  'departments.profilePane.descriptionLabel': 'Description',
  'departments.profilePane.descriptionPlaceholder': 'Department description',
  'departments.profilePane.active': 'Active',
  'departments.profilePane.inactive': 'Inactive',
  'departments.profilePane.saveChanges': 'Save changes',
  'departments.profilePane.deleteDepartment': 'Delete Department',
  'permissions.general.editBusinessProfile.label': "Edit Business Profile",
  'permissions.general.editBusinessProfile.description': "View and edit the business name, logo, address, and contact info",
  'permissions.general.manageSubscriptionBilling.label': "Manage Subscription & Billing",
  'permissions.general.manageSubscriptionBilling.description': "View or change the plan, payment methods, and invoices",
  'permissions.general.manageUsers.label': "Manage Users",
  'permissions.general.manageUsers.description': "View the team, invite users, edit roles, or remove users",
  'permissions.general.manageDepartments.label': "Manage Departments",
  'permissions.general.manageDepartments.description': "View, create, edit, or delete departments and manage membership",
  'permissions.general.managePermissions.label': "Manage Permissions",
  'permissions.general.managePermissions.description': "Grant or revoke permissions for other users and departments",
  'permissions.general.manageChannelsConnections.label': "Manage Channel Connections",
  'permissions.general.manageChannelsConnections.description': "View, reconfigure, connect, or disconnect any messaging channel",
  'permissions.general.manageIntegrationsApiKeys.label': "Manage Integrations & API Keys",
  'permissions.general.manageIntegrationsApiKeys.description': "View or manage third-party integrations and API keys",
  'permissions.general.viewReportsAnalytics.label': "View Reports & Analytics",
  'permissions.general.viewReportsAnalytics.description': "View business-wide reports and analytics",
  'permissions.general.leadFinder.label': 'Lead Finder',
  'permissions.general.leadFinder.description': 'Find businesses on the map and the web, review them, and add them as contacts or vendors.',
  'permissions.general.manageDataLists.label': "Manage Data Lists",
  'permissions.general.manageDataLists.description': "View, edit records in, or create/delete Data Lists",
  'permissions.general.manageContactsGlobal.label': "Manage All Contacts",
  'permissions.general.manageContactsGlobal.description': "Business-wide contact management: bulk export, merge, or delete",
  'permissions.general.manageAutomationFlows.label': "Manage Automation Flows",
  'permissions.general.manageAutomationFlows.description': "View, modify, publish, or delete automation flows",
  'permissions.general.manageQuickReplies.label': "Manage Quick Replies",
  'permissions.general.manageQuickReplies.description': "View or edit quick reply sets",
  'permissions.general.manageCalendarBookings.label': "Manage Calendar & Bookings",
  'permissions.general.manageCalendarBookings.description': "View or edit calendars and bookings",
  'permissions.general.manageProductsCatalog.label': "Manage Products & Catalog",
  'permissions.general.manageProductsCatalog.description': "View, edit, create, or delete products and catalogs",
  'permissions.general.manageVendors.label': "Manage Vendors",
  'permissions.general.manageVendors.description': "View, edit, create, or delete vendors and their linked products",
  'permissions.general.manageOrders.label': "Manage Orders",
  'permissions.general.manageOrders.description': "View or edit orders",
  'permissions.general.exportBusinessData.label': "Export Business Data",
  'permissions.general.exportBusinessData.description': "Export business-wide data",
  'permissions.wabu.messaging.label': "Messaging",
  'permissions.wabu.messaging.description': "View and send messages in WhatsApp conversations",
  'permissions.wabu.useTemplates.label': "Use Message Templates",
  'permissions.wabu.useTemplates.description': "Send pre-approved WhatsApp message templates",
  'permissions.wabu.useAutomationFlows.label': "Use Automation Flows",
  'permissions.wabu.useAutomationFlows.description': "Trigger and manage automation flows for WhatsApp",
  'permissions.wabu.viewAnalytics.label': "View Analytics",
  'permissions.wabu.viewAnalytics.description': "View performance analytics for WhatsApp",
  'permissions.wabu.manageChannelConnection.label': "Manage Channel Connection",
  'permissions.wabu.manageChannelConnection.description': "Reconfigure or connect/disconnect the WhatsApp channel",
  'permissions.wabu.exportContacts.label': "Export Contacts",
  'permissions.wabu.exportContacts.description': "Export the contact list gathered from WhatsApp",
  'permissions.wabu.deleteConversations.label': "Delete Conversations",
  'permissions.wabu.deleteConversations.description': "Permanently delete WhatsApp conversations",
  'permissions.wabu.assignConversations.label': "Assign Conversations",
  'permissions.wabu.assignConversations.description': "Assign WhatsApp conversations to users or departments",
  'permissions.wabu.viewAllConversations.label': "View All Conversations",
  'permissions.wabu.viewAllConversations.description': "See every WhatsApp conversation, not just assigned ones",
  'permissions.wabu.manageContactTags.label': "Manage Contact Tags",
  'permissions.wabu.manageContactTags.description': "Add or remove tags on WhatsApp contacts",
  'permissions.fbm.messaging.label': "Messaging",
  'permissions.fbm.messaging.description': "View and send messages in Messenger conversations",
  'permissions.fbm.useTemplates.label': "Use Message Templates",
  'permissions.fbm.useTemplates.description': "Send pre-approved Messenger message templates",
  'permissions.fbm.useAutomationFlows.label': "Use Automation Flows",
  'permissions.fbm.useAutomationFlows.description': "Trigger and manage automation flows for Messenger",
  'permissions.fbm.viewAnalytics.label': "View Analytics",
  'permissions.fbm.viewAnalytics.description': "View performance analytics for Messenger",
  'permissions.fbm.manageChannelConnection.label': "Manage Channel Connection",
  'permissions.fbm.manageChannelConnection.description': "Reconfigure or connect/disconnect the Messenger channel",
  'permissions.fbm.exportContacts.label': "Export Contacts",
  'permissions.fbm.exportContacts.description': "Export the contact list gathered from Messenger",
  'permissions.fbm.deleteConversations.label': "Delete Conversations",
  'permissions.fbm.deleteConversations.description': "Permanently delete Messenger conversations",
  'permissions.fbm.assignConversations.label': "Assign Conversations",
  'permissions.fbm.assignConversations.description': "Assign Messenger conversations to users or departments",
  'permissions.fbm.viewAllConversations.label': "View All Conversations",
  'permissions.fbm.viewAllConversations.description': "See every Messenger conversation, not just assigned ones",
  'permissions.fbm.manageContactTags.label': "Manage Contact Tags",
  'permissions.fbm.manageContactTags.description': "Add or remove tags on Messenger contacts",
  'permissions.sms.messaging.label': "Messaging",
  'permissions.sms.messaging.description': "View and send messages in SMS conversations",
  'permissions.sms.useTemplates.label': "Use Message Templates",
  'permissions.sms.useTemplates.description': "Send pre-approved SMS message templates",
  'permissions.sms.useAutomationFlows.label': "Use Automation Flows",
  'permissions.sms.useAutomationFlows.description': "Trigger and manage automation flows for SMS",
  'permissions.sms.viewAnalytics.label': "View Analytics",
  'permissions.sms.viewAnalytics.description': "View performance analytics for SMS",
  'permissions.sms.manageChannelConnection.label': "Manage Channel Connection",
  'permissions.sms.manageChannelConnection.description': "Reconfigure or connect/disconnect the SMS channel",
  'permissions.sms.exportContacts.label': "Export Contacts",
  'permissions.sms.exportContacts.description': "Export the contact list gathered from SMS",
  'permissions.sms.deleteConversations.label': "Delete Conversations",
  'permissions.sms.deleteConversations.description': "Permanently delete SMS conversations",
  'permissions.sms.assignConversations.label': "Assign Conversations",
  'permissions.sms.assignConversations.description': "Assign SMS conversations to users or departments",
  'permissions.sms.viewAllConversations.label': "View All Conversations",
  'permissions.sms.viewAllConversations.description': "See every SMS conversation, not just assigned ones",
  'permissions.sms.manageContactTags.label': "Manage Contact Tags",
  'permissions.sms.manageContactTags.description': "Add or remove tags on SMS contacts",
  'permissions.email.messaging.label': "Messaging",
  'permissions.email.messaging.description': "View and send messages in Email conversations",
  'permissions.email.useTemplates.label': "Use Message Templates",
  'permissions.email.useTemplates.description': "Send pre-approved Email message templates",
  'permissions.email.useAutomationFlows.label': "Use Automation Flows",
  'permissions.email.useAutomationFlows.description': "Trigger and manage automation flows for Email",
  'permissions.email.viewAnalytics.label': "View Analytics",
  'permissions.email.viewAnalytics.description': "View performance analytics for Email",
  'permissions.email.manageChannelConnection.label': "Manage Channel Connection",
  'permissions.email.manageChannelConnection.description': "Reconfigure or connect/disconnect the Email channel",
  'permissions.email.exportContacts.label': "Export Contacts",
  'permissions.email.exportContacts.description': "Export the contact list gathered from Email",
  'permissions.email.deleteConversations.label': "Delete Conversations",
  'permissions.email.deleteConversations.description': "Permanently delete Email conversations",
  'permissions.email.assignConversations.label': "Assign Conversations",
  'permissions.email.assignConversations.description': "Assign Email conversations to users or departments",
  'permissions.email.viewAllConversations.label': "View All Conversations",
  'permissions.email.viewAllConversations.description': "See every Email conversation, not just assigned ones",
  'permissions.email.manageContactTags.label': "Manage Contact Tags",
  'permissions.email.manageContactTags.description': "Add or remove tags on Email contacts",
  'permissions.telegram.messaging.label': "Messaging",
  'permissions.telegram.messaging.description': "View and send messages in Telegram conversations",
  'permissions.telegram.useTemplates.label': "Use Message Templates",
  'permissions.telegram.useTemplates.description': "Send pre-approved Telegram message templates",
  'permissions.telegram.useAutomationFlows.label': "Use Automation Flows",
  'permissions.telegram.useAutomationFlows.description': "Trigger and manage automation flows for Telegram",
  'permissions.telegram.viewAnalytics.label': "View Analytics",
  'permissions.telegram.viewAnalytics.description': "View performance analytics for Telegram",
  'permissions.telegram.manageChannelConnection.label': "Manage Channel Connection",
  'permissions.telegram.manageChannelConnection.description': "Reconfigure or connect/disconnect the Telegram channel",
  'permissions.telegram.exportContacts.label': "Export Contacts",
  'permissions.telegram.exportContacts.description': "Export the contact list gathered from Telegram",
  'permissions.telegram.deleteConversations.label': "Delete Conversations",
  'permissions.telegram.deleteConversations.description': "Permanently delete Telegram conversations",
  'permissions.telegram.assignConversations.label': "Assign Conversations",
  'permissions.telegram.assignConversations.description': "Assign Telegram conversations to users or departments",
  'permissions.telegram.viewAllConversations.label': "View All Conversations",
  'permissions.telegram.viewAllConversations.description': "See every Telegram conversation, not just assigned ones",
  'permissions.telegram.manageContactTags.label': "Manage Contact Tags",
  'permissions.telegram.manageContactTags.description': "Add or remove tags on Telegram contacts",
  'permissions.instagram.messaging.label': "Messaging",
  'permissions.instagram.messaging.description': "View and send messages in Instagram conversations",
  'permissions.instagram.useTemplates.label': "Use Message Templates",
  'permissions.instagram.useTemplates.description': "Send pre-approved Instagram message templates",
  'permissions.instagram.useAutomationFlows.label': "Use Automation Flows",
  'permissions.instagram.useAutomationFlows.description': "Trigger and manage automation flows for Instagram",
  'permissions.instagram.viewAnalytics.label': "View Analytics",
  'permissions.instagram.viewAnalytics.description': "View performance analytics for Instagram",
  'permissions.instagram.manageChannelConnection.label': "Manage Channel Connection",
  'permissions.instagram.manageChannelConnection.description': "Reconfigure or connect/disconnect the Instagram channel",
  'permissions.instagram.exportContacts.label': "Export Contacts",
  'permissions.instagram.exportContacts.description': "Export the contact list gathered from Instagram",
  'permissions.instagram.deleteConversations.label': "Delete Conversations",
  'permissions.instagram.deleteConversations.description': "Permanently delete Instagram conversations",
  'permissions.instagram.assignConversations.label': "Assign Conversations",
  'permissions.instagram.assignConversations.description': "Assign Instagram conversations to users or departments",
  'permissions.instagram.viewAllConversations.label': "View All Conversations",
  'permissions.instagram.viewAllConversations.description': "See every Instagram conversation, not just assigned ones",
  'permissions.instagram.manageContactTags.label': "Manage Contact Tags",
  'permissions.instagram.manageContactTags.description': "Add or remove tags on Instagram contacts",
  'permissions.contacts.view.label': "View Contacts",
  'permissions.contacts.view.description': "None: only contacts assigned to this user or their department. View: all business contacts.",
  'permissions.contacts.viewMobileNumber.label': "View Mobile Number",
  'permissions.contacts.viewMobileNumber.description': "View contacts' mobile phone numbers",
  'permissions.contacts.manage.label': "Manage Contacts",
  'permissions.contacts.manage.description': "Create, edit, delete, or merge contacts. Independent from View Contacts.",
  'permissions.contacts.import.label': "Import Contacts",
  'permissions.contacts.import.description': "Import contacts from a file or device, including for campaigns",
  'permissions.contacts.export.label': "Export Contacts",
  'permissions.contacts.export.description': "Export the contact list",
  'permissions.contacts.manageTags.label': "Manage Contact Tags",
  'permissions.contacts.manageTags.description': "Add or remove contact tags",
  'permissions.contacts.manageNotes.label': "Manage Contact Notes",
  'permissions.contacts.manageNotes.description': "Add or remove notes on a contact",
  'permissions.contacts.manageAssignments.label': "Manage Contact Assignments",
  'permissions.contacts.manageAssignments.description': "Assign contacts to users or departments",
  'permissions.reports.view.label': "View Reports",
  'permissions.reports.view.description': "View: own scoped data only. Edit: also see managed team's data (Manager). Admin: business-wide, unrestricted.",
  'permissions.reports.export.label': "Export & Import Reports",
  'permissions.reports.export.description': "Export report data and import saved report templates",
  'permissions.reports.manageSavedReports.label': "Saved Reports",
  'permissions.reports.manageSavedReports.description': "View: load others' saved reports as templates. Edit: create, edit, and delete own saved reports.",
  'permissions.phone.viewCallHistory.label': "View Call History",
  'permissions.phone.viewCallHistory.description': "View: own calls only. Edit: also see managed team's calls (Manager). Admin: every call in the business, unrestricted.",
  'permissions.phone.playRecording.label': "Play Call Recordings",
  'permissions.phone.playRecording.description': "Listen to recordings of calls visible under View Call History",
  'permissions.phone.downloadRecording.label': "Download Call Recordings",
  'permissions.phone.downloadRecording.description': "Save or share a copy of a call recording",
  'permissions.notifications.manageSettings.label': "Manage Notification Settings",
  'permissions.notifications.manageSettings.description': "View or edit notification settings",
  'permissions.notifications.sendBroadcast.label': "Send Broadcast Notifications",
  'permissions.notifications.sendBroadcast.description': "Send broadcast notifications to the team",
  'permissions.storage.upload.label': "Upload Files",
  'permissions.storage.upload.description': "Upload media/files to storage",
  'permissions.storage.manage.label': "Manage Storage",
  'permissions.storage.manage.description': "Delete own uploads, or manage quota and any file",

  // Calendar — BusinessCalendarScreen.tsx
  'calendar.business.searchPlaceholder': "Search events...",
  'calendar.business.selectDate': "Select Date",
  'calendar.business.unknownCalendar': "Unknown Calendar",
  'calendar.business.untitledEvent': "Untitled Event",
  'calendar.business.noEventsFound': "No events found",
  'calendar.business.noEventsForDay': "No events for this day",
  'calendar.business.tryAdjustingFilters': "Try adjusting your filters",
  'calendar.business.createFirstEvent': "Create your first event to get started",
  'calendar.business.allCalendars': "All Calendars",
  'calendar.business.loadCalendarsFailed': "Failed to load calendars",

  // Calendar — CalendarCreateScreen.tsx
  'calendar.create.businessRequired': "Business information is required",
  'calendar.create.userRequired': "User information is required",
  'calendar.create.title': "Calendar",
  'calendar.create.subtitle': "Create a new calendar for your business",
  'calendar.create.personalTitle': "Personal Calendar",
  'calendar.create.personalSubtitle': "Create a calendar just for your own schedule",
  'calendar.create.successMessage': "Calendar created successfully",
  'calendar.create.failedMessage': "Failed to create calendar",
  'calendar.create.submitLabel': "Create Calendar",

  // Calendar — CalendarBookingScreen.tsx
  'calendar.booking.bookingFailedError': "Booking failed",
  'calendar.booking.pickFileFailedError': "Failed to pick file",
  'calendar.booking.selectTimeTitle': "Select Time",
  'calendar.booking.selectAppointmentTitle': "Select Appointment",
  'calendar.booking.eventDetailsTitle': "Event Details",
  'calendar.booking.selectDateTitle': "Select Date",
  'calendar.booking.noSlotsForDay': "No available time slots for this day",
  'calendar.booking.available': "Available",
  'calendar.booking.eventFallback': "Event",
  'calendar.booking.untitledEvent': "Untitled Event",
  'calendar.booking.timeRangeTo': "to",
  'calendar.booking.cancelButton': "Cancel",
  'calendar.booking.bookButton': "Book",
  'calendar.booking.viewExistingAppointments': "View Existing Appointments",
  'calendar.booking.appointmentsOnDay': "{{count}} {{label}} on this day",
  'calendar.booking.appointmentSingular': "appointment",
  'calendar.booking.appointmentPlural': "appointments",
  'calendar.booking.hourLabel': "Hour",
  'calendar.booking.minuteLabel': "Minute",
  'calendar.booking.periodLabel': "Period",
  'calendar.booking.durationLabel': "Duration",
  'calendar.booking.durationMinutes': "{{minutes}} min",
  'calendar.booking.durationSlots': "{{minutes}} min slots",
  'calendar.booking.notesLabel': "Notes (Optional)",
  'calendar.booking.notesPlaceholder': "Add any additional notes...",
  'calendar.booking.joinUrlLabel': "Join URL (Optional)",
  'calendar.booking.joinUrlPlaceholder': "https://meet.example.com/...",
  'calendar.booking.attachmentsLabel': "Attachments (Optional)",
  'calendar.booking.addFileButton': "Add File",
  'calendar.booking.createNewAppointment': "Create New Appointment",
  'calendar.booking.addNewAppointmentForDay': "Add a new appointment for this day",
  'calendar.booking.calendarFallback': "Calendar",
  'calendar.booking.titleLabel': "Title",
  'calendar.booking.descriptionLabel': "Description",
  'calendar.booking.locationLabel': "Location",
  'calendar.booking.meetingLinkLabel': "Meeting Link",
  'calendar.booking.attachmentsWithCount': "Attachments ({{count}})",
  'calendar.booking.attachmentFallback': "Attachment {{number}}",
  'calendar.booking.autoCloseText': "This window will close automatically",

  // Calendar — CalendarEditScreen.tsx
  'calendar.edit.loading': "Loading calendar...",
  'calendar.edit.notFound': "Calendar not found",
  'calendar.edit.loadFailed': "Failed to load calendar",
  'calendar.edit.calendarIdRequired': "Calendar ID is required",
  'calendar.edit.businessRequired': "Business information is required",
  'calendar.edit.updateSuccess': "Calendar updated successfully",
  'calendar.edit.updateFailed': "Failed to update calendar",
  'calendar.edit.title': "Calendar",
  'calendar.edit.subtitle': "Edit calendar settings",
  'calendar.edit.submitLabel': "Update Calendar",

  // Calendar — CalendarListScreen.tsx
  'calendar.list.loading': "Loading calendars...",
  'calendar.list.loadFailed': "Failed to load calendars",
  'calendar.list.companyCalendars': "Company Calendars",
  'calendar.list.myPersonalCalendar': "My Personal Calendar",
  'calendar.list.noCompanyCalendars': "No company calendars found.",
  'calendar.list.noPersonalCalendar': "No personal calendar yet — create one to sync your own schedule.",
  'calendar.list.createBusinessCalendar': "Create Business Calendar",
  'calendar.list.createPersonalCalendar': "Create Personal Calendar",
  'calendar.list.deleteSuccess': "Calendar deleted successfully",
  'calendar.list.deleteFailed': "Failed to delete calendar",
  'calendar.list.deleteTitle': "Delete Calendar",
  'calendar.list.deleteMessage': "Are you sure you want to delete this calendar? All events in this calendar will also be deleted.",
  'calendar.list.deleteConfirm': "Delete",
  'calendar.list.deleteCancel': "Cancel",
  'calendar.list.retry': "Retry",

  // Calendar — EventCreateScreen.tsx
  'calendar.eventCreate.missingInfo': "Business or calendar information missing",
  'calendar.eventCreate.successMessage': "Event created successfully",
  'calendar.eventCreate.failedMessage': "Failed to create event",
  'calendar.eventCreate.title': "Create Event",
  'calendar.eventCreate.submitLabel': "Create Event",

  // Calendar — EventForm.tsx
  'calendar.eventForm.defaultSubmitLabel': "Save Event",
  'calendar.eventForm.titleRequired': "Event title is required",
  'calendar.eventForm.endDateAfterStartDate': "End date must be after start date",
  'calendar.eventForm.endTimeAfterStartTime': "End time must be after start time",
  'calendar.eventForm.endDateTimeAfterStart': "End date and time must be after start date and time",
  'calendar.eventForm.meetingUrlRequired': "Meeting URL is required for online meetings",
  'calendar.eventForm.selectCalendarError': "Please select a calendar",
  'calendar.eventForm.invalidDate': "Invalid Date",
  'calendar.eventForm.uploadAttachmentFailed': "Failed to upload attachment",
  'calendar.eventForm.pickAttachmentFailed': "Failed to pick attachment. Please try again.",
  'calendar.eventForm.titleLabel': "Event Title *",
  'calendar.eventForm.titlePlaceholder': "e.g., Team Meeting, Client Call",
  'calendar.eventForm.calendarLabel': "Calendar *",
  'calendar.eventForm.selectCalendarPlaceholder': "Select calendar",
  'calendar.eventForm.descriptionLabel': "Description",
  'calendar.eventForm.descriptionPlaceholder': "Event description",
  'calendar.eventForm.contactsLabel': "Contacts",
  'calendar.eventForm.selectContactsPlaceholder': "Select contacts",
  'calendar.eventForm.contactsSelectedCount': "{{count}} {{label}} selected",
  'calendar.eventForm.contactSingular': "contact",
  'calendar.eventForm.contactPlural': "contacts",
  'calendar.eventForm.searchContactsPlaceholder': "Search contacts...",
  'calendar.eventForm.loadingContacts': "Loading contacts...",
  'calendar.eventForm.noContactsFound': "No contacts found",
  'calendar.eventForm.noContactsAvailable': "No contacts available",
  'calendar.eventForm.unknownContact': "Unknown Contact",
  'calendar.eventForm.unknownContactShort': "Unknown",
  'calendar.eventForm.allDayEventLabel': "All Day Event",
  'calendar.eventForm.dateTimeLabel': "Date & Time *",
  'calendar.eventForm.startDateLabel': "Start Date",
  'calendar.eventForm.endDateLabel': "End Date",
  'calendar.eventForm.startLabel': "Start",
  'calendar.eventForm.endLabel': "End",
  'calendar.eventForm.meetingTypeLabel': "Meeting Type",
  'calendar.eventForm.locationNameLabel': "Location Name",
  'calendar.eventForm.locationNamePlaceholder': "e.g., Conference Room A",
  'calendar.eventForm.addressLabel': "Address",
  'calendar.eventForm.addressPlaceholder': "Full address",
  'calendar.eventForm.meetingProviderLabel': "Meeting Provider",
  'calendar.eventForm.meetingUrlLabel': "Meeting URL *",
  'calendar.eventForm.meetingUrlPlaceholder': "https://...",
  'calendar.eventForm.meetingPasswordLabel': "Meeting Password",
  'calendar.eventForm.optionalPlaceholder': "Optional",
  'calendar.eventForm.attachmentsLabel': "Attachments",
  'calendar.eventForm.uploadingText': "Uploading...",
  'calendar.eventForm.addAttachmentButton': "Add Attachment",
  'calendar.eventForm.notesLabel': "Notes",
  'calendar.eventForm.noteContentPlaceholder': "Note content",
  'calendar.eventForm.addNotePlaceholder': "Add a note...",
  'calendar.eventForm.remindersLabel': "Reminders",
  'calendar.eventForm.remindersHelperText': "Get notified before this event starts",
  'calendar.eventForm.reminderAtTimeOfEvent': "At time of event",
  'calendar.eventForm.reminderMinutes5': "5 minutes before",
  'calendar.eventForm.reminderMinutes15': "15 minutes before",
  'calendar.eventForm.reminderMinutes30': "30 minutes before",
  'calendar.eventForm.reminderHour1': "1 hour before",
  'calendar.eventForm.reminderDay1': "1 day before",
  'calendar.eventForm.reminderMinutesBefore': "{{count}} minutes before",
  'calendar.eventForm.reminderHoursBefore': "{{count}} hours before",
  'calendar.eventForm.reminderDaysBefore': "{{count}} days before",
  'calendar.eventForm.reminderCustomPlaceholder': "Custom minutes before",
  'calendar.eventForm.cancelButton': "Cancel",

  // Calendar — EventDetailScreen.tsx
  'calendar.eventDetail.loadFailed': "Failed to load event",
  'calendar.eventDetail.deleteSuccess': "Event deleted successfully",
  'calendar.eventDetail.deleteFailed': "Failed to delete event",
  'calendar.eventDetail.title': "Event Details",
  'calendar.eventDetail.loading': "Loading event...",
  'calendar.eventDetail.dateTimeSection': "Date & Time",
  'calendar.eventDetail.allDay': "All Day",
  'calendar.eventDetail.until': "Until {{date}}",
  'calendar.eventDetail.timezone': "Timezone: {{timezone}}",
  'calendar.eventDetail.descriptionSection': "Description",
  'calendar.eventDetail.locationSection': "Location",
  'calendar.eventDetail.onlineMeetingSection': "Online Meeting",
  'calendar.eventDetail.customProvider': "Custom",
  'calendar.eventDetail.joinMeeting': "Join Meeting",
  'calendar.eventDetail.password': "Password: {{password}}",
  'calendar.eventDetail.attachmentsSection': "Attachments ({{count}})",
  'calendar.eventDetail.attachmentFallback': "Attachment {{number}}",
  'calendar.eventDetail.attendeesSection': "Attendees ({{count}})",
  'calendar.eventDetail.myRsvpSection': "My RSVP",
  'calendar.eventDetail.rsvpAccept': "Accept",
  'calendar.eventDetail.rsvpTentative': "Tentative",
  'calendar.eventDetail.rsvpDecline': "Decline",
  'calendar.eventDetail.rsvpUpdated': "Your response was saved",
  'calendar.eventDetail.rsvpFailed': "Could not save your response",
  'calendar.eventDetail.deleteTitle': "Delete Event",
  'calendar.eventDetail.deleteMessage': "Are you sure you want to delete this event?",
  'calendar.eventDetail.deleteConfirm': "Delete",
  'calendar.eventDetail.deleteCancel': "Cancel",
  'calendar.eventDetail.editButton': "Edit",
  'calendar.eventDetail.deleteButton': "Delete",

  // Calendar — EventListScreen.tsx
  'calendar.eventList.noSelection': "No calendar or business selected",
  'calendar.eventList.loadFailed': "Failed to load events",
  'calendar.eventList.deleteSuccess': "Event deleted successfully",
  'calendar.eventList.deleteFailed': "Failed to delete event",
  'calendar.eventList.fallbackTitle': "Events",
  'calendar.eventList.loading': "Loading events...",
  'calendar.eventList.retry': "Retry",
  'calendar.eventList.noEventsFound': "No events found",
  'calendar.eventList.createFirstEvent': "Create your first event to get started",
  'calendar.eventList.createEvent': "Create Event",
  'calendar.eventList.deleteTitle': "Delete Event",
  'calendar.eventList.deleteMessage': "Are you sure you want to delete this event?",
  'calendar.eventList.deleteConfirm': "Delete",
  'calendar.eventList.deleteCancel': "Cancel",

  // Calendar — CalendarForm.tsx
  'calendar.calendarForm.nameLabel': "Calendar Name *",
  'calendar.calendarForm.namePlaceholder': "e.g., Work Calendar, Personal Calendar",
  'calendar.calendarForm.descriptionLabel': "Description",
  'calendar.calendarForm.descriptionPlaceholder': "Brief description of this calendar",
  'calendar.calendarForm.colorLabel': "Color *",
  'calendar.calendarForm.timezoneLabel': "Timezone *",
  'calendar.calendarForm.visibilityLabel': "Visibility",
  'calendar.calendarForm.visibilityPrivate': "Private",
  'calendar.calendarForm.visibilityPublic': "Public",
  'calendar.calendarForm.visibilityShared': "Shared",
  'calendar.calendarForm.setDefaultLabel': "Set as Default Calendar",
  'calendar.calendarForm.setDefaultDescription': "This calendar will be used as the default for new events",
  'calendar.calendarForm.activeLabel': "Active",
  'calendar.calendarForm.activeDescription': "Inactive calendars won't appear in the calendar list",
  'calendar.calendarForm.availabilityLabel': "Availability",
  'calendar.calendarForm.availabilityHelperText': "Configure when this calendar is available",
  'calendar.calendarForm.availabilityModeAllTime': "All Time",
  'calendar.calendarForm.availabilityModePeriod': "Period",
  'calendar.calendarForm.availabilityModeDays': "Days",
  'calendar.calendarForm.startDateLabel': "Start Date",
  'calendar.calendarForm.endDateLabel': "End Date",
  'calendar.calendarForm.selectDatePlaceholder': "Select date",
  'calendar.calendarForm.allDayLabel': "All Day",
  'calendar.calendarForm.allDayDescription': "Available 24 hours or specific time range",
  'calendar.calendarForm.startTimeLabel': "Start Time",
  'calendar.calendarForm.endTimeLabel': "End Time",
  'calendar.calendarForm.selectDaysOfWeekLabel': "Select Days of Week",
  'calendar.calendarForm.daySunShort': "Sun",
  'calendar.calendarForm.dayMonShort': "Mon",
  'calendar.calendarForm.dayTueShort': "Tue",
  'calendar.calendarForm.dayWedShort': "Wed",
  'calendar.calendarForm.dayThuShort': "Thu",
  'calendar.calendarForm.dayFriShort': "Fri",
  'calendar.calendarForm.daySatShort': "Sat",
  'calendar.calendarForm.slotDurationLabel': "Slot Duration (minutes)",
  'calendar.calendarForm.slotDurationPlaceholder': "e.g. 30",
  'calendar.calendarForm.maxBookingsPerSlotLabel': "Max Bookings Per Slot",
  'calendar.calendarForm.maxBookingsPerSlotPlaceholder': "1",
  'calendar.calendarForm.slotDurationHelperText': "Leave slot duration empty to treat the whole availability window as one bookable slot.",
  'calendar.calendarForm.cancelButton': "Cancel",
  'calendar.calendarForm.saveButton': "Save Calendar",
  'calendar.calendarForm.nameRequiredError': "Calendar name is required",
  'calendar.calendarForm.nameMinLengthError': "Calendar name must be at least 2 characters",
  'calendar.calendarForm.timezoneRequiredError': "Timezone is required",
  'calendar.calendarForm.startDateRequiredError': "Start date is required",
  'calendar.calendarForm.endDateRequiredError': "End date is required",
  'calendar.calendarForm.endDateAfterStartError': "End date must be after start date",
  'calendar.calendarForm.selectAtLeastOneDayError': "Please select at least one day",
  'calendar.calendarForm.startTimeRequiredError': "Start time is required",
  'calendar.calendarForm.endTimeRequiredError': "End time is required",
  'calendar.calendarForm.endTimeAfterStartError': "End time must be after start time",

  // Calendar — CalendarGoogleSync.tsx
  'calendar.googleSync.title': "Sync with Google",
  'calendar.googleSync.helperText': "Keep this calendar in sync with a Google Calendar — events added on either side will appear on both.",
  'calendar.googleSync.connectButton': "Connect Google Calendar",
  'calendar.googleSync.connectedTitle': "Connected",
  'calendar.googleSync.connectedMessage': "Linked {{email}}",
  'calendar.googleSync.connectFailedTitle': "Could not connect",
  'calendar.googleSync.pickCalendar': "Choose which Google calendar to sync",
  'calendar.googleSync.hidePicker': "Hide Google calendars",
  'calendar.googleSync.noGoogleCalendars': "No calendars found on this Google account.",
  'calendar.googleSync.linkedTitle': "Calendar linked",
  'calendar.googleSync.linkedMessage': "\"{{name}}\" is now syncing.",
  'calendar.googleSync.linkFailedTitle': "Could not link calendar",
  'calendar.googleSync.updateFailedTitle': "Could not update",
  'calendar.googleSync.genericRetry': "Please try again.",
  'calendar.googleSync.tapToChange': "tap to change",
  'calendar.googleSync.syncEnabledLabel': "Sync enabled",
  'calendar.googleSync.directionInbound': "Google → DISLIX",
  'calendar.googleSync.directionOutbound': "DISLIX → Google",
  'calendar.googleSync.directionBoth': "Both directions",
  'calendar.googleSync.changeCalendar': "Change calendar",
  'calendar.googleSync.unlinkCalendar': "Unlink",
  'calendar.googleSync.unlinkFailedTitle': "Could not unlink calendar",

  // Calendar — EventEditScreen.tsx
  'calendar.eventEdit.missingInfo': "Missing required information",
  'calendar.eventEdit.updateSuccess': "Event updated successfully",
  'calendar.eventEdit.updateFailed': "Failed to update event",
  'calendar.eventEdit.selectCalendarError': "Please select a calendar",
  'calendar.eventEdit.createSuccess': "Event created successfully",
  'calendar.eventEdit.createFailed': "Failed to create event",
  'calendar.eventEdit.saveFailedUpdate': "Failed to update event",
  'calendar.eventEdit.saveFailedCreate': "Failed to create event",
  'calendar.eventEdit.loadFailed': "Failed to load event",
  'calendar.eventEdit.loading': "Loading event...",
  'calendar.eventEdit.notFound': "Event not found",
  'calendar.eventEdit.loadingCalendars': "Loading calendars...",
  'calendar.eventEdit.noCalendarsAvailable': "No calendars available. Please create a calendar first.",
  'calendar.eventEdit.editTitle': "Edit Event",
  'calendar.eventEdit.createTitle': "Create Event",
  'calendar.eventEdit.updateSubtitle': "Update event details",
  'calendar.eventEdit.createSubtitle': "Add a new event",
  'calendar.eventEdit.untitledEvent': "Untitled Event",
  'calendar.eventEdit.dateTimeSection': "Date & Time",
  'calendar.eventEdit.allDay': "All Day",
  'calendar.eventEdit.attendeesSection': "Attendees & Contacts",
  'calendar.eventEdit.externalAttendeeFallback': "External Attendee",
  'calendar.eventEdit.userIdLabel': "User ID: {{userId}}",
  'calendar.eventEdit.onlineMeetingSection': "Online Meeting",
  'calendar.eventEdit.locationSection': "Location",
  'calendar.eventEdit.joinMeeting': "Join Meeting",
  'calendar.eventEdit.eventDetailsSection': "Event Details",
  'calendar.eventEdit.updateSubmitLabel': "Update Event",
  'calendar.eventEdit.createSubmitLabel': "Create Event",
  'calendar.eventEdit.deleteSuccess': "Event deleted successfully",
  'calendar.eventEdit.deleteFailed': "Failed to delete event",
  'calendar.eventEdit.deleteTitle': "Delete Event",
  'calendar.eventEdit.deleteMessage': "Are you sure you want to delete this event?",
  'calendar.eventEdit.deleteConfirm': "Delete",
  'calendar.eventEdit.deleteCancel': "Cancel",

  // Calendar — CalendarList.tsx
  'calendar.calendarList.loading': "Loading calendars...",
  'calendar.calendarList.emptyDefault': "No calendars found",

  // Calendar — CalendarMonthView.tsx
  'calendar.monthView.untitledEvent': "Untitled",
  'calendar.monthView.moreEvents': "+{{count}} more",
  'calendar.monthView.daySun': "Sun",
  'calendar.monthView.dayMon': "Mon",
  'calendar.monthView.dayTue': "Tue",
  'calendar.monthView.dayWed': "Wed",
  'calendar.monthView.dayThu': "Thu",
  'calendar.monthView.dayFri': "Fri",
  'calendar.monthView.daySat': "Sat",

  // Calendar — EventCard.tsx
  'calendar.eventCard.allDay': "All Day",
  'calendar.eventCard.until': "Until {{date}}",
  'calendar.eventCard.online': "Online",
  'calendar.eventCard.acceptedCount': "{{accepted}}/{{total}} accepted",

  // Calendar — CalendarCard.tsx
  'calendar.calendarCard.default': "Default",
  'calendar.calendarCard.eventCount': "{{count}} events",
  'calendar.calendarCard.inactive': "Inactive",
  'calendar.calendarCard.visibilityPublic': "public",
  'calendar.calendarCard.visibilityPrivate': "private",
  'calendar.calendarCard.visibilityShared': "shared",

  // ─── Visits setup ───────────────────────────────────────────────────────────
  'visitsSetup.title': 'Visits Setup',
  'visitsSetup.enablePrompt': 'Enable field visits to configure defaults, geofencing, photo requirements, and outcomes.',
  'visitsSetup.enableButton': 'Enable Visits',
  'visitsSetup.disableButton': 'Disable Visits',
  'visitsSetup.disableConfirmTitle': 'Disable Visits?',
  'visitsSetup.disableConfirmMessage': 'This will remove all Visits configuration. Existing visits are not affected.',
  'visitsSetup.sections.defaults': 'Defaults',
  'visitsSetup.sections.location': 'Location Enforcement',
  'visitsSetup.sections.photos': 'Photo Requirements',
  'visitsSetup.sections.eligibility': 'Eligibility',
  'visitsSetup.sections.outcomes': 'Outcomes',
  'visitsSetup.sections.calendar': 'Calendar Defaults',
  'visitsSetup.sections.routing': 'Route Directions',
  'visitsSetup.fields.expectedDurationMinutes': 'Expected Duration (minutes)',
  'visitsSetup.fields.dailyVisitTarget': 'Daily Visit Target',
  'visitsSetup.fields.defaultCampaignDurationDays': 'Default Campaign Duration (days)',
  'visitsSetup.fields.defaultVisitWindowHours': 'Default Visit Window (hours)',
  'visitsSetup.fields.locationEnabled': 'Enforce Location',
  'visitsSetup.fields.radiusMeters': 'Allowed Radius (meters)',
  'visitsSetup.fields.maxAccuracyMeters': 'Max GPS Accuracy (meters)',
  'visitsSetup.fields.allowOverride': 'Allow Override With Reason',
  'visitsSetup.fields.requireOnStart': 'Require Photo on Start',
  'visitsSetup.fields.requireOnEnd': 'Require Photo on End',
  'visitsSetup.fields.minPhotosOnStart': 'Min Photos on Start',
  'visitsSetup.fields.minPhotosOnEnd': 'Min Photos on End',
  'visitsSetup.fields.maxPhotos': 'Max Photos',
  'visitsSetup.fields.cameraOnlyNote': 'Camera capture only — gallery uploads are not permitted',
  'visitsSetup.fields.eligibleUsers': 'Eligible Users',
  'visitsSetup.fields.eligibleDepartments': 'Eligible Departments',
  'visitsSetup.fields.selectUsers': 'Select Users',
  'visitsSetup.fields.selectDepartments': 'Select Departments',
  'visitsSetup.fields.autoCreateEvent': 'Auto-create Calendar Event',
  'visitsSetup.fields.useRoadRouting': 'Use road-following directions',
  'visitsSetup.fields.useRoadRoutingHint': 'Requires the self-hosted routing service to be configured on the server. When off, or if the service is unavailable, a straight-line distance is used instead.',
  'visitsSetup.fields.reminderOffsets': 'Reminder Offsets (minutes, comma-separated)',
  'visitsSetup.fields.defaultCalendarId': 'Default Calendar ID',
  'visitsSetup.outcomes.addOutcome': 'Add Outcome',
  'visitsSetup.outcomes.editTitle': 'Edit Outcome',
  'visitsSetup.outcomes.label': 'Label',
  'visitsSetup.outcomes.labelAr': 'Label (Arabic)',
  'visitsSetup.outcomes.icon': 'Icon',
  'visitsSetup.outcomes.color': 'Color',
  'visitsSetup.outcomes.resultType': 'Result Type',
  'visitsSetup.outcomes.resultTypeSuccess': 'Success',
  'visitsSetup.outcomes.resultTypeNeutral': 'Neutral',
  'visitsSetup.outcomes.resultTypeFailure': 'Failure',
  'visitsSetup.outcomes.active': 'Active',
  'visitsSetup.outcomes.actionType': 'Action',
  'visitsSetup.outcomes.actionNone': 'None',
  'visitsSetup.outcomes.actionReschedule': 'Reschedule',
  'visitsSetup.outcomes.actionReminder': 'Create Reminder',
  'visitsSetup.outcomes.actionAssign': 'Assign/Reassign',
  'visitsSetup.outcomes.actionNote': 'Add Note',
  'visitsSetup.outcomes.removeConfirmTitle': 'Remove Outcome?',
  'visitsSetup.outcomes.removeConfirmMessage': 'This outcome will no longer be available for new visits.',
  'visitsSetup.save': 'Save',
  'visitsSetup.cancel': 'Cancel',
  'visitsSetup.savedSuccess': 'Saved successfully',
  'visitsSetup.saveFailed': 'Failed to save',

  // ─── Visits (Phase 2 — singular visit CRUD + execution) ─────────────────────
  'visits.common.save': 'Save',
  'visits.common.cancel': 'Cancel',
  'visits.errors.generic': 'Something went wrong. Please try again.',
  'visits.status.pending': 'Pending',
  'visits.status.scheduled': 'Scheduled',
  'visits.status.in_progress': 'In Progress',
  'visits.status.completed': 'Completed',
  'visits.status.missed': 'Missed',
  'visits.status.cancelled': 'Cancelled',
  'visits.status.rescheduled': 'Rescheduled',
  'visits.priority.low': 'Low',
  'visits.priority.normal': 'Normal',
  'visits.priority.high': 'High',
  'visits.priority.urgent': 'Urgent',

  'visits.filters.all': 'All',
  'visits.filters.active': 'Active',
  'visits.list.title': 'Visits',
  'visits.list.createVisit': 'Create Visit',
  'visits.list.createVisitSubtitle': 'Schedule a single field visit',
  'visits.list.createCampaign': 'Create Campaign',
  'visits.list.createCampaignSubtitle': 'Plan and distribute visits across a contact pool',
  'visits.list.createMenuTitle': 'What would you like to create?',
  'visits.list.contact': 'Contact',
  'visits.list.noSchedule': 'Not scheduled',
  'visits.list.empty': 'No visits found',
  'visits.list.routeButton': 'Route',
  'visits.list.campaignsButton': 'Campaigns',
  'visits.list.settingsButton': 'Visit Settings',
  'visits.route.title': 'Route',
  'visits.route.titleForCampaign': 'Campaign Route',
  'visits.route.visitsCount': '{{selected}} of {{total}} visits selected',
  'visits.route.selectAll': 'Select all',
  'visits.route.deselectAll': 'Deselect all',
  'visits.route.noEligibleVisits': 'No eligible visits to route right now',
  'visits.route.anchorCurrentLocation': 'My Current Location',
  'visits.route.anchorManual': 'Enter Coordinates',
  'visits.route.latitude': 'Latitude',
  'visits.route.longitude': 'Longitude',
  'visits.route.directionsMode': 'Directions Mode',
  'visits.route.modeDriving': 'Driving',
  'visits.route.modeWalking': 'Walking',
  'visits.route.modeCycling': 'Cycling',
  'visits.route.modeMotorcycle': 'Motorcycle',
  'visits.route.compute': 'Compute Route',
  'visits.route.openInMaps': 'Open in Maps',
  'visits.route.fallbackBanner': 'Using straight-line distance — routing service unavailable',
  'visits.route.notIncluded': 'Not Included',
  'visits.route.notIncludedNote': 'These visits could not be routed — missing location',
  'visits.route.totalDistance': 'Total Distance',
  'visits.route.noVisitsSelected': 'Select at least one visit',
  'visits.route.noAnchor': 'Set a starting point first',

  'visits.detail.title': 'Visit Details',
  'visits.detail.overview': 'Overview',
  'visits.detail.startNextVisit': 'Start next visit',
  'visits.detail.contact': 'Contact',
  'visits.detail.unknownContact': 'Unknown Contact',
  'visits.detail.viewProfile': 'View profile',
  'visits.detail.viewOnDislixMaps': 'View on DISLIX Maps',
  'visits.map.closeDirections': 'Close directions',
  'visits.map.expand': 'Expand map',
  'visits.detail.backToVisits': 'Back to Visits',
  'visits.detail.backToHome': 'Back to Home',
  'visits.detail.partOfCampaign': 'Part of campaign',
  'visits.detail.singleVisit': 'Single visit',
  'visits.detail.targetLocation': 'Target Location',
  'visits.detail.schedule': 'Schedule',
  'visits.detail.scheduledFor': 'Scheduled for',
  'visits.detail.dueBy': 'Due by',
  'visits.detail.expectedDuration': 'Expected duration',
  'visits.detail.minutes': 'minutes',
  'visits.detail.assignment': 'Assignment',
  'visits.detail.assignedUser': 'Assigned user',
  'visits.detail.assignedDepartment': 'Assigned department',
  'visits.detail.geoStamps': 'Location Records',
  'visits.detail.startGeoStamp': 'Start location',
  'visits.detail.endGeoStamp': 'End location',
  'visits.detail.photos': 'Photos',
  'visits.detail.outcome': 'Outcome',
  'visits.detail.action': 'Action',
  'visits.detail.notes': 'Notes',
  'visits.detail.addNote': 'Add Note',
  'visits.detail.notePlaceholder': 'Write a note...',
  'visits.detail.noNotes': 'No notes yet',
  'visits.detail.startVisit': 'Start Visit',
  'visits.detail.continueVisit': 'Continue Visit',
  'visits.detail.claimVisit': 'Claim Visit',
  'visits.detail.cancelVisit': 'Cancel Visit',
  'visits.detail.cancelConfirmTitle': 'Cancel this visit?',
  'visits.detail.cancelConfirmMessage': 'This visit will be marked as cancelled. This action cannot be undone.',
  'visits.detail.cancelReasonLabel': 'Reason for cancelling',
  'visits.detail.cancelReasonPlaceholder': 'Why is this visit being cancelled?',
  'visits.detail.getDirections': 'Get Directions',
  'visits.detail.previousVisits': 'Previous Visits',
  'visits.detail.contactNotes': 'Contact Notes',
  'visits.detail.contactNotePlaceholder': 'Add a note about this contact...',

  'visits.create.title': 'Create Visit',
  'visits.create.contactSection': 'Contact',
  'visits.create.selectContact': 'Select Contact',
  'visits.create.changeContact': 'Change Contact',
  'visits.create.searchContacts': 'Search contacts...',
  'visits.create.noContactsFound': 'No contacts found',
  'visits.create.assigneeSection': 'Assignee',
  'visits.create.assignToUser': 'Assign to User',
  'visits.create.assignToDepartment': 'Assign to Department',
  'visits.create.selectUser': 'Select User',
  'visits.create.selectDepartment': 'Select Department',
  'visits.create.prioritySection': 'Priority',
  'visits.create.scheduleSection': 'Schedule',
  'visits.create.scheduledDate': 'Scheduled Date',
  'visits.create.scheduledTime': 'Scheduled Time',
  'visits.create.expectedDuration': 'Expected Duration (minutes)',
  'visits.create.expectedDurationPlaceholder': 'Defaults to business setting',
  'visits.create.createCalendarEvent': 'Create Calendar Event',
  'visits.create.submit': 'Create Visit',
  'visits.create.errors.contactRequired': 'Please select a contact',
  'visits.create.errors.assigneeRequired': 'Please assign this visit to a user or department',
  'visits.create.errors.scheduleRequiredForCalendar': 'A schedule date is required to sync this visit with the calendar',
  'visits.create.errors.contactNoLocation': 'This contact has no location, maps URL, or address on file, so a visit cannot be created for it. Add a location to the contact first.',

  'visits.execute.title': 'Visit Execution',
  'visits.execute.targetLocation': 'Target Location',
  'visits.execute.refreshLocation': 'Refresh Location',
  'visits.execute.distanceFromYou': '{{distance}}m from target',
  'visits.execute.startPhotos': 'Start Photos',
  'visits.execute.endPhotos': 'End Photos',
  'visits.execute.overrideReason': 'Override Reason (optional)',
  'visits.execute.overrideReasonPlaceholder': 'Why are you outside the allowed radius?',
  'visits.execute.startVisit': 'Start Visit',
  'visits.execute.viewOnDislixMaps': 'View on DISLIX Maps',
  'visits.execute.ongoingVisitTitle': 'You have an ongoing visit',
  'visits.execute.ongoingVisitMessage': 'You must end your ongoing visit before starting another one.',
  'visits.execute.ongoingVisitAction': 'Go to ongoing visit',
  'visits.execute.closeToTarget': "You're close to the destination — tap to start the visit",
  'visits.execute.inProgress': 'Visit In Progress',
  'visits.execute.liveDirectionsFallback': 'Using straight-line distance — routing service unavailable',
  'visits.execute.unnamedRoad': 'Unnamed road',
  'visits.execute.etaApprox': '~{{minutes}} min (typical traffic)',
  'visits.execute.blockedNoLocation': 'Waiting for your location before you can start.',
  'visits.execute.blockedMissingStartPhotos': 'Add at least {{count}} photo(s) before starting.',
  'visits.execute.blockedMissingEndPhotos': 'Add at least {{count}} photo(s) before ending.',
  'visits.execute.onTheWay': 'On the way',
  'visits.execute.routeFastest': 'Fastest route',
  'visits.execute.routeAlternative': 'Alternative {{number}}',
  'visits.execute.addNoteQuick': 'Add a quick note',
  'visits.execute.endVisit': 'End Visit',
  'visits.execute.selectOutcome': 'Select Outcome',
  'visits.execute.rescheduleHours': 'Hours from now',
  'visits.execute.reminderMinutes': 'Minutes from now',
  'visits.execute.selectAssignee': 'Select Assignee',
  'visits.execute.outcomeNote': 'Note',
  'visits.execute.confirm': 'Confirm',
  'visits.execute.errors.locationPermissionDenied': 'Location permission is required to start a visit',
  'visits.execute.errors.locationFailed': 'Could not get your current location',
  'visits.execute.errors.cameraPermissionDenied': 'Camera permission is required to capture a photo',
  'visits.execute.errors.photoUploadFailed': 'Failed to upload photo',
  'visits.execute.errors.tooFarAway': 'You are {{distance}}m away, must be within {{radius}}m',
  'visits.execute.errors.assigneeRequired': 'Please select a user or department',
  'visits.execute.errors.noteRequired': 'Please enter a note',

  'visitCampaigns.status.draft': 'Draft',
  'visitCampaigns.status.active': 'Active',
  'visitCampaigns.status.paused': 'Paused',
  'visitCampaigns.status.completed': 'Completed',
  'visitCampaigns.status.cancelled': 'Cancelled',

  'visitCampaigns.list.title': 'Campaigns',
  'visitCampaigns.list.createCampaign': 'Create Campaign',
  'visitCampaigns.list.empty': 'No campaigns found',
  'visitCampaigns.list.contactCount': '{{count}} contacts',

  'visitCampaigns.create.title': 'Create Campaign',
  'visitCampaigns.create.back': 'Back',
  'visitCampaigns.create.next': 'Next',
  'visitCampaigns.create.done': 'Done',
  'visitCampaigns.create.basicsSection': 'Campaign Basics',
  'visitCampaigns.create.name': 'Name',
  'visitCampaigns.create.namePlaceholder': 'e.g. Q3 Customer Check-ins',
  'visitCampaigns.create.description': 'Description',
  'visitCampaigns.create.descriptionPlaceholder': 'Optional description',
  'visitCampaigns.create.startDate': 'Start Date',
  'visitCampaigns.create.endDate': 'End Date',
  'visitCampaigns.create.expectedDuration': 'Expected Duration (minutes)',
  'visitCampaigns.create.expectedDurationPlaceholder': 'Defaults to business setting',
  'visitCampaigns.create.dailyVisitTarget': 'Daily Visit Target',
  'visitCampaigns.create.dailyVisitTargetPlaceholder': 'Optional target per day',
  'visitOverride.title': 'Override defaults',
  'visitOverride.locationGroup': 'Location enforcement',
  'visitOverride.locationEnabled': 'Enforce check-in location',
  'visitOverride.radiusMeters': 'Check-in radius (meters)',
  'visitOverride.maxAccuracyMeters': 'Max GPS accuracy allowed (meters)',
  'visitOverride.allowOverrideWithReason': 'Allow override with a reason',
  'visitOverride.photosGroup': 'Photo requirements',
  'visitOverride.requireOnStart': 'Require photo to start',
  'visitOverride.minPhotosOnStart': 'Minimum photos on start',
  'visitOverride.requireOnEnd': 'Require photo to end',
  'visitOverride.minPhotosOnEnd': 'Minimum photos on end',
  'visitOverride.maxPhotos': 'Maximum photos',
  'visitOverride.calendarGroup': 'Calendar',
  'visitOverride.autoCreateEvent': 'Auto-create calendar event',
  'visitOverride.inheritPlaceholder': 'Inherit default',
  'visitOverride.saved': 'Overrides saved',
  'visitOverride.save': 'Save overrides',
  'visitCampaigns.create.assignmentSection': 'Assign to Departments/Users',
  'visitCampaigns.create.assignedDepartments': 'Assigned Departments',
  'visitCampaigns.create.assignedUsers': 'Assigned Users',
  'visitCampaigns.create.selectDepartments': 'Select Departments',
  'visitCampaigns.create.selectUsers': 'Select Users',
  'visitCampaigns.create.selectedCount': '{{count}} selected',
  'visitCampaigns.create.contactPoolSection': 'Contact Pool',
  'visitCampaigns.create.contactCountSoFar': '{{count}} contacts attached so far',
  'visitCampaigns.create.selectContactsTab': 'Select Contacts',
  'visitCampaigns.create.uploadFileTab': 'Upload File',
  'visitCampaigns.create.searchAndSelectContacts': 'Search & Select Contacts',
  'visitCampaigns.create.attachSelected': 'Attach {{count}} Contacts',
  'visitCampaigns.create.chooseFile': 'Choose File',
  'visitCampaigns.create.uploadingProgress': 'Uploading... {{percent}}%',
  'visitCampaigns.create.uploadStillProcessing': 'This is taking longer than expected. The import is still running in the background.',
  'visitCampaigns.create.contactsAttached': '{{count}} contacts attached',
  'visitCampaigns.create.pendingAttachNote': '{{count}} more will be attached when you activate',
  'visitCampaigns.create.skippedNoLocation': '{{count}} contacts skipped (no location on file)',
  'visitCampaigns.create.reviewSection': 'Review & Activate',
  'visitCampaigns.create.activateCampaign': 'Activate Campaign',
  'visitCampaigns.create.saveAsDraft': 'Save as Draft',
  'visitCampaigns.create.errors.nameRequired': 'Please enter a campaign name',
  'visitCampaigns.create.errors.datesRequired': 'Please select a start and end date',
  'visitCampaigns.create.errors.assignmentRequired': 'You must assign at least one department or user before adding contacts',
  'visitCampaigns.create.errors.mustAssignFirst': 'Campaign must have at least one assigned department or user before contacts can be attached',
  'visitCampaigns.create.errors.noContactsBeforeActivate': 'Add at least one contact to this campaign before activating it',

  'visitCampaigns.detail.title': 'Campaign Details',
  'visitCampaigns.detail.activate': 'Activate',
  'visitCampaigns.detail.activated': 'Campaign activated',
  'visitCampaigns.detail.cancelCampaign': 'Cancel Campaign',
  'visitCampaigns.detail.cancelConfirmTitle': 'Cancel this campaign?',
  'visitCampaigns.detail.cancelConfirmMessage': 'This will cancel the campaign and all its non-terminal visits. This action cannot be undone.',
  'visitCampaigns.detail.addContacts': 'Add Contacts',
  'visitCampaigns.detail.distribute': 'Distribute',
  'visitCampaigns.detail.route': 'Route',
  'visitCampaigns.detail.autoDistributedNote': 'Visits were auto-distributed among assigned users when contacts were attached.',
  'visitCampaigns.detail.visitsSection': 'Visits',
  'visitCampaigns.detail.kpiVisitsCreated': 'Visits created',
  'visitCampaigns.detail.kpiEstimatedTime': 'Est. field time',
  'visitCampaigns.detail.kpiHours': '~{{hours}}h',
  'visitCampaigns.detail.kpiDaysValue': '~{{days}} days',
  'visitCampaigns.detail.kpiDailyTarget': '{{target}}/day target',

  'visitCampaigns.distribute.title': 'Distribute Visits',
  'visitCampaigns.distribute.autoSection': 'Auto-Distribute',
  'visitCampaigns.distribute.usingDepartment': 'Using department: {{name}}',
  'visitCampaigns.distribute.autoDistributeButton': 'Auto-distribute evenly',
  'visitCampaigns.distribute.autoDistributed': '{{count}} visits distributed',
  'visitCampaigns.distribute.unassignedSection': 'Unassigned ({{count}})',
  'visitCampaigns.distribute.noUnassigned': 'No unassigned visits',
  'visitCampaigns.distribute.assign': 'Assign',
  'visitCampaigns.distribute.reassign': 'Reassign',

  'permissions.visits.view.label': 'View Visits',
  'permissions.visits.view.description': 'See assigned visits. Manager tier also sees department visits; Admin sees all.',
  'permissions.visits.execute.label': 'Execute Visits',
  'permissions.visits.execute.description': 'Start, end, and log outcomes for visits assigned to you.',
  'permissions.visits.manageVisits.label': 'Manage Visits',
  'permissions.visits.manageVisits.description': 'Create and edit individual visits. Admin tier can also delete.',
  'permissions.visits.manageCampaigns.label': 'Manage Campaigns',
  'permissions.visits.manageCampaigns.description': 'Create and edit visit campaigns and their contact pools. Admin tier can also delete.',
  'permissions.visits.distribute.label': 'Distribute Visits',
  'permissions.visits.distribute.description': 'Assign or rebalance department visit pools across team members.',
  'permissions.visits.manageConfig.label': 'Manage Visits Configuration',
  'permissions.visits.manageConfig.description': 'Enable/disable the Visits service and configure defaults, enforcement, and outcomes.',
  'permissions.visits.overrideGeofence.label': 'Override Geofence',
  'permissions.visits.overrideGeofence.description': 'Start a visit outside the allowed location radius, with a stated reason.',
  'permissions.visits.viewPhotos.label': 'View Visit Photos',
  'permissions.visits.viewPhotos.description': 'See photos captured during visit start/end.',
  'permissions.task.viewHistory.label': 'Task History',
  'permissions.task.viewHistory.description': 'View and resend task runs (e.g. bulk WhatsApp sends). View tier sees own tasks only, Manager tier also sees managed team tasks, Admin sees every task in the business.',

  // ─── Product Selector Modal ─────────────────────────────────────────────────
  'productSelector.title': 'Select Products',
  'productSelector.selectedCount': '{{count}} selected',
  'productSelector.searchPlaceholder': 'Search products...',
  'productSelector.createNewProduct': 'Create New Product',
  'productSelector.productNamePlaceholder': 'Product name',
  'productSelector.pricePlaceholder': 'Price',
  'productSelector.creating': 'Creating...',
  'productSelector.createAndSelect': 'Create & Select',
  'productSelector.loadingProducts': 'Loading products...',
  'productSelector.noProductsFound': 'No products found',
  'productSelector.tryDifferentSearch': 'Try a different search term',
  'productSelector.createProductsFirst': 'Create products first',
  'productSelector.addSelected': 'Add Selected',

  // ─── Quotations: List ────────────────────────────────────────────────────────
  'quotations.list.title': 'Quotations',
  'quotations.list.templates': 'Templates',
  'quotations.list.newQuotation': 'New Quotation',
  'quotations.list.searchPlaceholder': 'Search quotations...',
  'quotations.list.countSingular': '{{count}} quotation',
  'quotations.list.countPlural': '{{count}} quotations',
  'quotations.list.empty': 'No quotations yet',
  'quotations.list.emptyHint': 'Tap + to create your first quotation',
  'quotations.list.loadError': 'Failed to load quotations',
  'quotations.list.all': 'All',
  'quotations.list.view': 'View',
  'quotations.list.validUntil': 'Valid until {{date}}',
  'quotations.list.numberCopied': 'Quotation number copied',
  'quotations.list.emptyFiltered': 'No quotations with this status',
  'quotations.filters.title': 'Sort & Filter',
  'quotations.filters.validUntil': 'Valid until',
  'quotations.filters.createdBy': 'Created by',
  'quotations.filters.currency': 'Currency',
  'quotations.filters.remove': 'Remove filter',
  'quotations.filters.reset': 'Reset',
  'quotations.filters.clear': 'Clear filters',
  'quotations.filters.apply': 'Apply',
  'quotations.filters.applyWithCount': 'Apply ({{count}})',
  'quotations.filters.activeCount': '{{count}} filter(s) on',
  'quotations.filters.sort': 'Sort by',
  'quotations.filters.sort.newest': 'Newest',
  'quotations.filters.sort.oldest': 'Oldest',
  'quotations.filters.sort.totalDesc': 'Highest total',
  'quotations.filters.sort.totalAsc': 'Lowest total',
  'quotations.filters.sort.expiringSoon': 'Expiring soonest',
  'quotations.filters.status': 'Status',
  'quotations.filters.statusHint': 'Pick one or more.',
  'quotations.filters.created': 'Created',
  'quotations.filters.anyDate': 'Any date',
  'quotations.filters.validity': 'Validity',
  'quotations.filters.validity.valid': 'Still valid',
  'quotations.filters.validity.expired': 'Expired',
  'quotations.filters.validity.none': 'No expiry date',
  'quotations.filters.total': 'Total amount',
  'quotations.filters.min': 'Min',
  'quotations.filters.max': 'Max',

  // ─── Quotations: Form ────────────────────────────────────────────────────────
  'quotations.form.editTitle': 'Edit Quotation',
  'quotations.form.newTitle': 'New Quotation',
  'quotations.form.customer': 'Customer',
  'quotations.form.email': 'Email',
  'quotations.form.emailPlaceholder': 'customer@example.com',
  'quotations.form.address': 'Address',
  'quotations.form.addressPlaceholder': 'Delivery/billing address',
  'quotations.form.location': 'Location',
  'quotations.form.locationHint': '(optional — pin on map)',
  'quotations.form.selectLocation': 'Select location',
  'quotations.form.items': 'Items',
  'quotations.form.addProduct': 'Add Product',
  'quotations.form.addCustomLine': 'Add Custom Line',
  'quotations.form.lineDescriptionPlaceholder': 'Line description',
  'quotations.form.pricePlaceholder': 'Price',
  'quotations.form.qtyPlaceholder': 'Qty',
  'quotations.form.addLine': 'Add Line',
  'quotations.form.noItemsYet': 'No items yet — add a product or a custom line',
  'quotations.form.qty': 'Qty',
  'quotations.form.unitPrice': 'Unit Price',
  'quotations.form.total': 'Total',
  'quotations.form.charges': 'Charges',
  'quotations.form.tax': 'Tax',
  'quotations.form.shipping': 'Shipping',
  'quotations.form.discount': 'Discount',
  'quotations.form.currencyFailed': 'Could not convert to that currency. Try again.',
  'quotations.form.currency': 'Currency',
  'quotations.form.subtotal': 'Subtotal',
  'quotations.form.notesPlaceholder': 'Add a note about this quotation...',
  'quotations.form.missingInfoTitle': 'Missing Info',
  'quotations.form.missingInfoMessage': 'Customer name and phone are required',
  'quotations.form.noItemsTitle': 'No Items',
  'quotations.form.noItemsMessage': 'Add at least one item',
  'quotations.form.savedTitle': 'Saved',
  'quotations.form.updatedMessage': 'Quotation updated successfully',
  'quotations.form.createdMessage': 'Quotation created successfully',
  'quotations.form.saveError': 'Failed to save quotation',
  'quotations.form.addProducts': 'Add Products',
  'quotations.form.shippingMethod': 'Shipping Method',
  'quotations.form.selectShippingMethod': 'Select shipping method',
  'quotations.form.selectShippingMethodTitle': 'Select Shipping Method',
  'quotations.form.noShippingMethods': 'No shipping methods configured',
  'quotations.form.free': 'Free',
  'quotations.form.zoneLabel': 'Zone: {{zone}}',
  'quotations.form.otherAreaFallback': 'Other area (fallback rate)',
  'quotations.form.otherArea': 'Other area',
  'quotations.form.freeShippingHint': 'Add {{amount}} more to qualify for free delivery',
  'quotations.form.express': 'Express',
  'quotations.form.couponCodePlaceholder': 'Coupon code',
  'quotations.form.apply': 'Apply',
  'quotations.form.couponAppliedTitle': 'Coupon Applied',
  'quotations.form.couponAppliedMessage': 'Saved {{amount}}',
  'quotations.form.invalidCouponTitle': 'Invalid Coupon',
  'quotations.form.invalidCouponMessage': 'Coupon is not valid',
  'quotations.form.businessNotFound': 'Business not found',
  'quotations.form.shippingZoneUnavailableTitle': 'Zone Not Available',
  'quotations.form.shippingZoneUnavailableMessage': "The selected location is outside this shipping method's zones.",
  'quotations.form.manualDiscount': 'Discount',

  // ─── Quotations: Detail ──────────────────────────────────────────────────────
  'quotations.detail.title': 'Quotation',
  'quotations.detail.edit': 'Edit',
  'quotations.detail.delete': 'Delete',
  'quotations.detail.viewConvertedOrder': 'View converted order →',
  'quotations.detail.customer': 'Customer',
  'quotations.detail.items': 'Items',
  'quotations.detail.subtotal': 'Subtotal',
  'quotations.detail.tax': 'Tax',
  'quotations.detail.shipping': 'Shipping',
  'quotations.detail.discount': 'Discount',
  'quotations.detail.total': 'Total',
  'quotations.detail.notes': 'Notes',
  'quotations.detail.viewPdf': 'View PDF',
  'quotations.detail.generatePdf': 'Generate PDF',
  'quotations.detail.regeneratePdf': 'Regenerate PDF',
  'quotations.detail.convertToOrder': 'Convert to Order',
  'quotations.detail.deleteTitle': 'Delete Quotation',
  'quotations.detail.deleteMessage': "Are you sure you want to delete this quotation? This can't be undone.",
  'quotations.detail.deletedMessage': 'Quotation deleted',
  'quotations.detail.deleteError': 'Failed to delete quotation',
  'quotations.detail.notFound': 'Quotation not found',
  'quotations.detail.loadError': 'Failed to load quotation',
  'quotations.detail.pdfError': 'Failed to generate PDF',
  'quotations.detail.convertedTitle': 'Converted',
  'quotations.detail.convertedMessage': 'Order {{orderNumber}} created successfully',
  'quotations.detail.convertError': 'Failed to convert quotation',

  // ─── Quotations: Templates ───────────────────────────────────────────────────
  'quotations.templates.title': 'Templates',
  'quotations.templates.headerTitle': 'Quotation & Invoice Templates',
  'quotations.templates.noCustomTemplates': 'No custom templates yet',
  'quotations.templates.noCustomTemplatesHint': 'Quotations use a built-in default template until you create one',
  'quotations.templates.newTemplate': 'New Template',
  'quotations.templates.empty': 'No templates yet',
  'quotations.templates.emptyHint': 'Tap + to create your first template',
  'quotations.templates.default': 'Default',
  'quotations.templates.loadError': 'Failed to load templates',
  'quotations.templates.deleteTitle': 'Delete Template',
  'quotations.templates.deleteMessage': "Are you sure you want to delete this template? This can't be undone.",
  'quotations.templates.deletedMessage': 'Template deleted',
  'quotations.templates.deleteError': 'Failed to delete template',

  // ─── Quotations: Template Editor ─────────────────────────────────────────────
  'quotations.templateEditor.editTitle': 'Edit Template',
  'quotations.templateEditor.newTitle': 'New Template',
  'quotations.templateEditor.nameLabel': 'Template Name *',
  'quotations.templateEditor.namePlaceholder': 'e.g. Standard Quotation',
  'quotations.templateEditor.type': 'Type',
  'quotations.templateEditor.typeQuotation': 'Quotation',
  'quotations.templateEditor.typeInvoice': 'Invoice',
  'quotations.templateEditor.logoUrl': 'Logo URL',
  'quotations.templateEditor.primaryColor': 'Primary Color',
  'quotations.templateEditor.secondaryColor': 'Secondary Color',
  'quotations.templateEditor.useAsDefault': 'Use as default {{type}} template',
  'quotations.templateEditor.htmlContent': 'HTML Content',
  'quotations.templateEditor.missingNameTitle': 'Missing Name',
  'quotations.templateEditor.missingNameMessage': 'Template name is required',
  'quotations.templateEditor.savedTitle': 'Saved',
  'quotations.templateEditor.updatedMessage': 'Template updated successfully',
  'quotations.templateEditor.createdMessage': 'Template created successfully',
  'quotations.templateEditor.saveError': 'Failed to save template',
  'quotations.templateEditor.loadError': 'Failed to load template',
  'quotations.templateEditor.preview': 'Preview',
  'quotations.templateEditor.previewTitle': 'Template Preview',
  'quotations.templateEditor.previewError': 'Failed to generate preview',
  'quotations.templateEditor.settings': 'Template Settings',
  'quotations.templateEditor.canvasView': 'Canvas',
  'quotations.templateEditor.codeView': 'Code',
  'quotations.templateEditor.notDefaultHint': "Not the default — quotations won't use this template until it's set as default.",
} as const;

export type TranslationKey = keyof typeof enStrings;
